// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Custom variables followed by theme variables followed by Bootstrap variables
 * to ensure cascade of styles.
 **/

html {
  min-height: 100%;
  position: relative;
}
body {
  margin: 0;
  margin-bottom: 100px;
}

*, *::before, *::after {
  box-sizing: border-box;
}
footer {
  margin-top: 20px;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 40px;
  color:#2B354F;
}

.ocultar-movil {
  @media (max-width: 572px) {
    display: none;
  }
}


#wrapper {
  display:flex
}
#wrapper #content-wrapper {
  background-color:#f8f9fc;
  width:100%;
  overflow-x:hidden
}
#wrapper #content-wrapper #content{
  flex:1 0 auto
}

@media only screen and (max-width: 1200px) {
  
	/* Force table to not be like tables anymore */
	#no-more-tables table, 
	#no-more-tables thead, 
	#no-more-tables tbody, 
	#no-more-tables th, 
	#no-more-tables td, 
	#no-more-tables tr { 
		display: block; 
	}

  /* Force table to not be like tables anymore */
	#no-more-tables-users table, 
	#no-more-tables-users thead, 
	#no-more-tables-users tbody, 
	#no-more-tables-users th, 
	#no-more-tables-users td, 
	#no-more-tables-users tr { 
		display: block; 
	}

    /* Force table to not be like tables anymore */
	#no-more-tables-borrar table, 
	#no-more-tables-borrar thead, 
	#no-more-tables-borrar tbody, 
	#no-more-tables-borrar th, 
	#no-more-tables-borrar td, 
	#no-more-tables-borrar tr { 
		display: block; 
	}


 
	/* Hide table headers (but not display: none;, for accessibility) */
	#no-more-tables thead th { 
    position: absolute;
		top: -9999px;
		left: -9999px;
	}
  /* Hide table headers (but not display: none;, for accessibility) */
	#no-more-tables-users thead th { 
    position: absolute;
		top: -9999px;
		left: -9999px;
	}
    /* Hide table headers (but not display: none;, for accessibility) */
	#no-more-tables-borrar thead th { 
    position: absolute;
		top: -9999px;
		left: -9999px;
	}
 
	#no-more-tables tr { border: 1px solid #ccc; }
  #no-more-tables-users tr { border: 1px solid #ccc; }
  #no-more-tables-borrar tr { border: 1px solid #ccc; }
 
  #no-more-tables td { 
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee; 
    position: relative;
    padding-left: 50%; 
    white-space: normal;
    text-align:left;
  }
  #no-more-tables-users td { 
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee; 
    position: relative;
    padding-left: 50%; 
    white-space: normal;
    text-align:left;
  }
  #no-more-tables-borrar td { 
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee; 
    position: relative;
    padding-left: 50%; 
    white-space: normal;
    text-align:left;
  }
  
  #no-more-tables td:before { 
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%; 
    padding-right: 10px; 
    white-space: nowrap;
    text-align:left;
    font-weight: bold;
  }
  #no-more-tables-users td:before { 
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%; 
    padding-right: 10px; 
    white-space: nowrap;
    text-align:left;
    font-weight: bold;
  }
  #no-more-tables-borrar td:before { 
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%; 
    padding-right: 10px; 
    white-space: nowrap;
    text-align:left;
    font-weight: bold;
  }
  
  /*
  Generamos cabeceras cuando activamos la tabla vertical para dispositivos móviles
  */

  #no-more-tables-users td:nth-of-type(1):before { content: "Guardar"; padding-top: 0.40rem; }
  #no-more-tables-users td:nth-of-type(2):before { content: "Email"; padding-top: 0.40rem; }
  #no-more-tables-users td:nth-of-type(3):before { content: "Edición"; padding-top: 0.40rem; }
  #no-more-tables-users td:nth-of-type(4):before { content: "Administración"; padding-top: 0.40rem; }

  #no-more-tables-borrar td:nth-of-type(1):before { content: "Borrar"; padding-top: 0.40rem; }
  #no-more-tables-borrar td:nth-of-type(2):before { content: "Email"; padding-top: 0.40rem; }
  #no-more-tables-borrar td:nth-of-type(3):before { content: "Edición"; padding-top: 0.40rem; }
  #no-more-tables-borrar td:nth-of-type(4):before { content: "Administración"; padding-top: 0.40rem; }

  #no-more-tables td:nth-of-type(1):before { content: "ID incidencia"; padding-top: 0.40rem; }
  #no-more-tables td:nth-of-type(2):before { content: "Dominio"; padding-top: 0.40rem; }
  #no-more-tables td:nth-of-type(3):before { content: "Severidad"; padding-top: 0.40rem; }
  #no-more-tables td:nth-of-type(4):before { content: "Descripción"; padding-top: 0.40rem;}
  #no-more-tables td:nth-of-type(5):before { content: "Estado"; padding-top: 0.40rem;}
  #no-more-tables td:nth-of-type(6):before { content: "Servicios Afectados"; padding-top: 0.40rem;}
  #no-more-tables td:nth-of-type(7):before { content: "Clientes Afectados"; padding-top: 0.40rem;}
  #no-more-tables td:nth-of-type(8):before { content: "Red/Infr. afectada"; padding-top: 0.40rem;}
  #no-more-tables td:nth-of-type(9):before { content: "Duración"; padding-top: 0.40rem;}
  #no-more-tables td:nth-of-type(10):before { content: "Actualizado"; padding-top: 0.40rem;}
  #no-more-tables td:nth-of-type(11):before { content: "Última actualización"; padding-top: 0.40rem;}

}

.bg-somosierra {
  background-color: #FF7900 ;
  background-image: linear-gradient(180deg,#FF7900  10%,rgb(173, 103, 56));
  background-size: cover;
}

.icon-hover-grow {
  transition: transform 0.3s ease; /* Smooth transition for the transform property */
}

.icon-hover-grow:hover {
  transform: scale(1.5); /* Increase the size of the icon by 50% when hovered */
}

.listaDashboard .nav-item:hover {
  transform: none;
}

/* Brand wordmark is a static title — no link hover, underline, or scale. */
.sidebar .sidebar-brand.sidebar-brand-title,
.sidebar .sidebar-brand.sidebar-brand-title:hover,
.sidebar .sidebar-brand.sidebar-brand-title:focus {
  cursor: default;
  text-decoration: none !important;
  transform: none;
  color: inherit;
}

.sidebar .sidebar-brand.sidebar-brand-title .sidebar-brand-text,
.sidebar .sidebar-brand.sidebar-brand-title .sidebar-brand-text:hover {
  transform: none;
  text-decoration: none !important;
}

.auto-width-fecha {
  min-width: 200px;
  width: auto;
}

.auto-width-duracion {
  min-width: 150px;
  width: auto;
}

.auto-width-severity {
  min-width: 120px;
  width: auto;
}

.auto-width-ticket {
  min-width: 150px;
  width: auto;
}

.auto-height {
  min-height: 150px;
  height: auto;
}

.masmovil-button {
  background-color: #FF7900;
  background-size: cover;
}

.chart-container {
  overflow: hidden;
}

.borde-seleccion {
  border-bottom: 1px solid rgb(192, 190, 190);
}

.columna_todo_espacio {
  height: 75vh;
}

.contenedor-interno-con-borde {
  border: 1px solid rgb(192, 190, 190);
  padding: 20px;
  height: 75vh;
  border-radius: 1%;
  overflow-y: auto;
}

.centro-chart-donut {
  position: absolute !important; 
  top: 50% !important; 
  left: 50% !important; 
  transform: translate(-50%, -50%) !important; 
  text-align: center !important; 
  color: #000 !important;
}

.avatar-miperfil {
  vertical-align: middle;
  width: 50% !important;
  height: 50% !important;
  border-radius: 50%;
}

.sidebar-footer {
  margin-top: auto;
  width: 100%;
  flex-shrink: 0;
}

/* Keep sidebar chrome (footer) in the viewport even when main content is tall. */
.sidebar.navbar {
  align-self: flex-start;
  position: sticky;
  top: 0;
  height: 100vh;
  max-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.caja-valor {
  display: flex;
  flex-direction: column; 
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding:12px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid;
  border-color: #cfd6d7;
}

.caja-1 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 0rem;
    margin-right: 1.5vw;
    margin-bottom: 1rem;
    flex: 1 0 40%;
    
  }
  @media (min-width: 1280px) {
    margin-left: 0rem;
    margin-right: 1vw;
    flex: 1 0 20%;
    
  }  
}
.caja-2 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 1.5vw;
    margin-right: 0vw;
    margin-bottom: 1rem;
    flex: 1 0 40%;
   
  }
  @media (min-width: 1280px) {
    margin-left: 1vw;;
    margin-right: 1vw;;
    flex: 1 0 20%;
   
  }  
}

.caja-3 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 0vw;
    margin-right: 1.5vw;
    flex: 1 0 40%;
  }
  @media (min-width: 1280px) {
    margin-top: 0rem;
    margin-left: 1vw;
    margin-right: 1vw;
    flex: 1 0 20%;
    
  }  
}

.caja-4 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 1.5vw;
    margin-right: 0vw;
    flex: 1 0 40%;
   
  }
  @media (min-width: 1280px) {
    margin-top: 0rem;
    margin-right: 0px;
    margin-left: 1vw;
    flex: 1 0 20%;
   
  }  
}

.caja-detalle {
  display: flex;
  flex-direction: column; 
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding:12px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid;
  border-color: #cfd6d7;
}
.caja-detalle-1 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 0vw;
    margin-right: 1.5vw;
    margin-bottom: 1vw;
    flex: 1 0 40%;
    
  }
  @media (min-width: 1280px) {
    margin-left: 0rem;
    margin-right: 1vw;
    flex: 1 0 10%;
    
  }  
}
.caja-detalle-2 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 1.5vw;
    margin-right: 0vw;
    margin-bottom: 1vw;
    flex: 1 0 40%;
   
  }
  @media (min-width: 1280px) {
    margin-left: 1vw;;
    margin-right: 1vw;;
    flex: 1 0 10%;
   
  }  
}
.caja-detalle-3 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 0vw;
    margin-right: 1.5vw;
    margin-bottom: 1vw;
    flex: 1 0 40%;
  }
  @media (min-width: 1280px) {
    margin-top: 0rem;
    margin-left: 1vw;
    margin-right: 1vw;
    flex: 1 0 10%;
  }  
}
.caja-detalle-4 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 1.5vw;
    margin-right: 0vw;
    margin-bottom: 1vw;
    flex: 1 0 40%;
  }
  @media (min-width: 1280px) {
    margin-top: 0rem;
    margin-right: 1vw;
    margin-left: 1vw;
    flex: 1 0 10%;
  }  
}
.caja-detalle-5 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 0vw;
    margin-right: 1.5vw;
    margin-bottom: 1vw;
    flex: 1 0 40%;
  }
  @media (min-width: 1280px) {
    margin-top: 0rem;
    margin-right: 1vw;
    margin-left: 1vw;
    flex: 1 0 10%;
   
  }  
}
.caja-detalle-6 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 1.5vw;
    margin-right: 0vw;
    margin-bottom: 1vw;
    flex: 1 0 40%;
   
  }
  @media (min-width: 1280px) {
    margin-top: 0rem;
    margin-right: 1vw;
    margin-left: 1vw;
    flex: 1 0 10%;
   
  }  
}
.caja-detalle-7 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 0vw;
    margin-right: 1.5vw;
    flex: 1 0 40%;
   
  }
  @media (min-width: 1280px) {
    margin-top: 0rem;
    margin-right: 1vw;
    margin-left: 1vw;
    flex: 1 0 10%;
   
  }  
}
.caja-detalle-8 {
  @media (min-width: 375px) and (max-width: 1279px) {
    margin-left: 1.5vw;
    margin-right: 0vw;
    flex: 1 0 40%;
   
  }
  @media (min-width: 1280px) {
    margin-top: 0rem;
    margin-right: 0vw;
    margin-left: 1vw;
    flex: 1 0 10%;
   
  }  
}



.altura-chart {
  @media (max-width: 1280px) {
    height:250px;
  }  
}

/* Formato de la card que da todos los datos de las entidades */
.card-datos-entidad {
  border: 0.5px solid #2B3550;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
}

.card-resultado {
  border: 0.5px solid #2B3550;
  margin-right: 1px;
  margin-left: 1px;
  /*background-color: #F1F4F8;*/
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
}


.card-blue-entidades {
    border: 0.5px solid #2B3550;
    background-color: #2B354F;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
}

.card-blue-exterior {
  border: 0.5px solid #2B354F;
  background-color: rgb(219, 224, 238);
  border-radius: 20px 20px 20px 20px;
  -moz-border-radius: 20px 20px 20px 20px;
  -webkit-border-radius: 20px 20px 20px 20px;
}

/* Amplio el ancho del footer ya que no consigo que se extienda el ancho de la pantalla */
.container-footer {
  margin-left: -20px !important;
  margin-right: -20px !important;
  width: 101% !important;
}

/* Contenedor de cartas para consulta general de todas
las tipologias, todos los sevicios */
.containerL {
  border: 0.5px solid #2B3550;
  border-radius: 20px 20px 20px 20px;
  -moz-border-radius: 20px 20px 20px 20px;
  -webkit-border-radius: 20px 20px 20px 20px;
  background-color: white;
  display: flex;
}

.colL {
  margin: 10px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.item-containerL {
  padding: 0px;
  margin: 1px;
}

.cursor-pointer {
  cursor: pointer;
}

#sidebarToggle {width:2.5rem;
                height:2.5rem;
                text-align:center;
                margin-bottom:1rem;
                cursor:pointer;
                transform: none !important;
                transition: background-color 0.15s ease;
                padding: 0;
              }.sidebar 
#sidebarToggle:after {font-weight:900;
                      content:"\\f104";
                      color: white !important;
                      font-family:Font Awesome\\ 5 Free;
                      margin-right:.1rem;
                      transform: none !important;
                    }.sidebar 
#sidebarToggle:hover,
#sidebarToggle:focus,
#sidebarToggle:active {
  text-decoration: none;
  outline: none;
  transform: none !important;
  box-shadow: none;
  background-color: hsla(0, 0%, 100%, 0.2);
}
.sidebar-dark #sidebarToggle:hover,
.sidebar-dark #sidebarToggle:focus,
.sidebar-dark #sidebarToggle:active {
  background-color: hsla(0, 0%, 100%, 0.2);
}
/* Zero width only below desktop mid: desktop toggled stays SB Admin icons (~6.5rem). */
@media (max-width: 767.98px) {
  /* Out of flow so opening the drawer does not shrink main content. */
  .sidebar.navbar {
    position: fixed !important;
    left: 0;
    top: 0;
    z-index: 1040;
  }
  .sidebar.toggled{width:0!important;overflow:hidden}
  /* Open mobile drawer matches expanded desktop width (icons + labels). */
  .sidebar:not(.toggled){width:14rem!important}
}

.sidebar .listaDashboard .nav-item .nav-link {
  box-sizing: border-box;
  width: 100% !important;
  max-width: 100%;
  overflow: hidden;
}

/* Expanded / open-drawer rows: icon column + wrapping label, highlight stays in-strip. */
.sidebar:not(.toggled) .listaDashboard .nav-item .nav-link {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  text-align: left;
  padding: 0.65rem 0.75rem;
}

.sidebar:not(.toggled) .listaDashboard .nav-item .nav-link > i {
  flex: 0 0 1.25rem;
  width: 1.25rem;
  margin-right: 0.5rem;
  padding-right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar:not(.toggled) .listaDashboard .nav-item .nav-link > span {
  flex: 1 1 auto;
  min-width: 0;
  display: block;
  padding-left: 0;
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.25;
}

/* Icons mode: no brand/divider chrome — first icon sits at the top of the strip. */
.sidebar.sidebar-mode-icons .sidebar-divider {
  display: none !important;
}

.sidebar.sidebar-mode-icons > .d-flex.flex-column {
  padding-top: 0.25rem !important;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  flex-direction: column !important;
}

.sidebar.sidebar-mode-icons .sidebar-brand {
  display: none !important;
  height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden;
}

.sidebar.sidebar-mode-icons .listaDashboard {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
}

.sidebar.sidebar-mode-icons .listaDashboard .nav-item {
  width: 100%;
  max-width: 100%;
}

.sidebar.sidebar-mode-icons .listaDashboard .nav-item .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100% !important;
  max-width: 100%;
  padding: 0.75rem 0.25rem;
  text-align: center;
}

.sidebar.sidebar-mode-icons .listaDashboard .nav-item .nav-link > span {
  display: none;
}

.sidebar.sidebar-mode-icons .listaDashboard .nav-item .nav-link > i {
  margin-right: 0;
  padding-right: 0;
}

.sidebar.sidebar-mode-icons .sidebar-footer {
  font-size: 0.75rem;
  line-height: 1.2;
  padding-left: 0.15rem;
  padding-right: 0.15rem;
  overflow: hidden;
}

.sidebar.sidebar-mode-icons .sidebar-collapse-control {
  width: 100%;
  overflow: hidden;
}

.sidebar.sidebar-mode-icons #sidebarToggle {
  width: 2rem;
  height: 2rem;
  margin-bottom: 0.75rem;
  transform: none !important;
}
.sidebar.toggled 
#sidebarToggle:after{content:"\\f105";
                     font-family:Font Awesome\\ 5 Free;
                     margin-left:0}

#sidebarToggle{background-color:#eaecf4}.sidebar-light 
#sidebarToggle:after{color:#b7b9cc}.sidebar-light 
#sidebarToggle:hover{background-color:hsla(0, 0%, 100%, 0.2)}

/* Margen en el paso 4 para que se vea espaciado en móviles*/
#Paso4 {
  @media (max-width: 768px)
   { 
    margin-top: 1.5rem;
   }

}

/* Añado el after porque la transición que general el lift cambia
de color el texto de blanco a negro y quiero evitarla, pongo el after
con el text a blanco y añado el important, sin el important no funciona */
.btn-card-entidades {
    color: #fff !important;
    background-color: #2B354F;
} ::after {
    color: #fff !important;
}

element.style {
}


.card-header {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
  padding: 1.25rem 1.25rem;
  border-bottom: none;
  background-color: rgba(33,18,27,0);

}

.card-header:after {
  /* Para pintar el borde inferior del header como una línea */
  content : "";
  max-width:1280px;
  height  : 15px;
  width   : 100%; 
  border-bottom: 1px solid #2B3550;
  margin:0 auto;
  padding: 1px 0px
}


.card-title {
    margin-bottom: 0.75rem;
}
p {
    margin-top: 0;
    margin-bottom: 1rem;
}

.pais-cartera {
  position: absolute;
  padding-top: 4px;
  padding-left: 15px;
  font-size: 25px;
}

.fuentes-cabecera-card {
  font-size: 20px;
}

.pt-detalles {
  padding-top: 1.2rem;
}

/* user agent stylesheet */
p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
}
.font-weight-bold {
    font-weight: 700 !important;
}
.text-center {
    text-align: center !important;
}
body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
}
html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
*, *::before, *::after {
    box-sizing: border-box;
}

/* Usada en la barra de desplegables del buscador de entidades */
.local-grid-barra-desplegables { 
  @media (min-width: 992px) {
      flex: 0 0 22%;
      max-width: 22%;
    }
}
/* Selectores de clase y de Id para ajustar la barra principal  de busqueda
a 4 desplegables y un botón de */
#local-boton-busqueda-principal {
  display:block;
  width:100%; 
}
.local-grid-boton-busqueda { 
  @media (min-width: 992px) {
      flex: 0 0 12%;
      max-width: 12%;
    }
}


/* Cambio de ancho por defecto del cuadro que se muestra al darle a la flecha
de la clase deowdown-menu */
.dropdown-menu.show {
  min-width: 20rem;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

/* Usada en el texto de política de privacidad para separar la línea del blockquote del párrafo */
.blockquote-politica-privacidad {
  border-left: 2px solid #4E66F8;
  padding-left: 3rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.power-off-personalized-color{
  color: black !important;
 }::after {
  color: black !important;
}::after {
  color: black !important;
}
.card-border-rounded {
  border: 0.5px solid rgba(50,156,156, 1.05);
  border-radius: 20px 20px 20px 20px;
  -moz-border-radius: 20px 20px 20px 20px;
  -webkit-border-radius: 20px 20px 20px 20px;
}

.button-border-rounded {
  border: 0.5px solid rgba(50,156,156, 1.05);
  border-radius: 7px 7px 7px 7px;
  -moz-border-radius: 7px 7px 7px 7px;
  -webkit-border-radius: 7px 7px 7px 7px;
}



.card-footer {
  border-top: none;
  background-color: rgba(33,18,27,0);
}

.align-star-rating {
  display: inline-flex !important;
}
.card-footer-short {
  padding: 20px 10px 20px 10px !important;
}

.btn-align {
  padding: 1px 1px;
  margin-bottom: 7px;
  line-height: 1.12857143;
  vertical-align: middle;
}

.hero {
  position: relative;
  text-align: center;
  background: #f8f9fa;
  box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.075);
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

img.bg-image {
  font-family: 'object-fit: cover;';
  -o-object-fit: cover;
  object-fit: cover;
}

.dark-overlay,
.gradient-overlay {
  position: relative;
  overflow: hidden;
}

.img-thumbnail {
  margin-top: 5px
}

.img-adjust {
  width: 90% !important;
  height: 75% !important;
  margin-left: 10px !important;
  margin-right: 0px !important;
  border-radius: 25px 25px 25px 25px;
  -moz-border-radius: 25px 25px 25px 25px;
  -webkit-border-radius: 25px 25px 25px 25px;
  display: inline-block !important;
}

.modal-backdrop {
  opacity:0.3 !important;
}

.lift {
  transition: box-shadow .25s ease, transform .25s ease; 
}

.lift:hover,
.lift:focus {
  box-shadow: 0 1rem 2.5rem rgba(22, 28, 45, 0.1), 0 0.5rem 1rem -0.75rem rgba(22, 28, 45, 0.1) !important;
  transform: translate3d(0, -3px, 0); 
}

.lift-lg:hover,
.lift-lg:focus {
  box-shadow: 0 2rem 5rem rgba(22, 28, 45, 0.1), 0 0.5rem 1rem -0.75rem rgba(22, 28, 45, 0.05) !important;
  transform: translate3d(0, -5px, 0);
}

.inline-block {
  display: inline
}

.lead {
  font-size: 1.3125rem;
  font-weight: 400; }

input[type=text]::-ms-clear {
  display: none; /* We disable delete icon,  https://developer.mozilla.org/es/docs/Web/CSS/::-ms-clear */
}

.card-img-top {
  width: 100%;
  border-top-left-radius: calc(0.375rem - 0px);
  border-top-right-radius: calc(0.375rem - 0px); 
}

.display-2 {
  font-size: 3.8125rem;
  font-weight: 400;
  line-height: 1; }

.bg-cover {
  background: no-repeat center center / cover; }

.bg-dark {
  background-color: #2B354F !important; }

/*.bg-image {
  background-image: url('/imgs/cover-5.jpg');
}*/
.bg-gradient-light {
  background-image: linear-gradient(to bottom, #F9FBFD 0%, #FFFFFF 100%); }

.bg-gray-200 {
  background-color: #F1F4F8 !important; }

.bg-gray-300 {
  background-color: #D9E2EF !important; }

.bg-gray-800 {
  background-color: #384C74 !important; }

.bg-black {
  background-color: #161C2D !important; }

.alert-box {
  position: absolute;
  top: -50px; /* Comienza fuera de la pantalla, en la parte superior */
  left: 200px;
  font-size: 0.7rem;
  background-color: rgb(209, 102, 102) !important;
  z-index: 1000; /* Asegura que esté por encima de otros elementos */
  font-size: 20px; /* Ajusta el tamaño del texto para pantallas más pequeñas */
  opacity: 0; /* Comienza invisible */
  color: white;
  transition: top 0.5s ease, opacity 0.5s ease;
  font-weight: bold;
}

.alert-box.alert-box-active {
    top: 10px;
    opacity: 1; /* Se vuelve visible */
}


.shadow-light {
  box-shadow: 0 0.5rem 1.5rem rgba(22, 28, 45, 0.05) !important; 
}

.shadow-light-lg {
  box-shadow: 0 1.5rem 4rem rgba(22, 28, 45, 0.05) !important; 
}

.shadow-dark {
  box-shadow: 0 0.5rem 1.5rem rgba(22, 28, 45, 0.15) !important; 
}

.shadow-dark-lg {
  box-shadow: 0 1.5rem 4rem rgba(22, 28, 45, 0.15) !important; 
}

.shadow-lift {
  box-shadow: 0 1rem 2.5rem rgba(22, 28, 45, 0.1), 0 0.5rem 1rem -0.75rem rgba(22, 28, 45, 0.1) !important; 
}

.position-relative {
  position: relative !important; }
/* Personalized styles for some Ids */

#cardTecnicosDisponibles {
  padding-top: 10px;
}

.device {
  position: relative; }
  .device > .img-fluid {
    position: relative; }

.device::before {
  content: "";
  background-color: #F9FBFD; }

.device::before,
.device-screen {
  position: absolute;
  -o-object-fit: cover;
     object-fit: cover; }

.device-iphonex::before,
.device-iphonex > .device-screen {
  top: 7.784431138%;
  left: 16.4021164%;
  width: 66.137566137%;
  height: 80.838323353%; }

.device-macbook::before,
.device-macbook > .device-screen {
  top: 11.53846154%;
  left: 13.38709677%;
  width: 73.548387096%;
  height: 73.076923076%; }

.device-combo {
  position: relative; }

.device-combo > .device {
  position: absolute; }

.device-combo-iphonex-iphonex {
  padding-bottom: 130.250482%; }

.device-combo-iphonex-iphonex > .device-iphonex:first-child {
  bottom: 0;
  left: 0;
  width: 65.5260116%;
  z-index: 1; }

.device-combo-iphonex-iphonex > .device-iphonex:last-child {
  top: 0;
  right: 0;
  width: 72.8323699%; }

.device-combo-macbook-iphonex,
.device-combo-iphonex-macbook {
  padding-bottom: 62.4260355%; }

.device-combo-macbook-iphonex > .device-macbook,
.device-combo-iphonex-macbook > .device-macbook {
  width: 91.7159763%; }

.device-combo-macbook-iphonex > .device-iphonex,
.device-combo-iphonex-macbook > .device-iphonex {
  width: 27.9585799%;
  z-index: 1; }

.device-combo-macbook-iphonex > .device-macbook {
  top: 0;
  left: 0; }

.device-combo-iphonex-macbook > .device-macbook {
  top: 0;
  right: 0; }

.device-combo-macbook-iphonex > .device-iphonex {
  bottom: 0;
  right: 0; }

.device-combo-iphonex-macbook > .device-iphonex {
  bottom: 0;
  left: 0; }

@media (max-width: 576px) {
  .card-body {
    font-size: 0.7rem;
  }
  .img-adjust {
    width: 100% !important;
    height: 65% !important;
  }
  .align-star-rating {
    font-size: 0.7rem !important;
    display: inline-flex !important;
  }
}

@media (min-width: 992px) {
  .sidenav {
    position: fixed;
    top: 84px;
    
    height: calc(100vh - 84px);
    overflow: auto; } }


@media (min-width: 992px) {
  .sidenav-left {
    left: 0; } }

@media (min-width: 992px) {
  .sidenav-right {
    right: 0; } }

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .shape > svg {
    display: none; } }

    .shape {
      position: absolute;
      pointer-events: none; 
    }
    
    .shape > * {
      display: block; 
    }
    
    .shape:not([class*="shape-blur"]) {
      overflow: hidden; 
    }
    
    .shape:not([class*="shape-blur"]) > * {
      transform: scale(2); 
    }
    
    .shape-top {
      top: 0;
      right: 0;
      left: 0; }
    
    .shape-top > * {
      transform-origin: bottom center; 
    }
    
    .shape-right {
      top: 0;
      right: 0;
      bottom: 0;
      left: 0; }
    
    .shape-right > * {
      position: inherit;
      top: inherit;
      bottom: inherit;
      right: inherit;
      transform-origin: center left; }
    
    .shape-bottom {
      right: 0;
      bottom: 0;
      left: 0; }
    
    .shape-bottom > * {
      transform-origin: top center; 
    }
    
    .shape-left {
      top: 0;
      right: 0;
      bottom: 0;
      left: 0; 
    }
    
    .shape-left > * {
      position: inherit;
      top: inherit;
      bottom: inherit;
      left: inherit;
      transform-origin: center right; 
    }
    
    .shape-fluid-x > * {
      width: 100%;
      height: auto; 
    }
    
    .shape-fluid-y > * {
      width: auto;
      height: 100%; 
    }
    
    .shape-blur-1 {
      top: 0;
      right: 0;
      left: 0; 
    }
    
      @media (min-width: 768px) {
        .shape-blur-1 {
          bottom: 0;
          left: 50%;
          right: auto; } }
    
    .shape-blur-1 > * {
      width: 100%;
      height: auto; }
      @media (min-width: 768px) {
        .shape-blur-1 > * {
          width: auto;
          height: 100%; } }
    
    .shape-blur-2 {
      top: 0;
      right: 0;
      left: 0; }
      @media (min-width: 768px) {
        .shape-blur-2 {
          bottom: 0;
          right: 50%;
          left: auto; } }
    
    .shape-blur-2 > * {
      width: 100%;
      height: auto; }
      @media (min-width: 768px) {
        .shape-blur-2 > * {
          width: auto;
          height: 100%;
          float: right; } }
    
    .shape-blur-3 {
      top: 0;
      right: 0;
      left: 0; }
    
    .shape-blur-3 > * {
      width: 100%;
      height: auto; }
    
    .shape-blur-4 {
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%) scale(1.3); }
    
    .shape-blur-4 > * {
      width: auto;
      height: 100%; }

.overlay {
  position: relative; }
    .overlay::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: inherit; }
  
  .overlay-primary::before {
    background-color: #335EEA; }
  
  .overlay-gradient-primary-right::before {
    background-image: linear-gradient(to bottom, transparent, #335EEA); }
    @media (min-width: 768px) {
      .overlay-gradient-primary-right::before {
        background-image: linear-gradient(to right, transparent, #335EEA 50%, #335EEA); } }
  
  .overlay-gradient-primary-down::before {
    background-image: linear-gradient(to bottom, transparent, #335EEA); }
  
  .overlay-gradient-primary-left::before {
    background-image: linear-gradient(to bottom, transparent, #335EEA); }
    @media (min-width: 768px) {
      .overlay-gradient-primary-left::before {
        background-image: linear-gradient(to left, transparent, #335EEA 50%, #335EEA); } }
  
  .overlay-secondary::before {
    background-color: #506690; }
  
  .overlay-gradient-secondary-right::before {
    background-image: linear-gradient(to bottom, transparent, #506690); }
    @media (min-width: 768px) {
      .overlay-gradient-secondary-right::before {
        background-image: linear-gradient(to right, transparent, #506690 50%, #506690); } }
  
  .overlay-gradient-secondary-down::before {
    background-image: linear-gradient(to bottom, transparent, #506690); }
  
  .overlay-gradient-secondary-left::before {
    background-image: linear-gradient(to bottom, transparent, #506690); }
    @media (min-width: 768px) {
      .overlay-gradient-secondary-left::before {
        background-image: linear-gradient(to left, transparent, #506690 50%, #506690); } }
  
  .overlay-success::before {
    background-color: #42BA96; }
  
  .overlay-gradient-success-right::before {
    background-image: linear-gradient(to bottom, transparent, #42BA96); }
    @media (min-width: 768px) {
      .overlay-gradient-success-right::before {
        background-image: linear-gradient(to right, transparent, #42BA96 50%, #42BA96); } }
  
  .overlay-gradient-success-down::before {
    background-image: linear-gradient(to bottom, transparent, #42BA96); }
  
  .overlay-gradient-success-left::before {
    background-image: linear-gradient(to bottom, transparent, #42BA96); }
    @media (min-width: 768px) {
      .overlay-gradient-success-left::before {
        background-image: linear-gradient(to left, transparent, #42BA96 50%, #42BA96); } }
  
  .overlay-info::before {
    background-color: #7C69EF; }
  
  .overlay-gradient-info-right::before {
    background-image: linear-gradient(to bottom, transparent, #7C69EF); }
    @media (min-width: 768px) {
      .overlay-gradient-info-right::before {
        background-image: linear-gradient(to right, transparent, #7C69EF 50%, #7C69EF); } }
  
  .overlay-gradient-info-down::before {
    background-image: linear-gradient(to bottom, transparent, #7C69EF); }
  
  .overlay-gradient-info-left::before {
    background-image: linear-gradient(to bottom, transparent, #7C69EF); }
    @media (min-width: 768px) {
      .overlay-gradient-info-left::before {
        background-image: linear-gradient(to left, transparent, #7C69EF 50%, #7C69EF); } }
  
  .overlay-warning::before {
    background-color: #FAD776; }
  
  .overlay-gradient-warning-right::before {
    background-image: linear-gradient(to bottom, transparent, #FAD776); }
    @media (min-width: 768px) {
      .overlay-gradient-warning-right::before {
        background-image: linear-gradient(to right, transparent, #FAD776 50%, #FAD776); } }
  
  .overlay-gradient-warning-down::before {
    background-image: linear-gradient(to bottom, transparent, #FAD776); }
  
  .overlay-gradient-warning-left::before {
    background-image: linear-gradient(to bottom, transparent, #FAD776); }
    @media (min-width: 768px) {
      .overlay-gradient-warning-left::before {
        background-image: linear-gradient(to left, transparent, #FAD776 50%, #FAD776); } }
  
  .overlay-danger::before {
    background-color: #DF4759; }
  
  .overlay-gradient-danger-right::before {
    background-image: linear-gradient(to bottom, transparent, #DF4759); }
    @media (min-width: 768px) {
      .overlay-gradient-danger-right::before {
        background-image: linear-gradient(to right, transparent, #DF4759 50%, #DF4759); } }
  
  .overlay-gradient-danger-down::before {
    background-image: linear-gradient(to bottom, transparent, #DF4759); }
  
  .overlay-gradient-danger-left::before {
    background-image: linear-gradient(to bottom, transparent, #DF4759); }
    @media (min-width: 768px) {
      .overlay-gradient-danger-left::before {
        background-image: linear-gradient(to left, transparent, #DF4759 50%, #DF4759); } }
  
  .overlay-light::before {
    background-color: #F9FBFD; }
  
  .overlay-gradient-light-right::before {
    background-image: linear-gradient(to bottom, transparent, #F9FBFD); }
    @media (min-width: 768px) {
      .overlay-gradient-light-right::before {
        background-image: linear-gradient(to right, transparent, #F9FBFD 50%, #F9FBFD); } }
  
  .overlay-gradient-light-down::before {
    background-image: linear-gradient(to bottom, transparent, #F9FBFD); }
  
  .overlay-gradient-light-left::before {
    background-image: linear-gradient(to bottom, transparent, #F9FBFD); }
    @media (min-width: 768px) {
      .overlay-gradient-light-left::before {
        background-image: linear-gradient(to left, transparent, #F9FBFD 50%, #F9FBFD); } }
  
  .overlay-dark::before {
    background-color: #2B354F; }
  
  .overlay-gradient-dark-right::before {
    background-image: linear-gradient(to bottom, transparent, #2B354F); }
    @media (min-width: 768px) {
      .overlay-gradient-dark-right::before {
        background-image: linear-gradient(to right, transparent, #2B354F 50%, #2B354F); } }
  
  .overlay-gradient-dark-down::before {
    background-image: linear-gradient(to bottom, transparent, #2B354F); }
  
  .overlay-gradient-dark-left::before {
    background-image: linear-gradient(to bottom, transparent, #2B354F); }
    @media (min-width: 768px) {
      .overlay-gradient-dark-left::before {
        background-image: linear-gradient(to left, transparent, #2B354F 50%, #2B354F); } }
  
  .overlay-primary-desat::before {
    background-color: #6C8AEC; }
  
  .overlay-gradient-primary-desat-right::before {
    background-image: linear-gradient(to bottom, transparent, #6C8AEC); }
    @media (min-width: 768px) {
      .overlay-gradient-primary-desat-right::before {
        background-image: linear-gradient(to right, transparent, #6C8AEC 50%, #6C8AEC); } }
  
  .overlay-gradient-primary-desat-down::before {
    background-image: linear-gradient(to bottom, transparent, #6C8AEC); }
  
  .overlay-gradient-primary-desat-left::before {
    background-image: linear-gradient(to bottom, transparent, #6C8AEC); }
    @media (min-width: 768px) {
      .overlay-gradient-primary-desat-left::before {
        background-image: linear-gradient(to left, transparent, #6C8AEC 50%, #6C8AEC); } }
  
  .overlay-black::before {
    background-color: #161C2D; }
  
  .overlay-gradient-black-right::before {
    background-image: linear-gradient(to bottom, transparent, #161C2D); }
    @media (min-width: 768px) {
      .overlay-gradient-black-right::before {
        background-image: linear-gradient(to right, transparent, #161C2D 50%, #161C2D); } }
  
  .overlay-gradient-black-down::before {
    background-image: linear-gradient(to bottom, transparent, #161C2D); }
  
  .overlay-gradient-black-left::before {
    background-image: linear-gradient(to bottom, transparent, #161C2D); }
    @media (min-width: 768px) {
      .overlay-gradient-black-left::before {
        background-image: linear-gradient(to left, transparent, #161C2D 50%, #161C2D); } }
  
  .overlay-10::before {
    opacity: 0.1; }
  
  .overlay-20::before {
    opacity: 0.2; }
  
  .overlay-30::before {
    opacity: 0.3; }
  
  .overlay-40::before {
    opacity: 0.4; }
  
  .overlay-50::before {
    opacity: 0.5; }
  
  .overlay-60::before {
    opacity: 0.6; }
  
  .overlay-70::before {
    opacity: 0.7; }
  
  .overlay-80::before {
    opacity: 0.8; }
  
  .overlay-90::before {
    opacity: 0.9; }

.shape {
  position: absolute;
  pointer-events: none; }

.shape > * {
  display: block; }

.shape:not([class*="shape-blur"]) {
  overflow: hidden; }

.shape:not([class*="shape-blur"]) > * {
  transform: scale(2); }

.btn-rounded-circle {
  padding-left: 0.8125rem;
  padding-right: 0.8125rem;
  border-radius: 50rem; }
  .btn-rounded-circle > * {
    display: block;
    line-height: 1;
    width: 1em; }

.btn-rounded-circle.btn-lg, .btn-group-lg > .btn-rounded-circle.btn {
  padding-left: 1.122rem;
  padding-right: 1.122rem; }

.btn-rounded-circle.btn-sm, .btn-group-sm > .btn-rounded-circle.btn {
  padding-left: 0.5625rem;
  padding-right: 0.5625rem; }

.text-content h1,
.text-content h2,
.text-content h3,
.text-content h4,
.text-content h5,block
.text-content h6,
.text-content p,
.text-content ul,
.text-content ol,
.text-content blockquote {
  margin-bottom: 2rem;
}

.blockquote {
  padding: 1rem;
  border-left: 2px solid #4E66F8;
} 

.breadcrumb {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  list-style: none;
  background-color: transparent;
  border-radius: 0.4rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #868e96;
  content: "—";
}

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}

.breadcrumb-item.active {
  color: #868e96;
}


.text-content p,
.text-content ul,
.text-content ol {
  font-size: 1.1rem;
}

.text-content p,
.text-content ul,
.text-content ol {
  color: #868e96;
}


.text-gray-100 {
  color: #F9FBFD !important; }

.text-gray-200 {
  color: #F1F4F8 !important; }

.text-gray-300 {
  color: #D9E2EF !important; }

.text-gray-400 {
  color: #C6D3E6 !important; }

.text-gray-500 {
  color: #ABBCD5 !important; }

.text-gray-600 {
  color: #869AB8 !important; }

.text-gray-700 {
  color: #506690 !important; }

.text-gray-800 {
  color: #384C74 !important; }

.text-gray-900 {
  color: #2B354F !important; }

.text-white-70 {
  color: rgba(255, 255, 255, 0.7) !important; }

.text-white-75 {
  color: rgba(255, 255, 255, 0.75) !important; }

.text-white-80 {
  color: rgba(255, 255, 255, 0.8) !important; }

.text-white {
  color: #fff!important;
}

.m-0 {
 margin: 0 !important; }
.mt-0,
.my-0 {
 margin-top: 0 !important; }
.mr-0,
.mx-0 {
 margin-right: 0 !important; }
.mb-0,
.my-0 {
 margin-bottom: 0 !important; }
.ml-0,
.mx-0 {
 margin-left: 0 !important; }
.m-1 {
 margin: 0.25rem !important; }
.mt-1,
.my-1 {
 margin-top: 0.25rem !important; }
.mr-1,
.mx-1 {
 margin-right: 0.25rem !important; }
.mb-1,
.my-1 {
 margin-bottom: 0.25rem !important; }
.ml-1,
.mx-1 {
 margin-left: 0.25rem !important; }
.m-2 {
 margin: 0.5rem !important; }
.mt-2,
.my-2 {
 margin-top: 0.5rem !important; }
.mr-2,
.mx-2 {
 margin-right: 0.5rem !important; }
.mb-2,
.my-2 {
 margin-bottom: 0.5rem !important; }
.ml-2,
.mx-2 {
 margin-left: 0.5rem !important; }
.m-3 {
 margin: 0.75rem !important; }
.mt-3,
.my-3 {
 margin-top: 0.75rem !important; }
.mr-3,
.mx-3 {
 margin-right: 0.75rem !important; }
.mb-3,
.my-3 {
 margin-bottom: 0.75rem !important; }
.ml-3,
.mx-3 {
 margin-left: 0.75rem !important; }
.m-4 {
 margin: 1rem !important; }
.mt-4,
.my-4 {
 margin-top: 1rem !important; }
.mr-4,
.mx-4 {
 margin-right: 1rem !important; }
.mb-4,
.my-4 {
 margin-bottom: 1rem !important; }
.ml-4,
.mx-4 {
 margin-left: 1rem !important; }
.m-5 {
 margin: 1.5rem !important; }
.mt-5,
.my-5 {
 margin-top: 1.5rem !important; }
.mr-5,
.mx-5 {
 margin-right: 1.5rem !important; }
.mb-5,
.my-5 {
 margin-bottom: 1.5rem !important; }
.ml-5,
.mx-5 {
 margin-left: 1.5rem !important; }
.m-6 {
 margin: 2rem !important; }
.mt-6,
.my-6 {
 margin-top: 2rem !important; }
.mr-6,
.mx-6 {
 margin-right: 2rem !important; }
.mb-6,
.my-6 {
 margin-bottom: 2rem !important; }
.ml-6,
.mx-6 {
 margin-left: 2rem !important; }
.m-7 {
 margin: 2.5rem !important; }
.mt-7,
.my-7 {
 margin-top: 2.5rem !important; }
.mr-7,
.mx-7 {
 margin-right: 2.5rem !important; }
.mb-7,
.my-7 {
 margin-bottom: 2.5rem !important; }
.ml-7,
.mx-7 {
 margin-left: 2.5rem !important; }
.m-8 {
 margin: 3rem !important; }
.mt-8,
.my-8 {
 margin-top: 3rem !important; }
.mr-8,
.mx-8 {
 margin-right: 3rem !important; }
.mb-8,
.my-8 {
 margin-bottom: 3rem !important; }
.ml-8,
.mx-8 {
 margin-left: 3rem !important; }
.m-9 {
 margin: 4rem !important; }
.mt-9,
.my-9 {
 margin-top: 4rem !important; }
.mr-9,
.mx-9 {
 margin-right: 4rem !important; }
.mb-9,
.my-9 {
 margin-bottom: 4rem !important; }
.ml-9,
.mx-9 {
 margin-left: 4rem !important; }
.m-10 {
 margin: 5rem !important; }
.mt-10,
.my-10 {
 margin-top: 5rem !important; }
.mr-10,
.mx-10 {
 margin-right: 5rem !important; }
.mb-10,
.my-10 {
 margin-bottom: 5rem !important; }
.ml-10,
.mx-10 {
 margin-left: 5rem !important; }
.m-11 {
 margin: 6rem !important; }
.mt-11,
.my-11 {
 margin-top: 6rem !important; }
.mr-11,
.mx-11 {
 margin-right: 6rem !important; }
.mb-11,
.my-11 {
 margin-bottom: 6rem !important; }
.ml-11,
.mx-11 {
 margin-left: 6rem !important; }
.m-12 {
 margin: 8rem !important; }
.mt-12,
.my-12 {
 margin-top: 8rem !important; }
.mr-12,
.mx-12 {
 margin-right: 8rem !important; }
.mb-12,
.my-12 {
 margin-bottom: 8rem !important; }
.ml-12,
.mx-12 {
 margin-left: 8rem !important; }
.m-13 {
 margin: 10rem !important; }
.mt-13,
.my-13 {
 margin-top: 10rem !important; }
.mr-13,
.mx-13 {
 margin-right: 10rem !important; }
.mb-13,
.my-13 {
 margin-bottom: 10rem !important; }
.ml-13,
.mx-13 {
 margin-left: 10rem !important; }
.m-14 {
 margin: 12rem !important; }
.mt-14,
.my-14 {
 margin-top: 12rem !important; }
.mr-14,
.mx-14 {
 margin-right: 12rem !important; }
.mb-14,
.my-14 {
 margin-bottom: 12rem !important; }
.ml-14,
.mx-14 {
 margin-left: 12rem !important; }
.m-15 {
 margin: 16rem !important; }
.mt-15,
.my-15 {
 margin-top: 16rem !important; }
.mr-15,
.mx-15 {
 margin-right: 16rem !important; }
.mb-15,
.my-15 {
 margin-bottom: 16rem !important; }
.ml-15,
.mx-15 {
 margin-left: 16rem !important; }
.m-16 {
 margin: 25rem !important; }
.mt-16,
.my-16 {
 margin-top: 25rem !important; }
.mr-16,
.mx-16 {
 margin-right: 25rem !important; }
.mb-16,
.my-16 {
 margin-bottom: 25rem !important; }
.ml-16,
.mx-16 {
 margin-left: 25rem !important; }
.p-0 {
 padding: 0 !important; }
.pt-0,
.py-0 {
 padding-top: 0 !important; }
.pr-0,
.px-0 {
 padding-right: 0 !important; }
.pb-0,
.py-0 {
 padding-bottom: 0 !important; }
.pl-0,
.px-0 {
 padding-left: 0 !important; }
.p-1 {
 padding: 0.25rem !important; }
.pt-1,
.py-1 {
 padding-top: 0.25rem !important; }
.pr-1,
.px-1 {
 padding-right: 0.25rem !important; }
.pb-1,
.py-1 {
 padding-bottom: 0.25rem !important; }
.pl-1,
.px-1 {
 padding-left: 0.25rem !important; }
.p-2 {
 padding: 0.5rem !important; }
.pt-2,
.py-2 {
 padding-top: 0.5rem !important; }
.pr-2,
.px-2 {
 padding-right: 0.5rem !important; }
.pb-2,
.py-2 {
 padding-bottom: 0.5rem !important; }
.pl-2,
.px-2 {
 padding-left: 0.5rem !important; }
.p-3 {
 padding: 0.75rem !important; }
.pt-3,
.py-3 {
 padding-top: 0.75rem !important; }
.pr-3,
.px-3 {
 padding-right: 0.75rem !important; }
.pb-3,
.py-3 {
 padding-bottom: 0.75rem !important; }
.pl-3,
.px-3 {
 padding-left: 0.75rem !important; }
.p-4 {
 padding: 1rem !important; }
.pt-4,
.py-4 {
 padding-top: 1rem !important; }
.pr-4,
.px-4 {
 padding-right: 1rem !important; }
.pb-4,
.py-4 {
 padding-bottom: 1rem !important; }
.pl-4,
.px-4 {
 padding-left: 1rem !important; }
.p-5 {
 padding: 1.5rem !important; }
.pt-5,
.py-5 {
 padding-top: 1.5rem !important; }
.pr-5,
.px-5 {
 padding-right: 1.5rem !important; }
.pb-5,
.py-5 {
 padding-bottom: 1.5rem !important; }
.pl-5,
.px-5 {
 padding-left: 1.5rem !important; }
.p-6 {
 padding: 2rem !important; }
.pt-6,
.py-6 {
 padding-top: 2rem !important; }
.pr-6,
.px-6 {
 padding-right: 2rem !important; }
.pb-6,
.py-6 {
 padding-bottom: 2rem !important; }
.pl-6,
.px-6 {
 padding-left: 2rem !important; }
.p-7 {
 padding: 2.5rem !important; }
.pt-7,
.py-7 {
 padding-top: 2.5rem !important; }
.pr-7,
.px-7 {
 padding-right: 2.5rem !important; }
.pb-7,
.py-7 {
 padding-bottom: 2.5rem !important; }
.pl-7,
.px-7 {
 padding-left: 2.5rem !important; }
.p-8 {
 padding: 3rem !important; }
.pt-8,
.py-8 {
 padding-top: 3rem !important; }
.pr-8,
.px-8 {
 padding-right: 3rem !important; }
.pb-8,
.py-8 {
 padding-bottom: 3rem !important; }
.pl-8,
.px-8 {
 padding-left: 3rem !important; }
.p-9 {
 padding: 4rem !important; }
.pt-9,
.py-9 {
 padding-top: 4rem !important; }
.pr-9,
.px-9 {
 padding-right: 4rem !important; }
.pb-9,
.py-9 {
 padding-bottom: 4rem !important; }
.pl-9,
.px-9 {
 padding-left: 4rem !important; }
.p-10 {
 padding: 5rem !important; }
.pt-10,
.py-10 {
 padding-top: 5rem !important; }
.pr-10,
.px-10 {
 padding-right: 5rem !important; }
.pb-10,
.py-10 {
 padding-bottom: 5rem !important; }
.pl-10,
.px-10 {
 padding-left: 5rem !important; }
.p-11 {
 padding: 6rem !important; }
.pt-11,
.py-11 {
 padding-top: 6rem !important; }
.pr-11,
.px-11 {
 padding-right: 6rem !important; }
.pb-11,
.py-11 {
 padding-bottom: 6rem !important; }
.pl-11,
.px-11 {
 padding-left: 6rem !important; }
.p-12 {
 padding: 8rem !important; }
.pt-12,
.py-12 {
 padding-top: 8rem !important; }
.pr-12,
.px-12 {
 padding-right: 8rem !important; }
.pb-12,
.py-12 {
 padding-bottom: 8rem !important; }
.pl-12,
.px-12 {
 padding-left: 8rem !important; }
.p-13 {
 padding: 10rem !important; }
.pt-13,
.py-13 {
 padding-top: 10rem !important; }
.pr-13,
.px-13 {
 padding-right: 10rem !important; }
.pb-13,
.py-13 {
 padding-bottom: 10rem !important; }
.pl-13,
.px-13 {
 padding-left: 10rem !important; }
.p-14 {
 padding: 12rem !important; }
.pt-14,
.py-14 {
 padding-top: 12rem !important; }
.pr-14,
.px-14 {
 padding-right: 12rem !important; }
.pb-14,
.py-14 {
 padding-bottom: 12rem !important; }
.pl-14,
.px-14 {
 padding-left: 12rem !important; }
.p-15 {
 padding: 16rem !important; }
.pt-15,
.py-15 {
 padding-top: 16rem !important; }
.pr-15,
.px-15 {
 padding-right: 16rem !important; }
.pb-15,
.py-15 {
 padding-bottom: 16rem !important; }
.pl-15,
.px-15 {
 padding-left: 16rem !important; }
.p-16 {
 padding: 25rem !important; }
.pt-16,
.py-16 {
 padding-top: 25rem !important; }
.pr-16,
.px-16 {
 padding-right: 25rem !important; }
.pb-16,
.py-16 {
 padding-bottom: 25rem !important; }
.pl-16,
.px-16 {
 padding-left: 25rem !important; }
.m-n1 {
 margin: -0.25rem !important; }
.mt-n1,
.my-n1 {
 margin-top: -0.25rem !important; }
.mr-n1,
.mx-n1 {
 margin-right: -0.25rem !important; }
.mb-n1,
.my-n1 {
 margin-bottom: -0.25rem !important; }
.ml-n1,
.mx-n1 {
 margin-left: -0.25rem !important; }
.m-n2 {
 margin: -0.5rem !important; }
.mt-n2,
.my-n2 {
 margin-top: -0.5rem !important; }
.mr-n2,
.mx-n2 {
 margin-right: -0.5rem !important; }
.mb-n2,
.my-n2 {
 margin-bottom: -0.5rem !important; }
.ml-n2,
.mx-n2 {
 margin-left: -0.5rem !important; }
.m-n3 {
 margin: -0.75rem !important; }
.mt-n3,
.my-n3 {
 margin-top: -0.75rem !important; }
.mr-n3,
.mx-n3 {
 margin-right: -0.75rem !important; }
.mb-n3,
.my-n3 {
 margin-bottom: -0.75rem !important; }
.ml-n3,
.mx-n3 {
 margin-left: -0.75rem !important; }
.m-n4 {
 margin: -1rem !important; }
.mt-n4,
.my-n4 {
 margin-top: -1rem !important; }
.mr-n4,
.mx-n4 {
 margin-right: -1rem !important; }
.mb-n4,
.my-n4 {
 margin-bottom: -1rem !important; }
.ml-n4,
.mx-n4 {
 margin-left: -1rem !important; }
.m-n5 {
 margin: -1.5rem !important; }
.mt-n5,
.my-n5 {
 margin-top: -1.5rem !important; }
.mr-n5,
.mx-n5 {
 margin-right: -1.5rem !important; }
.mb-n5,
.my-n5 {
 margin-bottom: -1.5rem !important; }
.ml-n5,
.mx-n5 {
 margin-left: -1.5rem !important; }
.m-n6 {
 margin: -2rem !important; }
.mt-n6,
.my-n6 {
 margin-top: -2rem !important; }
.mr-n6,
.mx-n6 {
 margin-right: -2rem !important; }
.mb-n6,
.my-n6 {
 margin-bottom: -2rem !important; }
.ml-n6,
.mx-n6 {
 margin-left: -2rem !important; }
.m-n7 {
 margin: -2.5rem !important; }
.mt-n7,
.my-n7 {
 margin-top: -2.5rem !important; }
.mr-n7,
.mx-n7 {
 margin-right: -2.5rem !important; }
.mb-n7,
.my-n7 {
 margin-bottom: -2.5rem !important; }
.ml-n7,
.mx-n7 {
 margin-left: -2.5rem !important; }
.m-n8 {
 margin: -3rem !important; }
.mt-n8,
.my-n8 {
 margin-top: -3rem !important; }
.mr-n8,
.mx-n8 {
 margin-right: -3rem !important; }
.mb-n8,
.my-n8 {
 margin-bottom: -3rem !important; }
.ml-n8,
.mx-n8 {
 margin-left: -3rem !important; }
.m-n9 {
 margin: -4rem !important; }
.mt-n9,
.my-n9 {
 margin-top: -4rem !important; }
.mr-n9,
.mx-n9 {
 margin-right: -4rem !important; }
.mb-n9,
.my-n9 {
 margin-bottom: -4rem !important; }
.ml-n9,
.mx-n9 {
 margin-left: -4rem !important; }
.m-n10 {
 margin: -5rem !important; }
.mt-n10,
.my-n10 {
 margin-top: -5rem !important; }
.mr-n10,
.mx-n10 {
 margin-right: -5rem !important; }
.mb-n10,
.my-n10 {
 margin-bottom: -5rem !important; }
.ml-n10,
.mx-n10 {
 margin-left: -5rem !important; }
.m-n11 {
 margin: -6rem !important; }
.mt-n11,
.my-n11 {
 margin-top: -6rem !important; }
.mr-n11,
.mx-n11 {
 margin-right: -6rem !important; }
.mb-n11,
.my-n11 {
 margin-bottom: -6rem !important; }
.ml-n11,
.mx-n11 {
 margin-left: -6rem !important; }
.m-n12 {
 margin: -8rem !important; }
.mt-n12,
.my-n12 {
 margin-top: -8rem !important; }
.mr-n12,
.mx-n12 {
 margin-right: -8rem !important; }
.mb-n12,
.my-n12 {
 margin-bottom: -8rem !important; }
.ml-n12,
.mx-n12 {
 margin-left: -8rem !important; }
.m-n13 {
 margin: -10rem !important; }
.mt-n13,
.my-n13 {
 margin-top: -10rem !important; }
.mr-n13,
.mx-n13 {
 margin-right: -10rem !important; }
.mb-n13,
.my-n13 {
 margin-bottom: -10rem !important; }
.ml-n13,
.mx-n13 {
 margin-left: -10rem !important; }
.m-n14 {
 margin: -12rem !important; }
.mt-n14,
.my-n14 {
 margin-top: -12rem !important; }
.mr-n14,
.mx-n14 {
 margin-right: -12rem !important; }
.mb-n14,
.my-n14 {
 margin-bottom: -12rem !important; }
.ml-n14,
.mx-n14 {
 margin-left: -12rem !important; }
.m-n15 {
 margin: -16rem !important; }
.mt-n15,
.my-n15 {
 margin-top: -16rem !important; }
.mr-n15,
.mx-n15 {
 margin-right: -16rem !important; }
.mb-n15,
.my-n15 {
 margin-bottom: -16rem !important; }
.ml-n15,
.mx-n15 {
 margin-left: -16rem !important; }
.m-n16 {
 margin: -25rem !important; }
.mt-n16,
.my-n16 {
 margin-top: -25rem !important; }
.mr-n16,
.mx-n16 {
 margin-right: -25rem !important; }
.mb-n16,
.my-n16 {
 margin-bottom: -25rem !important; }
.ml-n16,
.mx-n16 {
 margin-left: -25rem !important; }
.m-auto {
 margin: auto !important; }
.mt-auto,
.my-auto {
 margin-top: auto !important; }
.mr-auto,
.mx-auto {
 margin-right: auto !important; }
.mb-auto,
.my-auto {
 margin-bottom: auto !important; }
.ml-auto,
.mx-auto {
 margin-left: auto !important; }
@media (min-width: 576px) {
 .m-sm-0 {
   margin: 0 !important; }
 .mt-sm-0,
 .my-sm-0 {
   margin-top: 0 !important; }
 .mr-sm-0,
 .mx-sm-0 {
   margin-right: 0 !important; }
 .mb-sm-0,
 .my-sm-0 {
   margin-bottom: 0 !important; }
 .ml-sm-0,
 .mx-sm-0 {
   margin-left: 0 !important; }
 .m-sm-1 {
   margin: 0.25rem !important; }
 .mt-sm-1,
 .my-sm-1 {
   margin-top: 0.25rem !important; }
 .mr-sm-1,
 .mx-sm-1 {
   margin-right: 0.25rem !important; }
 .mb-sm-1,
 .my-sm-1 {
   margin-bottom: 0.25rem !important; }
 .ml-sm-1,
 .mx-sm-1 {
   margin-left: 0.25rem !important; }
 .m-sm-2 {
   margin: 0.5rem !important; }
 .mt-sm-2,
 .my-sm-2 {
   margin-top: 0.5rem !important; }
 .mr-sm-2,
 .mx-sm-2 {
   margin-right: 0.5rem !important; }
 .mb-sm-2,
 .my-sm-2 {
   margin-bottom: 0.5rem !important; }
 .ml-sm-2,
 .mx-sm-2 {
   margin-left: 0.5rem !important; }
 .m-sm-3 {
   margin: 0.75rem !important; }
 .mt-sm-3,
 .my-sm-3 {
   margin-top: 0.75rem !important; }
 .mr-sm-3,
 .mx-sm-3 {
   margin-right: 0.75rem !important; }
 .mb-sm-3,
 .my-sm-3 {
   margin-bottom: 0.75rem !important; }
 .ml-sm-3,
 .mx-sm-3 {
   margin-left: 0.75rem !important; }
 .m-sm-4 {
   margin: 1rem !important; }
 .mt-sm-4,
 .my-sm-4 {
   margin-top: 1rem !important; }
 .mr-sm-4,
 .mx-sm-4 {
   margin-right: 1rem !important; }
 .mb-sm-4,
 .my-sm-4 {
   margin-bottom: 1rem !important; }
 .ml-sm-4,
 .mx-sm-4 {
   margin-left: 1rem !important; }
 .m-sm-5 {
   margin: 1.5rem !important; }
 .mt-sm-5,
 .my-sm-5 {
   margin-top: 1.5rem !important; }
 .mr-sm-5,
 .mx-sm-5 {
   margin-right: 1.5rem !important; }
 .mb-sm-5,
 .my-sm-5 {
   margin-bottom: 1.5rem !important; }
 .ml-sm-5,
 .mx-sm-5 {
   margin-left: 1.5rem !important; }
 .m-sm-6 {
   margin: 2rem !important; }
 .mt-sm-6,
 .my-sm-6 {
   margin-top: 2rem !important; }
 .mr-sm-6,
 .mx-sm-6 {
   margin-right: 2rem !important; }
 .mb-sm-6,
 .my-sm-6 {
   margin-bottom: 2rem !important; }
 .ml-sm-6,
 .mx-sm-6 {
   margin-left: 2rem !important; }
 .m-sm-7 {
   margin: 2.5rem !important; }
 .mt-sm-7,
 .my-sm-7 {
   margin-top: 2.5rem !important; }
 .mr-sm-7,
 .mx-sm-7 {
   margin-right: 2.5rem !important; }
 .mb-sm-7,
 .my-sm-7 {
   margin-bottom: 2.5rem !important; }
 .ml-sm-7,
 .mx-sm-7 {
   margin-left: 2.5rem !important; }
 .m-sm-8 {
   margin: 3rem !important; }
 .mt-sm-8,
 .my-sm-8 {
   margin-top: 3rem !important; }
 .mr-sm-8,
 .mx-sm-8 {
   margin-right: 3rem !important; }
 .mb-sm-8,
 .my-sm-8 {
   margin-bottom: 3rem !important; }
 .ml-sm-8,
 .mx-sm-8 {
   margin-left: 3rem !important; }
 .m-sm-9 {
   margin: 4rem !important; }
 .mt-sm-9,
 .my-sm-9 {
   margin-top: 4rem !important; }
 .mr-sm-9,
 .mx-sm-9 {
   margin-right: 4rem !important; }
 .mb-sm-9,
 .my-sm-9 {
   margin-bottom: 4rem !important; }
 .ml-sm-9,
 .mx-sm-9 {
   margin-left: 4rem !important; }
 .m-sm-10 {
   margin: 5rem !important; }
 .mt-sm-10,
 .my-sm-10 {
   margin-top: 5rem !important; }
 .mr-sm-10,
 .mx-sm-10 {
   margin-right: 5rem !important; }
 .mb-sm-10,
 .my-sm-10 {
   margin-bottom: 5rem !important; }
 .ml-sm-10,
 .mx-sm-10 {
   margin-left: 5rem !important; }
 .m-sm-11 {
   margin: 6rem !important; }
 .mt-sm-11,
 .my-sm-11 {
   margin-top: 6rem !important; }
 .mr-sm-11,
 .mx-sm-11 {
   margin-right: 6rem !important; }
 .mb-sm-11,
 .my-sm-11 {
   margin-bottom: 6rem !important; }
 .ml-sm-11,
 .mx-sm-11 {
   margin-left: 6rem !important; }
 .m-sm-12 {
   margin: 8rem !important; }
 .mt-sm-12,
 .my-sm-12 {
   margin-top: 8rem !important; }
 .mr-sm-12,
 .mx-sm-12 {
   margin-right: 8rem !important; }
 .mb-sm-12,
 .my-sm-12 {
   margin-bottom: 8rem !important; }
 .ml-sm-12,
 .mx-sm-12 {
   margin-left: 8rem !important; }
 .m-sm-13 {
   margin: 10rem !important; }
 .mt-sm-13,
 .my-sm-13 {
   margin-top: 10rem !important; }
 .mr-sm-13,
 .mx-sm-13 {
   margin-right: 10rem !important; }
 .mb-sm-13,
 .my-sm-13 {
   margin-bottom: 10rem !important; }
 .ml-sm-13,
 .mx-sm-13 {
   margin-left: 10rem !important; }
 .m-sm-14 {
   margin: 12rem !important; }
 .mt-sm-14,
 .my-sm-14 {
   margin-top: 12rem !important; }
 .mr-sm-14,
 .mx-sm-14 {
   margin-right: 12rem !important; }
 .mb-sm-14,
 .my-sm-14 {
   margin-bottom: 12rem !important; }
 .ml-sm-14,
 .mx-sm-14 {
   margin-left: 12rem !important; }
 .m-sm-15 {
   margin: 16rem !important; }
 .mt-sm-15,
 .my-sm-15 {
   margin-top: 16rem !important; }
 .mr-sm-15,
 .mx-sm-15 {
   margin-right: 16rem !important; }
 .mb-sm-15,
 .my-sm-15 {
   margin-bottom: 16rem !important; }
 .ml-sm-15,
 .mx-sm-15 {
   margin-left: 16rem !important; }
 .m-sm-16 {
   margin: 25rem !important; }
 .mt-sm-16,
 .my-sm-16 {
   margin-top: 25rem !important; }
 .mr-sm-16,
 .mx-sm-16 {
   margin-right: 25rem !important; }
 .mb-sm-16,
 .my-sm-16 {
   margin-bottom: 25rem !important; }
 .ml-sm-16,
 .mx-sm-16 {
   margin-left: 25rem !important; }
 .p-sm-0 {
   padding: 0 !important; }
 .pt-sm-0,
 .py-sm-0 {
   padding-top: 0 !important; }
 .pr-sm-0,
 .px-sm-0 {
   padding-right: 0 !important; }
 .pb-sm-0,
 .py-sm-0 {
   padding-bottom: 0 !important; }
 .pl-sm-0,
 .px-sm-0 {
   padding-left: 0 !important; }
 .p-sm-1 {
   padding: 0.25rem !important; }
 .pt-sm-1,
 .py-sm-1 {
   padding-top: 0.25rem !important; }
 .pr-sm-1,
 .px-sm-1 {
   padding-right: 0.25rem !important; }
 .pb-sm-1,
 .py-sm-1 {
   padding-bottom: 0.25rem !important; }
 .pl-sm-1,
 .px-sm-1 {
   padding-left: 0.25rem !important; }
 .p-sm-2 {
   padding: 0.5rem !important; }
 .pt-sm-2,
 .py-sm-2 {
   padding-top: 0.5rem !important; }
 .pr-sm-2,
 .px-sm-2 {
   padding-right: 0.5rem !important; }
 .pb-sm-2,
 .py-sm-2 {
   padding-bottom: 0.5rem !important; }
 .pl-sm-2,
 .px-sm-2 {
   padding-left: 0.5rem !important; }
 .p-sm-3 {
   padding: 0.75rem !important; }
 .pt-sm-3,
 .py-sm-3 {
   padding-top: 0.75rem !important; }
 .pr-sm-3,
 .px-sm-3 {
   padding-right: 0.75rem !important; }
 .pb-sm-3,
 .py-sm-3 {
   padding-bottom: 0.75rem !important; }
 .pl-sm-3,
 .px-sm-3 {
   padding-left: 0.75rem !important; }
 .p-sm-4 {
   padding: 1rem !important; }
 .pt-sm-4,
 .py-sm-4 {
   padding-top: 1rem !important; }
 .pr-sm-4,
 .px-sm-4 {
   padding-right: 1rem !important; }
 .pb-sm-4,
 .py-sm-4 {
   padding-bottom: 1rem !important; }
 .pl-sm-4,
 .px-sm-4 {
   padding-left: 1rem !important; }
 .p-sm-5 {
   padding: 1.5rem !important; }
 .pt-sm-5,
 .py-sm-5 {
   padding-top: 1.5rem !important; }
 .pr-sm-5,
 .px-sm-5 {
   padding-right: 1.5rem !important; }
 .pb-sm-5,
 .py-sm-5 {
   padding-bottom: 1.5rem !important; }
 .pl-sm-5,
 .px-sm-5 {
   padding-left: 1.5rem !important; }
 .p-sm-6 {
   padding: 2rem !important; }
 .pt-sm-6,
 .py-sm-6 {
   padding-top: 2rem !important; }
 .pr-sm-6,
 .px-sm-6 {
   padding-right: 2rem !important; }
 .pb-sm-6,
 .py-sm-6 {
   padding-bottom: 2rem !important; }
 .pl-sm-6,
 .px-sm-6 {
   padding-left: 2rem !important; }
 .p-sm-7 {
   padding: 2.5rem !important; }
 .pt-sm-7,
 .py-sm-7 {
   padding-top: 2.5rem !important; }
 .pr-sm-7,
 .px-sm-7 {
   padding-right: 2.5rem !important; }
 .pb-sm-7,
 .py-sm-7 {
   padding-bottom: 2.5rem !important; }
 .pl-sm-7,
 .px-sm-7 {
   padding-left: 2.5rem !important; }
 .p-sm-8 {
   padding: 3rem !important; }
 .pt-sm-8,
 .py-sm-8 {
   padding-top: 3rem !important; }
 .pr-sm-8,
 .px-sm-8 {
   padding-right: 3rem !important; }
 .pb-sm-8,
 .py-sm-8 {
   padding-bottom: 3rem !important; }
 .pl-sm-8,
 .px-sm-8 {
   padding-left: 3rem !important; }
 .p-sm-9 {
   padding: 4rem !important; }
 .pt-sm-9,
 .py-sm-9 {
   padding-top: 4rem !important; }
 .pr-sm-9,
 .px-sm-9 {
   padding-right: 4rem !important; }
 .pb-sm-9,
 .py-sm-9 {
   padding-bottom: 4rem !important; }
 .pl-sm-9,
 .px-sm-9 {
   padding-left: 4rem !important; }
 .p-sm-10 {
   padding: 5rem !important; }
 .pt-sm-10,
 .py-sm-10 {
   padding-top: 5rem !important; }
 .pr-sm-10,
 .px-sm-10 {
   padding-right: 5rem !important; }
 .pb-sm-10,
 .py-sm-10 {
   padding-bottom: 5rem !important; }
 .pl-sm-10,
 .px-sm-10 {
   padding-left: 5rem !important; }
 .p-sm-11 {
   padding: 6rem !important; }
 .pt-sm-11,
 .py-sm-11 {
   padding-top: 6rem !important; }
 .pr-sm-11,
 .px-sm-11 {
   padding-right: 6rem !important; }
 .pb-sm-11,
 .py-sm-11 {
   padding-bottom: 6rem !important; }
 .pl-sm-11,
 .px-sm-11 {
   padding-left: 6rem !important; }
 .p-sm-12 {
   padding: 8rem !important; }
 .pt-sm-12,
 .py-sm-12 {
   padding-top: 8rem !important; }
 .pr-sm-12,
 .px-sm-12 {
   padding-right: 8rem !important; }
 .pb-sm-12,
 .py-sm-12 {
   padding-bottom: 8rem !important; }
 .pl-sm-12,
 .px-sm-12 {
   padding-left: 8rem !important; }
 .p-sm-13 {
   padding: 10rem !important; }
 .pt-sm-13,
 .py-sm-13 {
   padding-top: 10rem !important; }
 .pr-sm-13,
 .px-sm-13 {
   padding-right: 10rem !important; }
 .pb-sm-13,
 .py-sm-13 {
   padding-bottom: 10rem !important; }
 .pl-sm-13,
 .px-sm-13 {
   padding-left: 10rem !important; }
 .p-sm-14 {
   padding: 12rem !important; }
 .pt-sm-14,
 .py-sm-14 {
   padding-top: 12rem !important; }
 .pr-sm-14,
 .px-sm-14 {
   padding-right: 12rem !important; }
 .pb-sm-14,
 .py-sm-14 {
   padding-bottom: 12rem !important; }
 .pl-sm-14,
 .px-sm-14 {
   padding-left: 12rem !important; }
 .p-sm-15 {
   padding: 16rem !important; }
 .pt-sm-15,
 .py-sm-15 {
   padding-top: 16rem !important; }
 .pr-sm-15,
 .px-sm-15 {
   padding-right: 16rem !important; }
 .pb-sm-15,
 .py-sm-15 {
   padding-bottom: 16rem !important; }
 .pl-sm-15,
 .px-sm-15 {
   padding-left: 16rem !important; }
 .p-sm-16 {
   padding: 25rem !important; }
 .pt-sm-16,
 .py-sm-16 {
   padding-top: 25rem !important; }
 .pr-sm-16,
 .px-sm-16 {
   padding-right: 25rem !important; }
 .pb-sm-16,
 .py-sm-16 {
   padding-bottom: 25rem !important; }
 .pl-sm-16,
 .px-sm-16 {
   padding-left: 25rem !important; }
 .m-sm-n1 {
   margin: -0.25rem !important; }
 .mt-sm-n1,
 .my-sm-n1 {
   margin-top: -0.25rem !important; }
 .mr-sm-n1,
 .mx-sm-n1 {
   margin-right: -0.25rem !important; }
 .mb-sm-n1,
 .my-sm-n1 {
   margin-bottom: -0.25rem !important; }
 .ml-sm-n1,
 .mx-sm-n1 {
   margin-left: -0.25rem !important; }
 .m-sm-n2 {
   margin: -0.5rem !important; }
 .mt-sm-n2,
 .my-sm-n2 {
   margin-top: -0.5rem !important; }
 .mr-sm-n2,
 .mx-sm-n2 {
   margin-right: -0.5rem !important; }
 .mb-sm-n2,
 .my-sm-n2 {
   margin-bottom: -0.5rem !important; }
 .ml-sm-n2,
 .mx-sm-n2 {
   margin-left: -0.5rem !important; }
 .m-sm-n3 {
   margin: -0.75rem !important; }
 .mt-sm-n3,
 .my-sm-n3 {
   margin-top: -0.75rem !important; }
 .mr-sm-n3,
 .mx-sm-n3 {
   margin-right: -0.75rem !important; }
 .mb-sm-n3,
 .my-sm-n3 {
   margin-bottom: -0.75rem !important; }
 .ml-sm-n3,
 .mx-sm-n3 {
   margin-left: -0.75rem !important; }
 .m-sm-n4 {
   margin: -1rem !important; }
 .mt-sm-n4,
 .my-sm-n4 {
   margin-top: -1rem !important; }
 .mr-sm-n4,
 .mx-sm-n4 {
   margin-right: -1rem !important; }
 .mb-sm-n4,
 .my-sm-n4 {
   margin-bottom: -1rem !important; }
 .ml-sm-n4,
 .mx-sm-n4 {
   margin-left: -1rem !important; }
 .m-sm-n5 {
   margin: -1.5rem !important; }
 .mt-sm-n5,
 .my-sm-n5 {
   margin-top: -1.5rem !important; }
 .mr-sm-n5,
 .mx-sm-n5 {
   margin-right: -1.5rem !important; }
 .mb-sm-n5,
 .my-sm-n5 {
   margin-bottom: -1.5rem !important; }
 .ml-sm-n5,
 .mx-sm-n5 {
   margin-left: -1.5rem !important; }
 .m-sm-n6 {
   margin: -2rem !important; }
 .mt-sm-n6,
 .my-sm-n6 {
   margin-top: -2rem !important; }
 .mr-sm-n6,
 .mx-sm-n6 {
   margin-right: -2rem !important; }
 .mb-sm-n6,
 .my-sm-n6 {
   margin-bottom: -2rem !important; }
 .ml-sm-n6,
 .mx-sm-n6 {
   margin-left: -2rem !important; }
 .m-sm-n7 {
   margin: -2.5rem !important; }
 .mt-sm-n7,
 .my-sm-n7 {
   margin-top: -2.5rem !important; }
 .mr-sm-n7,
 .mx-sm-n7 {
   margin-right: -2.5rem !important; }
 .mb-sm-n7,
 .my-sm-n7 {
   margin-bottom: -2.5rem !important; }
 .ml-sm-n7,
 .mx-sm-n7 {
   margin-left: -2.5rem !important; }
 .m-sm-n8 {
   margin: -3rem !important; }
 .mt-sm-n8,
 .my-sm-n8 {
   margin-top: -3rem !important; }
 .mr-sm-n8,
 .mx-sm-n8 {
   margin-right: -3rem !important; }
 .mb-sm-n8,
 .my-sm-n8 {
   margin-bottom: -3rem !important; }
 .ml-sm-n8,
 .mx-sm-n8 {
   margin-left: -3rem !important; }
 .m-sm-n9 {
   margin: -4rem !important; }
 .mt-sm-n9,
 .my-sm-n9 {
   margin-top: -4rem !important; }
 .mr-sm-n9,
 .mx-sm-n9 {
   margin-right: -4rem !important; }
 .mb-sm-n9,
 .my-sm-n9 {
   margin-bottom: -4rem !important; }
 .ml-sm-n9,
 .mx-sm-n9 {
   margin-left: -4rem !important; }
 .m-sm-n10 {
   margin: -5rem !important; }
 .mt-sm-n10,
 .my-sm-n10 {
   margin-top: -5rem !important; }
 .mr-sm-n10,
 .mx-sm-n10 {
   margin-right: -5rem !important; }
 .mb-sm-n10,
 .my-sm-n10 {
   margin-bottom: -5rem !important; }
 .ml-sm-n10,
 .mx-sm-n10 {
   margin-left: -5rem !important; }
 .m-sm-n11 {
   margin: -6rem !important; }
 .mt-sm-n11,
 .my-sm-n11 {
   margin-top: -6rem !important; }
 .mr-sm-n11,
 .mx-sm-n11 {
   margin-right: -6rem !important; }
 .mb-sm-n11,
 .my-sm-n11 {
   margin-bottom: -6rem !important; }
 .ml-sm-n11,
 .mx-sm-n11 {
   margin-left: -6rem !important; }
 .m-sm-n12 {
   margin: -8rem !important; }
 .mt-sm-n12,
 .my-sm-n12 {
   margin-top: -8rem !important; }
 .mr-sm-n12,
 .mx-sm-n12 {
   margin-right: -8rem !important; }
 .mb-sm-n12,
 .my-sm-n12 {
   margin-bottom: -8rem !important; }
 .ml-sm-n12,
 .mx-sm-n12 {
   margin-left: -8rem !important; }
 .m-sm-n13 {
   margin: -10rem !important; }
 .mt-sm-n13,
 .my-sm-n13 {
   margin-top: -10rem !important; }
 .mr-sm-n13,
 .mx-sm-n13 {
   margin-right: -10rem !important; }
 .mb-sm-n13,
 .my-sm-n13 {
   margin-bottom: -10rem !important; }
 .ml-sm-n13,
 .mx-sm-n13 {
   margin-left: -10rem !important; }
 .m-sm-n14 {
   margin: -12rem !important; }
 .mt-sm-n14,
 .my-sm-n14 {
   margin-top: -12rem !important; }
 .mr-sm-n14,
 .mx-sm-n14 {
   margin-right: -12rem !important; }
 .mb-sm-n14,
 .my-sm-n14 {
   margin-bottom: -12rem !important; }
 .ml-sm-n14,
 .mx-sm-n14 {
   margin-left: -12rem !important; }
 .m-sm-n15 {
   margin: -16rem !important; }
 .mt-sm-n15,
 .my-sm-n15 {
   margin-top: -16rem !important; }
 .mr-sm-n15,
 .mx-sm-n15 {
   margin-right: -16rem !important; }
 .mb-sm-n15,
 .my-sm-n15 {
   margin-bottom: -16rem !important; }
 .ml-sm-n15,
 .mx-sm-n15 {
   margin-left: -16rem !important; }
 .m-sm-n16 {
   margin: -25rem !important; }
 .mt-sm-n16,
 .my-sm-n16 {
   margin-top: -25rem !important; }
 .mr-sm-n16,
 .mx-sm-n16 {
   margin-right: -25rem !important; }
 .mb-sm-n16,
 .my-sm-n16 {
   margin-bottom: -25rem !important; }
 .ml-sm-n16,
 .mx-sm-n16 {
   margin-left: -25rem !important; }
 .m-sm-auto {
   margin: auto !important; }
 .mt-sm-auto,
 .my-sm-auto {
   margin-top: auto !important; }
 .mr-sm-auto,
 .mx-sm-auto {
   margin-right: auto !important; }
 .mb-sm-auto,
 .my-sm-auto {
   margin-bottom: auto !important; }
 .ml-sm-auto,
 .mx-sm-auto {
   margin-left: auto !important; } }
@media (min-width: 768px) {
 .m-md-0 {
   margin: 0 !important; }
 .mt-md-0,
 .my-md-0 {
   margin-top: 0 !important; }
 .mr-md-0,
 .mx-md-0 {
   margin-right: 0 !important; }
 .mb-md-0,
 .my-md-0 {
   margin-bottom: 0 !important; }
 .ml-md-0,
 .mx-md-0 {
   margin-left: 0 !important; }
 .m-md-1 {
   margin: 0.25rem !important; }
 .mt-md-1,
 .my-md-1 {
   margin-top: 0.25rem !important; }
 .mr-md-1,
 .mx-md-1 {
   margin-right: 0.25rem !important; }
 .mb-md-1,
 .my-md-1 {
   margin-bottom: 0.25rem !important; }
 .ml-md-1,
 .mx-md-1 {
   margin-left: 0.25rem !important; }
 .m-md-2 {
   margin: 0.5rem !important; }
 .mt-md-2,
 .my-md-2 {
   margin-top: 0.5rem !important; }
 .mr-md-2,
 .mx-md-2 {
   margin-right: 0.5rem !important; }
 .mb-md-2,
 .my-md-2 {
   margin-bottom: 0.5rem !important; }
 .ml-md-2,
 .mx-md-2 {
   margin-left: 0.5rem !important; }
 .m-md-3 {
   margin: 0.75rem !important; }
 .mt-md-3,
 .my-md-3 {
   margin-top: 0.75rem !important; }
 .mr-md-3,
 .mx-md-3 {
   margin-right: 0.75rem !important; }
 .mb-md-3,
 .my-md-3 {
   margin-bottom: 0.75rem !important; }
 .ml-md-3,
 .mx-md-3 {
   margin-left: 0.75rem !important; }
 .m-md-4 {
   margin: 1rem !important; }
 .mt-md-4,
 .my-md-4 {
   margin-top: 1rem !important; }
 .mr-md-4,
 .mx-md-4 {
   margin-right: 1rem !important; }
 .mb-md-4,
 .my-md-4 {
   margin-bottom: 1rem !important; }
 .ml-md-4,
 .mx-md-4 {
   margin-left: 1rem !important; }
 .m-md-5 {
   margin: 1.5rem !important; }
 .mt-md-5,
 .my-md-5 {
   margin-top: 1.5rem !important; }
 .mr-md-5,
 .mx-md-5 {
   margin-right: 1.5rem !important; }
 .mb-md-5,
 .my-md-5 {
   margin-bottom: 1.5rem !important; }
 .ml-md-5,
 .mx-md-5 {
   margin-left: 1.5rem !important; }
 .m-md-6 {
   margin: 2rem !important; }
 .mt-md-6,
 .my-md-6 {
   margin-top: 2rem !important; }
 .mr-md-6,
 .mx-md-6 {
   margin-right: 2rem !important; }
 .mb-md-6,
 .my-md-6 {
   margin-bottom: 2rem !important; }
 .ml-md-6,
 .mx-md-6 {
   margin-left: 2rem !important; }
 .m-md-7 {
   margin: 2.5rem !important; }
 .mt-md-7,
 .my-md-7 {
   margin-top: 2.5rem !important; }
 .mr-md-7,
 .mx-md-7 {
   margin-right: 2.5rem !important; }
 .mb-md-7,
 .my-md-7 {
   margin-bottom: 2.5rem !important; }
 .ml-md-7,
 .mx-md-7 {
   margin-left: 2.5rem !important; }
 .m-md-8 {
   margin: 3rem !important; }
 .mt-md-8,
 .my-md-8 {
   margin-top: 3rem !important; }
 .mr-md-8,
 .mx-md-8 {
   margin-right: 3rem !important; }
 .mb-md-8,
 .my-md-8 {
   margin-bottom: 3rem !important; }
 .ml-md-8,
 .mx-md-8 {
   margin-left: 3rem !important; }
 .m-md-9 {
   margin: 4rem !important; }
 .mt-md-9,
 .my-md-9 {
   margin-top: 4rem !important; }
 .mr-md-9,
 .mx-md-9 {
   margin-right: 4rem !important; }
 .mb-md-9,
 .my-md-9 {
   margin-bottom: 4rem !important; }
 .ml-md-9,
 .mx-md-9 {
   margin-left: 4rem !important; }
 .m-md-10 {
   margin: 5rem !important; }
 .mt-md-10,
 .my-md-10 {
   margin-top: 5rem !important; }
 .mr-md-10,
 .mx-md-10 {
   margin-right: 5rem !important; }
 .mb-md-10,
 .my-md-10 {
   margin-bottom: 5rem !important; }
 .ml-md-10,
 .mx-md-10 {
   margin-left: 5rem !important; }
 .m-md-11 {
   margin: 6rem !important; }
 .mt-md-11,
 .my-md-11 {
   margin-top: 6rem !important; }
 .mr-md-11,
 .mx-md-11 {
   margin-right: 6rem !important; }
 .mb-md-11,
 .my-md-11 {
   margin-bottom: 6rem !important; }
 .ml-md-11,
 .mx-md-11 {
   margin-left: 6rem !important; }
 .m-md-12 {
   margin: 8rem !important; }
 .mt-md-12,
 .my-md-12 {
   margin-top: 8rem !important; }
 .mr-md-12,
 .mx-md-12 {
   margin-right: 8rem !important; }
 .mb-md-12,
 .my-md-12 {
   margin-bottom: 8rem !important; }
 .ml-md-12,
 .mx-md-12 {
   margin-left: 8rem !important; }
 .m-md-13 {
   margin: 10rem !important; }
 .mt-md-13,
 .my-md-13 {
   margin-top: 10rem !important; }
 .mr-md-13,
 .mx-md-13 {
   margin-right: 10rem !important; }
 .mb-md-13,
 .my-md-13 {
   margin-bottom: 10rem !important; }
 .ml-md-13,
 .mx-md-13 {
   margin-left: 10rem !important; }
 .m-md-14 {
   margin: 12rem !important; }
 .mt-md-14,
 .my-md-14 {
   margin-top: 12rem !important; }
 .mr-md-14,
 .mx-md-14 {
   margin-right: 12rem !important; }
 .mb-md-14,
 .my-md-14 {
   margin-bottom: 12rem !important; }
 .ml-md-14,
 .mx-md-14 {
   margin-left: 12rem !important; }
 .m-md-15 {
   margin: 16rem !important; }
 .mt-md-15,
 .my-md-15 {
   margin-top: 16rem !important; }
 .mr-md-15,
 .mx-md-15 {
   margin-right: 16rem !important; }
 .mb-md-15,
 .my-md-15 {
   margin-bottom: 16rem !important; }
 .ml-md-15,
 .mx-md-15 {
   margin-left: 16rem !important; }
 .m-md-16 {
   margin: 25rem !important; }
 .mt-md-16,
 .my-md-16 {
   margin-top: 25rem !important; }
 .mr-md-16,
 .mx-md-16 {
   margin-right: 25rem !important; }
 .mb-md-16,
 .my-md-16 {
   margin-bottom: 25rem !important; }
 .ml-md-16,
 .mx-md-16 {
   margin-left: 25rem !important; }
 .p-md-0 {
   padding: 0 !important; }
 .pt-md-0,
 .py-md-0 {
   padding-top: 0 !important; }
 .pr-md-0,
 .px-md-0 {
   padding-right: 0 !important; }
 .pb-md-0,
 .py-md-0 {
   padding-bottom: 0 !important; }
 .pl-md-0,
 .px-md-0 {
   padding-left: 0 !important; }
 .p-md-1 {
   padding: 0.25rem !important; }
 .pt-md-1,
 .py-md-1 {
   padding-top: 0.25rem !important; }
 .pr-md-1,
 .px-md-1 {
   padding-right: 0.25rem !important; }
 .pb-md-1,
 .py-md-1 {
   padding-bottom: 0.25rem !important; }
 .pl-md-1,
 .px-md-1 {
   padding-left: 0.25rem !important; }
 .p-md-2 {
   padding: 0.5rem !important; }
 .pt-md-2,
 .py-md-2 {
   padding-top: 0.5rem !important; }
 .pr-md-2,
 .px-md-2 {
   padding-right: 0.5rem !important; }
 .pb-md-2,
 .py-md-2 {
   padding-bottom: 0.5rem !important; }
 .pl-md-2,
 .px-md-2 {
   padding-left: 0.5rem !important; }
 .p-md-3 {
   padding: 0.75rem !important; }
 .pt-md-3,
 .py-md-3 {
   padding-top: 0.75rem !important; }
 .pr-md-3,
 .px-md-3 {
   padding-right: 0.75rem !important; }
 .pb-md-3,
 .py-md-3 {
   padding-bottom: 0.75rem !important; }
 .pl-md-3,
 .px-md-3 {
   padding-left: 0.75rem !important; }
 .p-md-4 {
   padding: 1rem !important; }
 .pt-md-4,
 .py-md-4 {
   padding-top: 1rem !important; }
 .pr-md-4,
 .px-md-4 {
   padding-right: 1rem !important; }
 .pb-md-4,
 .py-md-4 {
   padding-bottom: 1rem !important; }
 .pl-md-4,
 .px-md-4 {
   padding-left: 1rem !important; }
 .p-md-5 {
   padding: 1.5rem !important; }
 .pt-md-5,
 .py-md-5 {
   padding-top: 1.5rem !important; }
 .pr-md-5,
 .px-md-5 {
   padding-right: 1.5rem !important; }
 .pb-md-5,
 .py-md-5 {
   padding-bottom: 1.5rem !important; }
 .pl-md-5,
 .px-md-5 {
   padding-left: 1.5rem !important; }
 .p-md-6 {
   padding: 2rem !important; }
 .pt-md-6,
 .py-md-6 {
   padding-top: 2rem !important; }
 .pr-md-6,
 .px-md-6 {
   padding-right: 2rem !important; }
 .pb-md-6,
 .py-md-6 {
   padding-bottom: 2rem !important; }
 .pl-md-6,
 .px-md-6 {
   padding-left: 2rem !important; }
 .p-md-7 {
   padding: 2.5rem !important; }
 .pt-md-7,
 .py-md-7 {
   padding-top: 2.5rem !important; }
 .pr-md-7,
 .px-md-7 {
   padding-right: 2.5rem !important; }
 .pb-md-7,
 .py-md-7 {
   padding-bottom: 2.5rem !important; }
 .pl-md-7,
 .px-md-7 {
   padding-left: 2.5rem !important; }
 .p-md-8 {
   padding: 3rem !important; }
 .pt-md-8,
 .py-md-8 {
   padding-top: 3rem !important; }
 .pr-md-8,
 .px-md-8 {
   padding-right: 3rem !important; }
 .pb-md-8,
 .py-md-8 {
   padding-bottom: 3rem !important; }
 .pl-md-8,
 .px-md-8 {
   padding-left: 3rem !important; }
 .p-md-9 {
   padding: 4rem !important; }
 .pt-md-9,
 .py-md-9 {
   padding-top: 4rem !important; }
 .pr-md-9,
 .px-md-9 {
   padding-right: 4rem !important; }
 .pb-md-9,
 .py-md-9 {
   padding-bottom: 4rem !important; }
 .pl-md-9,
 .px-md-9 {
   padding-left: 4rem !important; }
 .p-md-10 {
   padding: 5rem !important; }
 .pt-md-10,
 .py-md-10 {
   padding-top: 5rem !important; }
 .pr-md-10,
 .px-md-10 {
   padding-right: 5rem !important; }
 .pb-md-10,
 .py-md-10 {
   padding-bottom: 5rem !important; }
 .pl-md-10,
 .px-md-10 {
   padding-left: 5rem !important; }
 .p-md-11 {
   padding: 6rem !important; }
 .pt-md-11,
 .py-md-11 {
   padding-top: 6rem !important; }
 .pr-md-11,
 .px-md-11 {
   padding-right: 6rem !important; }
 .pb-md-11,
 .py-md-11 {
   padding-bottom: 6rem !important; }
 .pl-md-11,
 .px-md-11 {
   padding-left: 6rem !important; }
 .p-md-12 {
   padding: 8rem !important; }
 .pt-md-12,
 .py-md-12 {
   padding-top: 8rem !important; }
 .pr-md-12,
 .px-md-12 {
   padding-right: 8rem !important; }
 .pb-md-12,
 .py-md-12 {
   padding-bottom: 8rem !important; }
 .pl-md-12,
 .px-md-12 {
   padding-left: 8rem !important; }
 .p-md-13 {
   padding: 10rem !important; }
 .pt-md-13,
 .py-md-13 {
   padding-top: 10rem !important; }
 .pr-md-13,
 .px-md-13 {
   padding-right: 10rem !important; }
 .pb-md-13,
 .py-md-13 {
   padding-bottom: 10rem !important; }
 .pl-md-13,
 .px-md-13 {
   padding-left: 10rem !important; }
 .p-md-14 {
   padding: 12rem !important; }
 .pt-md-14,
 .py-md-14 {
   padding-top: 12rem !important; }
 .pr-md-14,
 .px-md-14 {
   padding-right: 12rem !important; }
 .pb-md-14,
 .py-md-14 {
   padding-bottom: 12rem !important; }
 .pl-md-14,
 .px-md-14 {
   padding-left: 12rem !important; }
 .p-md-15 {
   padding: 16rem !important; }
 .pt-md-15,
 .py-md-15 {
   padding-top: 16rem !important; }
 .pr-md-15,
 .px-md-15 {
   padding-right: 16rem !important; }
 .pb-md-15,
 .py-md-15 {
   padding-bottom: 16rem !important; }
 .pl-md-15,
 .px-md-15 {
   padding-left: 16rem !important; }
 .p-md-16 {
   padding: 25rem !important; }
 .pt-md-16,
 .py-md-16 {
   padding-top: 25rem !important; }
 .pr-md-16,
 .px-md-16 {
   padding-right: 25rem !important; }
 .pb-md-16,
 .py-md-16 {
   padding-bottom: 25rem !important; }
 .pl-md-16,
 .px-md-16 {
   padding-left: 25rem !important; }
 .m-md-n1 {
   margin: -0.25rem !important; }
 .mt-md-n1,
 .my-md-n1 {
   margin-top: -0.25rem !important; }
 .mr-md-n1,
 .mx-md-n1 {
   margin-right: -0.25rem !important; }
 .mb-md-n1,
 .my-md-n1 {
   margin-bottom: -0.25rem !important; }
 .ml-md-n1,
 .mx-md-n1 {
   margin-left: -0.25rem !important; }
 .m-md-n2 {
   margin: -0.5rem !important; }
 .mt-md-n2,
 .my-md-n2 {
   margin-top: -0.5rem !important; }
 .mr-md-n2,
 .mx-md-n2 {
   margin-right: -0.5rem !important; }
 .mb-md-n2,
 .my-md-n2 {
   margin-bottom: -0.5rem !important; }
 .ml-md-n2,
 .mx-md-n2 {
   margin-left: -0.5rem !important; }
 .m-md-n3 {
   margin: -0.75rem !important; }
 .mt-md-n3,
 .my-md-n3 {
   margin-top: -0.75rem !important; }
 .mr-md-n3,
 .mx-md-n3 {
   margin-right: -0.75rem !important; }
 .mb-md-n3,
 .my-md-n3 {
   margin-bottom: -0.75rem !important; }
 .ml-md-n3,
 .mx-md-n3 {
   margin-left: -0.75rem !important; }
 .m-md-n4 {
   margin: -1rem !important; }
 .mt-md-n4,
 .my-md-n4 {
   margin-top: -1rem !important; }
 .mr-md-n4,
 .mx-md-n4 {
   margin-right: -1rem !important; }
 .mb-md-n4,
 .my-md-n4 {
   margin-bottom: -1rem !important; }
 .ml-md-n4,
 .mx-md-n4 {
   margin-left: -1rem !important; }
 .m-md-n5 {
   margin: -1.5rem !important; }
 .mt-md-n5,
 .my-md-n5 {
   margin-top: -1.5rem !important; }
 .mr-md-n5,
 .mx-md-n5 {
   margin-right: -1.5rem !important; }
 .mb-md-n5,
 .my-md-n5 {
   margin-bottom: -1.5rem !important; }
 .ml-md-n5,
 .mx-md-n5 {
   margin-left: -1.5rem !important; }
 .m-md-n6 {
   margin: -2rem !important; }
 .mt-md-n6,
 .my-md-n6 {
   margin-top: -2rem !important; }
 .mr-md-n6,
 .mx-md-n6 {
   margin-right: -2rem !important; }
 .mb-md-n6,
 .my-md-n6 {
   margin-bottom: -2rem !important; }
 .ml-md-n6,
 .mx-md-n6 {
   margin-left: -2rem !important; }
 .m-md-n7 {
   margin: -2.5rem !important; }
 .mt-md-n7,
 .my-md-n7 {
   margin-top: -2.5rem !important; }
 .mr-md-n7,
 .mx-md-n7 {
   margin-right: -2.5rem !important; }
 .mb-md-n7,
 .my-md-n7 {
   margin-bottom: -2.5rem !important; }
 .ml-md-n7,
 .mx-md-n7 {
   margin-left: -2.5rem !important; }
 .m-md-n8 {
   margin: -3rem !important; }
 .mt-md-n8,
 .my-md-n8 {
   margin-top: -3rem !important; }
 .mr-md-n8,
 .mx-md-n8 {
   margin-right: -3rem !important; }
 .mb-md-n8,
 .my-md-n8 {
   margin-bottom: -3rem !important; }
 .ml-md-n8,
 .mx-md-n8 {
   margin-left: -3rem !important; }
 .m-md-n9 {
   margin: -4rem !important; }
 .mt-md-n9,
 .my-md-n9 {
   margin-top: -4rem !important; }
 .mr-md-n9,
 .mx-md-n9 {
   margin-right: -4rem !important; }
 .mb-md-n9,
 .my-md-n9 {
   margin-bottom: -4rem !important; }
 .ml-md-n9,
 .mx-md-n9 {
   margin-left: -4rem !important; }
 .m-md-n10 {
   margin: -5rem !important; }
 .mt-md-n10,
 .my-md-n10 {
   margin-top: -5rem !important; }
 .mr-md-n10,
 .mx-md-n10 {
   margin-right: -5rem !important; }
 .mb-md-n10,
 .my-md-n10 {
   margin-bottom: -5rem !important; }
 .ml-md-n10,
 .mx-md-n10 {
   margin-left: -5rem !important; }
 .m-md-n11 {
   margin: -6rem !important; }
 .mt-md-n11,
 .my-md-n11 {
   margin-top: -6rem !important; }
 .mr-md-n11,
 .mx-md-n11 {
   margin-right: -6rem !important; }
 .mb-md-n11,
 .my-md-n11 {
   margin-bottom: -6rem !important; }
 .ml-md-n11,
 .mx-md-n11 {
   margin-left: -6rem !important; }
 .m-md-n12 {
   margin: -8rem !important; }
 .mt-md-n12,
 .my-md-n12 {
   margin-top: -8rem !important; }
 .mr-md-n12,
 .mx-md-n12 {
   margin-right: -8rem !important; }
 .mb-md-n12,
 .my-md-n12 {
   margin-bottom: -8rem !important; }
 .ml-md-n12,
 .mx-md-n12 {
   margin-left: -8rem !important; }
 .m-md-n13 {
   margin: -10rem !important; }
 .mt-md-n13,
 .my-md-n13 {
   margin-top: -10rem !important; }
 .mr-md-n13,
 .mx-md-n13 {
   margin-right: -10rem !important; }
 .mb-md-n13,
 .my-md-n13 {
   margin-bottom: -10rem !important; }
 .ml-md-n13,
 .mx-md-n13 {
   margin-left: -10rem !important; }
 .m-md-n14 {
   margin: -12rem !important; }
 .mt-md-n14,
 .my-md-n14 {
   margin-top: -12rem !important; }
 .mr-md-n14,
 .mx-md-n14 {
   margin-right: -12rem !important; }
 .mb-md-n14,
 .my-md-n14 {
   margin-bottom: -12rem !important; }
 .ml-md-n14,
 .mx-md-n14 {
   margin-left: -12rem !important; }
 .m-md-n15 {
   margin: -16rem !important; }
 .mt-md-n15,
 .my-md-n15 {
   margin-top: -16rem !important; }
 .mr-md-n15,
 .mx-md-n15 {
   margin-right: -16rem !important; }
 .mb-md-n15,
 .my-md-n15 {
   margin-bottom: -16rem !important; }
 .ml-md-n15,
 .mx-md-n15 {
   margin-left: -16rem !important; }
 .m-md-n16 {
   margin: -25rem !important; }
 .mt-md-n16,
 .my-md-n16 {
   margin-top: -25rem !important; }
 .mr-md-n16,
 .mx-md-n16 {
   margin-right: -25rem !important; }
 .mb-md-n16,
 .my-md-n16 {
   margin-bottom: -25rem !important; }
 .ml-md-n16,
 .mx-md-n16 {
   margin-left: -25rem !important; }
 .m-md-auto {
   margin: auto !important; }
 .mt-md-auto,
 .my-md-auto {
   margin-top: auto !important; }
 .mr-md-auto,
 .mx-md-auto {
   margin-right: auto !important; }
 .mb-md-auto,
 .my-md-auto {
   margin-bottom: auto !important; }
 .ml-md-auto,
 .mx-md-auto {
   margin-left: auto !important; } }
@media (min-width: 992px) {
 .m-lg-0 {
   margin: 0 !important; }
 .mt-lg-0,
 .my-lg-0 {
   margin-top: 0 !important; }
 .mr-lg-0,
 .mx-lg-0 {
   margin-right: 0 !important; }
 .mb-lg-0,
 .my-lg-0 {
   margin-bottom: 0 !important; }
 .ml-lg-0,
 .mx-lg-0 {
   margin-left: 0 !important; }
 .m-lg-1 {
   margin: 0.25rem !important; }
 .mt-lg-1,
 .my-lg-1 {
   margin-top: 0.25rem !important; }
 .mr-lg-1,
 .mx-lg-1 {
   margin-right: 0.25rem !important; }
 .mb-lg-1,
 .my-lg-1 {
   margin-bottom: 0.25rem !important; }
 .ml-lg-1,
 .mx-lg-1 {
   margin-left: 0.25rem !important; }
 .m-lg-2 {
   margin: 0.5rem !important; }
 .mt-lg-2,
 .my-lg-2 {
   margin-top: 0.5rem !important; }
 .mr-lg-2,
 .mx-lg-2 {
   margin-right: 0.5rem !important; }
 .mb-lg-2,
 .my-lg-2 {
   margin-bottom: 0.5rem !important; }
 .ml-lg-2,
 .mx-lg-2 {
   margin-left: 0.5rem !important; }
 .m-lg-3 {
   margin: 0.75rem !important; }
 .mt-lg-3,
 .my-lg-3 {
   margin-top: 0.75rem !important; }
 .mr-lg-3,
 .mx-lg-3 {
   margin-right: 0.75rem !important; }
 .mb-lg-3,
 .my-lg-3 {
   margin-bottom: 0.75rem !important; }
 .ml-lg-3,
 .mx-lg-3 {
   margin-left: 0.75rem !important; }
 .m-lg-4 {
   margin: 1rem !important; }
 .mt-lg-4,
 .my-lg-4 {
   margin-top: 1rem !important; }
 .mr-lg-4,
 .mx-lg-4 {
   margin-right: 1rem !important; }
 .mb-lg-4,
 .my-lg-4 {
   margin-bottom: 1rem !important; }
 .ml-lg-4,
 .mx-lg-4 {
   margin-left: 1rem !important; }
 .m-lg-5 {
   margin: 1.5rem !important; }
 .mt-lg-5,
 .my-lg-5 {
   margin-top: 1.5rem !important; }
 .mr-lg-5,
 .mx-lg-5 {
   margin-right: 1.5rem !important; }
 .mb-lg-5,
 .my-lg-5 {
   margin-bottom: 1.5rem !important; }
 .ml-lg-5,
 .mx-lg-5 {
   margin-left: 1.5rem !important; }
 .m-lg-6 {
   margin: 2rem !important; }
 .mt-lg-6,
 .my-lg-6 {
   margin-top: 2rem !important; }
 .mr-lg-6,
 .mx-lg-6 {
   margin-right: 2rem !important; }
 .mb-lg-6,
 .my-lg-6 {
   margin-bottom: 2rem !important; }
 .ml-lg-6,
 .mx-lg-6 {
   margin-left: 2rem !important; }
 .m-lg-7 {
   margin: 2.5rem !important; }
 .mt-lg-7,
 .my-lg-7 {
   margin-top: 2.5rem !important; }
 .mr-lg-7,
 .mx-lg-7 {
   margin-right: 2.5rem !important; }
 .mb-lg-7,
 .my-lg-7 {
   margin-bottom: 2.5rem !important; }
 .ml-lg-7,
 .mx-lg-7 {
   margin-left: 2.5rem !important; }
 .m-lg-8 {
   margin: 3rem !important; }
 .mt-lg-8,
 .my-lg-8 {
   margin-top: 3rem !important; }
 .mr-lg-8,
 .mx-lg-8 {
   margin-right: 3rem !important; }
 .mb-lg-8,
 .my-lg-8 {
   margin-bottom: 3rem !important; }
 .ml-lg-8,
 .mx-lg-8 {
   margin-left: 3rem !important; }
 .m-lg-9 {
   margin: 4rem !important; }
 .mt-lg-9,
 .my-lg-9 {
   margin-top: 4rem !important; }
 .mr-lg-9,
 .mx-lg-9 {
   margin-right: 4rem !important; }
 .mb-lg-9,
 .my-lg-9 {
   margin-bottom: 4rem !important; }
 .ml-lg-9,
 .mx-lg-9 {
   margin-left: 4rem !important; }
 .m-lg-10 {
   margin: 5rem !important; }
 .mt-lg-10,
 .my-lg-10 {
   margin-top: 5rem !important; }
 .mr-lg-10,
 .mx-lg-10 {
   margin-right: 5rem !important; }
 .mb-lg-10,
 .my-lg-10 {
   margin-bottom: 5rem !important; }
 .ml-lg-10,
 .mx-lg-10 {
   margin-left: 5rem !important; }
 .m-lg-11 {
   margin: 6rem !important; }
 .mt-lg-11,
 .my-lg-11 {
   margin-top: 6rem !important; }
 .mr-lg-11,
 .mx-lg-11 {
   margin-right: 6rem !important; }
 .mb-lg-11,
 .my-lg-11 {
   margin-bottom: 6rem !important; }
 .ml-lg-11,
 .mx-lg-11 {
   margin-left: 6rem !important; }
 .m-lg-12 {
   margin: 8rem !important; }
 .mt-lg-12,
 .my-lg-12 {
   margin-top: 8rem !important; }
 .mr-lg-12,
 .mx-lg-12 {
   margin-right: 8rem !important; }
 .mb-lg-12,
 .my-lg-12 {
   margin-bottom: 8rem !important; }
 .ml-lg-12,
 .mx-lg-12 {
   margin-left: 8rem !important; }
 .m-lg-13 {
   margin: 10rem !important; }
 .mt-lg-13,
 .my-lg-13 {
   margin-top: 10rem !important; }
 .mr-lg-13,
 .mx-lg-13 {
   margin-right: 10rem !important; }
 .mb-lg-13,
 .my-lg-13 {
   margin-bottom: 10rem !important; }
 .ml-lg-13,
 .mx-lg-13 {
   margin-left: 10rem !important; }
 .m-lg-14 {
   margin: 12rem !important; }
 .mt-lg-14,
 .my-lg-14 {
   margin-top: 12rem !important; }
 .mr-lg-14,
 .mx-lg-14 {
   margin-right: 12rem !important; }
 .mb-lg-14,
 .my-lg-14 {
   margin-bottom: 12rem !important; }
 .ml-lg-14,
 .mx-lg-14 {
   margin-left: 12rem !important; }
 .m-lg-15 {
   margin: 16rem !important; }
 .mt-lg-15,
 .my-lg-15 {
   margin-top: 16rem !important; }
 .mr-lg-15,
 .mx-lg-15 {
   margin-right: 16rem !important; }
 .mb-lg-15,
 .my-lg-15 {
   margin-bottom: 16rem !important; }
 .ml-lg-15,
 .mx-lg-15 {
   margin-left: 16rem !important; }
 .m-lg-16 {
   margin: 25rem !important; }
 .mt-lg-16,
 .my-lg-16 {
   margin-top: 25rem !important; }
 .mr-lg-16,
 .mx-lg-16 {
   margin-right: 25rem !important; }
 .mb-lg-16,
 .my-lg-16 {
   margin-bottom: 25rem !important; }
 .ml-lg-16,
 .mx-lg-16 {
   margin-left: 25rem !important; }
 .p-lg-0 {
   padding: 0 !important; }
 .pt-lg-0,
 .py-lg-0 {
   padding-top: 0 !important; }
 .pr-lg-0,
 .px-lg-0 {
   padding-right: 0 !important; }
 .pb-lg-0,
 .py-lg-0 {
   padding-bottom: 0 !important; }
 .pl-lg-0,
 .px-lg-0 {
   padding-left: 0 !important; }
 .p-lg-1 {
   padding: 0.25rem !important; }
 .pt-lg-1,
 .py-lg-1 {
   padding-top: 0.25rem !important; }
 .pr-lg-1,
 .px-lg-1 {
   padding-right: 0.25rem !important; }
 .pb-lg-1,
 .py-lg-1 {
   padding-bottom: 0.25rem !important; }
 .pl-lg-1,
 .px-lg-1 {
   padding-left: 0.25rem !important; }
 .p-lg-2 {
   padding: 0.5rem !important; }
 .pt-lg-2,
 .py-lg-2 {
   padding-top: 0.5rem !important; }
 .pr-lg-2,
 .px-lg-2 {
   padding-right: 0.5rem !important; }
 .pb-lg-2,
 .py-lg-2 {
   padding-bottom: 0.5rem !important; }
 .pl-lg-2,
 .px-lg-2 {
   padding-left: 0.5rem !important; }
 .p-lg-3 {
   padding: 0.75rem !important; }
 .pt-lg-3,
 .py-lg-3 {
   padding-top: 0.75rem !important; }
 .pr-lg-3,
 .px-lg-3 {
   padding-right: 0.75rem !important; }
 .pb-lg-3,
 .py-lg-3 {
   padding-bottom: 0.75rem !important; }
 .pl-lg-3,
 .px-lg-3 {
   padding-left: 0.75rem !important; }
 .p-lg-4 {
   padding: 1rem !important; }
 .pt-lg-4,
 .py-lg-4 {
   padding-top: 1rem !important; }
 .pr-lg-4,
 .px-lg-4 {
   padding-right: 1rem !important; }
 .pb-lg-4,
 .py-lg-4 {
   padding-bottom: 1rem !important; }
 .pl-lg-4,
 .px-lg-4 {
   padding-left: 1rem !important; }
 .p-lg-5 {
   padding: 1.5rem !important; }
 .pt-lg-5,
 .py-lg-5 {
   padding-top: 1.5rem !important; }
 .pr-lg-5,
 .px-lg-5 {
   padding-right: 1.5rem !important; }
 .pb-lg-5,
 .py-lg-5 {
   padding-bottom: 1.5rem !important; }
 .pl-lg-5,
 .px-lg-5 {
   padding-left: 1.5rem !important; }
 .p-lg-6 {
   padding: 2rem !important; }
 .pt-lg-6,
 .py-lg-6 {
   padding-top: 2rem !important; }
 .pr-lg-6,
 .px-lg-6 {
   padding-right: 2rem !important; }
 .pb-lg-6,
 .py-lg-6 {
   padding-bottom: 2rem !important; }
 .pl-lg-6,
 .px-lg-6 {
   padding-left: 2rem !important; }
 .p-lg-7 {
   padding: 2.5rem !important; }
 .pt-lg-7,
 .py-lg-7 {
   padding-top: 2.5rem !important; }
 .pr-lg-7,
 .px-lg-7 {
   padding-right: 2.5rem !important; }
 .pb-lg-7,
 .py-lg-7 {
   padding-bottom: 2.5rem !important; }
 .pl-lg-7,
 .px-lg-7 {
   padding-left: 2.5rem !important; }
 .p-lg-8 {
   padding: 3rem !important; }
 .pt-lg-8,
 .py-lg-8 {
   padding-top: 3rem !important; }
 .pr-lg-8,
 .px-lg-8 {
   padding-right: 3rem !important; }
 .pb-lg-8,
 .py-lg-8 {
   padding-bottom: 3rem !important; }
 .pl-lg-8,
 .px-lg-8 {
   padding-left: 3rem !important; }
 .p-lg-9 {
   padding: 4rem !important; }
 .pt-lg-9,
 .py-lg-9 {
   padding-top: 4rem !important; }
 .pr-lg-9,
 .px-lg-9 {
   padding-right: 4rem !important; }
 .pb-lg-9,
 .py-lg-9 {
   padding-bottom: 4rem !important; }
 .pl-lg-9,
 .px-lg-9 {
   padding-left: 4rem !important; }
 .p-lg-10 {
   padding: 5rem !important; }
 .pt-lg-10,
 .py-lg-10 {
   padding-top: 5rem !important; }
 .pr-lg-10,
 .px-lg-10 {
   padding-right: 5rem !important; }
 .pb-lg-10,
 .py-lg-10 {
   padding-bottom: 5rem !important; }
 .pl-lg-10,
 .px-lg-10 {
   padding-left: 5rem !important; }
 .p-lg-11 {
   padding: 6rem !important; }
 .pt-lg-11,
 .py-lg-11 {
   padding-top: 6rem !important; }
 .pr-lg-11,
 .px-lg-11 {
   padding-right: 6rem !important; }
 .pb-lg-11,
 .py-lg-11 {
   padding-bottom: 6rem !important; }
 .pl-lg-11,
 .px-lg-11 {
   padding-left: 6rem !important; }
 .p-lg-12 {
   padding: 8rem !important; }
 .pt-lg-12,
 .py-lg-12 {
   padding-top: 8rem !important; }
 .pr-lg-12,
 .px-lg-12 {
   padding-right: 8rem !important; }
 .pb-lg-12,
 .py-lg-12 {
   padding-bottom: 8rem !important; }
 .pl-lg-12,
 .px-lg-12 {
   padding-left: 8rem !important; }
 .p-lg-13 {
   padding: 10rem !important; }
 .pt-lg-13,
 .py-lg-13 {
   padding-top: 10rem !important; }
 .pr-lg-13,
 .px-lg-13 {
   padding-right: 10rem !important; }
 .pb-lg-13,
 .py-lg-13 {
   padding-bottom: 10rem !important; }
 .pl-lg-13,
 .px-lg-13 {
   padding-left: 10rem !important; }
 .p-lg-14 {
   padding: 12rem !important; }
 .pt-lg-14,
 .py-lg-14 {
   padding-top: 12rem !important; }
 .pr-lg-14,
 .px-lg-14 {
   padding-right: 12rem !important; }
 .pb-lg-14,
 .py-lg-14 {
   padding-bottom: 12rem !important; }
 .pl-lg-14,
 .px-lg-14 {
   padding-left: 12rem !important; }
 .p-lg-15 {
   padding: 16rem !important; }
 .pt-lg-15,
 .py-lg-15 {
   padding-top: 16rem !important; }
 .pr-lg-15,
 .px-lg-15 {
   padding-right: 16rem !important; }
 .pb-lg-15,
 .py-lg-15 {
   padding-bottom: 16rem !important; }
 .pl-lg-15,
 .px-lg-15 {
   padding-left: 16rem !important; }
 .p-lg-16 {
   padding: 25rem !important; }
 .pt-lg-16,
 .py-lg-16 {
   padding-top: 25rem !important; }
 .pr-lg-16,
 .px-lg-16 {
   padding-right: 25rem !important; }
 .pb-lg-16,
 .py-lg-16 {
   padding-bottom: 25rem !important; }
 .pl-lg-16,
 .px-lg-16 {
   padding-left: 25rem !important; }
 .m-lg-n1 {
   margin: -0.25rem !important; }
 .mt-lg-n1,
 .my-lg-n1 {
   margin-top: -0.25rem !important; }
 .mr-lg-n1,
 .mx-lg-n1 {
   margin-right: -0.25rem !important; }
 .mb-lg-n1,
 .my-lg-n1 {
   margin-bottom: -0.25rem !important; }
 .ml-lg-n1,
 .mx-lg-n1 {
   margin-left: -0.25rem !important; }
 .m-lg-n2 {
   margin: -0.5rem !important; }
 .mt-lg-n2,
 .my-lg-n2 {
   margin-top: -0.5rem !important; }
 .mr-lg-n2,
 .mx-lg-n2 {
   margin-right: -0.5rem !important; }
 .mb-lg-n2,
 .my-lg-n2 {
   margin-bottom: -0.5rem !important; }
 .ml-lg-n2,
 .mx-lg-n2 {
   margin-left: -0.5rem !important; }
 .m-lg-n3 {
   margin: -0.75rem !important; }
 .mt-lg-n3,
 .my-lg-n3 {
   margin-top: -0.75rem !important; }
 .mr-lg-n3,
 .mx-lg-n3 {
   margin-right: -0.75rem !important; }
 .mb-lg-n3,
 .my-lg-n3 {
   margin-bottom: -0.75rem !important; }
 .ml-lg-n3,
 .mx-lg-n3 {
   margin-left: -0.75rem !important; }
 .m-lg-n4 {
   margin: -1rem !important; }
 .mt-lg-n4,
 .my-lg-n4 {
   margin-top: -1rem !important; }
 .mr-lg-n4,
 .mx-lg-n4 {
   margin-right: -1rem !important; }
 .mb-lg-n4,
 .my-lg-n4 {
   margin-bottom: -1rem !important; }
 .ml-lg-n4,
 .mx-lg-n4 {
   margin-left: -1rem !important; }
 .m-lg-n5 {
   margin: -1.5rem !important; }
 .mt-lg-n5,
 .my-lg-n5 {
   margin-top: -1.5rem !important; }
 .mr-lg-n5,
 .mx-lg-n5 {
   margin-right: -1.5rem !important; }
 .mb-lg-n5,
 .my-lg-n5 {
   margin-bottom: -1.5rem !important; }
 .ml-lg-n5,
 .mx-lg-n5 {
   margin-left: -1.5rem !important; }
 .m-lg-n6 {
   margin: -2rem !important; }
 .mt-lg-n6,
 .my-lg-n6 {
   margin-top: -2rem !important; }
 .mr-lg-n6,
 .mx-lg-n6 {
   margin-right: -2rem !important; }
 .mb-lg-n6,
 .my-lg-n6 {
   margin-bottom: -2rem !important; }
 .ml-lg-n6,
 .mx-lg-n6 {
   margin-left: -2rem !important; }
 .m-lg-n7 {
   margin: -2.5rem !important; }
 .mt-lg-n7,
 .my-lg-n7 {
   margin-top: -2.5rem !important; }
 .mr-lg-n7,
 .mx-lg-n7 {
   margin-right: -2.5rem !important; }
 .mb-lg-n7,
 .my-lg-n7 {
   margin-bottom: -2.5rem !important; }
 .ml-lg-n7,
 .mx-lg-n7 {
   margin-left: -2.5rem !important; }
 .m-lg-n8 {
   margin: -3rem !important; }
 .mt-lg-n8,
 .my-lg-n8 {
   margin-top: -3rem !important; }
 .mr-lg-n8,
 .mx-lg-n8 {
   margin-right: -3rem !important; }
 .mb-lg-n8,
 .my-lg-n8 {
   margin-bottom: -3rem !important; }
 .ml-lg-n8,
 .mx-lg-n8 {
   margin-left: -3rem !important; }
 .m-lg-n9 {
   margin: -4rem !important; }
 .mt-lg-n9,
 .my-lg-n9 {
   margin-top: -4rem !important; }
 .mr-lg-n9,
 .mx-lg-n9 {
   margin-right: -4rem !important; }
 .mb-lg-n9,
 .my-lg-n9 {
   margin-bottom: -4rem !important; }
 .ml-lg-n9,
 .mx-lg-n9 {
   margin-left: -4rem !important; }
 .m-lg-n10 {
   margin: -5rem !important; }
 .mt-lg-n10,
 .my-lg-n10 {
   margin-top: -5rem !important; }
 .mr-lg-n10,
 .mx-lg-n10 {
   margin-right: -5rem !important; }
 .mb-lg-n10,
 .my-lg-n10 {
   margin-bottom: -5rem !important; }
 .ml-lg-n10,
 .mx-lg-n10 {
   margin-left: -5rem !important; }
 .m-lg-n11 {
   margin: -6rem !important; }
 .mt-lg-n11,
 .my-lg-n11 {
   margin-top: -6rem !important; }
 .mr-lg-n11,
 .mx-lg-n11 {
   margin-right: -6rem !important; }
 .mb-lg-n11,
 .my-lg-n11 {
   margin-bottom: -6rem !important; }
 .ml-lg-n11,
 .mx-lg-n11 {
   margin-left: -6rem !important; }
 .m-lg-n12 {
   margin: -8rem !important; }
 .mt-lg-n12,
 .my-lg-n12 {
   margin-top: -8rem !important; }
 .mr-lg-n12,
 .mx-lg-n12 {
   margin-right: -8rem !important; }
 .mb-lg-n12,
 .my-lg-n12 {
   margin-bottom: -8rem !important; }
 .ml-lg-n12,
 .mx-lg-n12 {
   margin-left: -8rem !important; }
 .m-lg-n13 {
   margin: -10rem !important; }
 .mt-lg-n13,
 .my-lg-n13 {
   margin-top: -10rem !important; }
 .mr-lg-n13,
 .mx-lg-n13 {
   margin-right: -10rem !important; }
 .mb-lg-n13,
 .my-lg-n13 {
   margin-bottom: -10rem !important; }
 .ml-lg-n13,
 .mx-lg-n13 {
   margin-left: -10rem !important; }
 .m-lg-n14 {
   margin: -12rem !important; }
 .mt-lg-n14,
 .my-lg-n14 {
   margin-top: -12rem !important; }
 .mr-lg-n14,
 .mx-lg-n14 {
   margin-right: -12rem !important; }
 .mb-lg-n14,
 .my-lg-n14 {
   margin-bottom: -12rem !important; }
 .ml-lg-n14,
 .mx-lg-n14 {
   margin-left: -12rem !important; }
 .m-lg-n15 {
   margin: -16rem !important; }
 .mt-lg-n15,
 .my-lg-n15 {
   margin-top: -16rem !important; }
 .mr-lg-n15,
 .mx-lg-n15 {
   margin-right: -16rem !important; }
 .mb-lg-n15,
 .my-lg-n15 {
   margin-bottom: -16rem !important; }
 .ml-lg-n15,
 .mx-lg-n15 {
   margin-left: -16rem !important; }
 .m-lg-n16 {
   margin: -25rem !important; }
 .mt-lg-n16,
 .my-lg-n16 {
   margin-top: -25rem !important; }
 .mr-lg-n16,
 .mx-lg-n16 {
   margin-right: -25rem !important; }
 .mb-lg-n16,
 .my-lg-n16 {
   margin-bottom: -25rem !important; }
 .ml-lg-n16,
 .mx-lg-n16 {
   margin-left: -25rem !important; }
 .m-lg-auto {
   margin: auto !important; }
 .mt-lg-auto,
 .my-lg-auto {
   margin-top: auto !important; }
 .mr-lg-auto,
 .mx-lg-auto {
   margin-right: auto !important; }
 .mb-lg-auto,
 .my-lg-auto {
   margin-bottom: auto !important; }
 .ml-lg-auto,
 .mx-lg-auto {
   margin-left: auto !important; } }
@media (min-width: 1200px) {
 .m-xl-0 {
   margin: 0 !important; }
 .mt-xl-0,
 .my-xl-0 {
   margin-top: 0 !important; }
 .mr-xl-0,
 .mx-xl-0 {
   margin-right: 0 !important; }
 .mb-xl-0,
 .my-xl-0 {
   margin-bottom: 0 !important; }
 .ml-xl-0,
 .mx-xl-0 {
   margin-left: 0 !important; }
 .m-xl-1 {
   margin: 0.25rem !important; }
 .mt-xl-1,
 .my-xl-1 {
   margin-top: 0.25rem !important; }
 .mr-xl-1,
 .mx-xl-1 {
   margin-right: 0.25rem !important; }
 .mb-xl-1,
 .my-xl-1 {
   margin-bottom: 0.25rem !important; }
 .ml-xl-1,
 .mx-xl-1 {
   margin-left: 0.25rem !important; }
 .m-xl-2 {
   margin: 0.5rem !important; }
 .mt-xl-2,
 .my-xl-2 {
   margin-top: 0.5rem !important; }
 .mr-xl-2,
 .mx-xl-2 {
   margin-right: 0.5rem !important; }
 .mb-xl-2,
 .my-xl-2 {
   margin-bottom: 0.5rem !important; }
 .ml-xl-2,
 .mx-xl-2 {
   margin-left: 0.5rem !important; }
 .m-xl-3 {
   margin: 0.75rem !important; }
 .mt-xl-3,
 .my-xl-3 {
   margin-top: 0.75rem !important; }
 .mr-xl-3,
 .mx-xl-3 {
   margin-right: 0.75rem !important; }
 .mb-xl-3,
 .my-xl-3 {
   margin-bottom: 0.75rem !important; }
 .ml-xl-3,
 .mx-xl-3 {
   margin-left: 0.75rem !important; }
 .m-xl-4 {
   margin: 1rem !important; }
 .mt-xl-4,
 .my-xl-4 {
   margin-top: 1rem !important; }
 .mr-xl-4,
 .mx-xl-4 {
   margin-right: 1rem !important; }
 .mb-xl-4,
 .my-xl-4 {
   margin-bottom: 1rem !important; }
 .ml-xl-4,
 .mx-xl-4 {
   margin-left: 1rem !important; }
 .m-xl-5 {
   margin: 1.5rem !important; }
 .mt-xl-5,
 .my-xl-5 {
   margin-top: 1.5rem !important; }
 .mr-xl-5,
 .mx-xl-5 {
   margin-right: 1.5rem !important; }
 .mb-xl-5,
 .my-xl-5 {
   margin-bottom: 1.5rem !important; }
 .ml-xl-5,
 .mx-xl-5 {
   margin-left: 1.5rem !important; }
 .m-xl-6 {
   margin: 2rem !important; }
 .mt-xl-6,
 .my-xl-6 {
   margin-top: 2rem !important; }
 .mr-xl-6,
 .mx-xl-6 {
   margin-right: 2rem !important; }
 .mb-xl-6,
 .my-xl-6 {
   margin-bottom: 2rem !important; }
 .ml-xl-6,
 .mx-xl-6 {
   margin-left: 2rem !important; }
 .m-xl-7 {
   margin: 2.5rem !important; }
 .mt-xl-7,
 .my-xl-7 {
   margin-top: 2.5rem !important; }
 .mr-xl-7,
 .mx-xl-7 {
   margin-right: 2.5rem !important; }
 .mb-xl-7,
 .my-xl-7 {
   margin-bottom: 2.5rem !important; }
 .ml-xl-7,
 .mx-xl-7 {
   margin-left: 2.5rem !important; }
 .m-xl-8 {
   margin: 3rem !important; }
 .mt-xl-8,
 .my-xl-8 {
   margin-top: 3rem !important; }
 .mr-xl-8,
 .mx-xl-8 {
   margin-right: 3rem !important; }
 .mb-xl-8,
 .my-xl-8 {
   margin-bottom: 3rem !important; }
 .ml-xl-8,
 .mx-xl-8 {
   margin-left: 3rem !important; }
 .m-xl-9 {
   margin: 4rem !important; }
 .mt-xl-9,
 .my-xl-9 {
   margin-top: 4rem !important; }
 .mr-xl-9,
 .mx-xl-9 {
   margin-right: 4rem !important; }
 .mb-xl-9,
 .my-xl-9 {
   margin-bottom: 4rem !important; }
 .ml-xl-9,
 .mx-xl-9 {
   margin-left: 4rem !important; }
 .m-xl-10 {
   margin: 5rem !important; }
 .mt-xl-10,
 .my-xl-10 {
   margin-top: 5rem !important; }
 .mr-xl-10,
 .mx-xl-10 {
   margin-right: 5rem !important; }
 .mb-xl-10,
 .my-xl-10 {
   margin-bottom: 5rem !important; }
 .ml-xl-10,
 .mx-xl-10 {
   margin-left: 5rem !important; }
 .m-xl-11 {
   margin: 6rem !important; }
 .mt-xl-11,
 .my-xl-11 {
   margin-top: 6rem !important; }
 .mr-xl-11,
 .mx-xl-11 {
   margin-right: 6rem !important; }
 .mb-xl-11,
 .my-xl-11 {
   margin-bottom: 6rem !important; }
 .ml-xl-11,
 .mx-xl-11 {
   margin-left: 6rem !important; }
 .m-xl-12 {
   margin: 8rem !important; }
 .mt-xl-12,
 .my-xl-12 {
   margin-top: 8rem !important; }
 .mr-xl-12,
 .mx-xl-12 {
   margin-right: 8rem !important; }
 .mb-xl-12,
 .my-xl-12 {
   margin-bottom: 8rem !important; }
 .ml-xl-12,
 .mx-xl-12 {
   margin-left: 8rem !important; }
 .m-xl-13 {
   margin: 10rem !important; }
 .mt-xl-13,
 .my-xl-13 {
   margin-top: 10rem !important; }
 .mr-xl-13,
 .mx-xl-13 {
   margin-right: 10rem !important; }
 .mb-xl-13,
 .my-xl-13 {
   margin-bottom: 10rem !important; }
 .ml-xl-13,
 .mx-xl-13 {
   margin-left: 10rem !important; }
 .m-xl-14 {
   margin: 12rem !important; }
 .mt-xl-14,
 .my-xl-14 {
   margin-top: 12rem !important; }
 .mr-xl-14,
 .mx-xl-14 {
   margin-right: 12rem !important; }
 .mb-xl-14,
 .my-xl-14 {
   margin-bottom: 12rem !important; }
 .ml-xl-14,
 .mx-xl-14 {
   margin-left: 12rem !important; }
 .m-xl-15 {
   margin: 16rem !important; }
 .mt-xl-15,
 .my-xl-15 {
   margin-top: 16rem !important; }
 .mr-xl-15,
 .mx-xl-15 {
   margin-right: 16rem !important; }
 .mb-xl-15,
 .my-xl-15 {
   margin-bottom: 16rem !important; }
 .ml-xl-15,
 .mx-xl-15 {
   margin-left: 16rem !important; }
 .m-xl-16 {
   margin: 25rem !important; }
 .mt-xl-16,
 .my-xl-16 {
   margin-top: 25rem !important; }
 .mr-xl-16,
 .mx-xl-16 {
   margin-right: 25rem !important; }
 .mb-xl-16,
 .my-xl-16 {
   margin-bottom: 25rem !important; }
 .ml-xl-16,
 .mx-xl-16 {
   margin-left: 25rem !important; }
 .p-xl-0 {
   padding: 0 !important; }
 .pt-xl-0,
 .py-xl-0 {
   padding-top: 0 !important; }
 .pr-xl-0,
 .px-xl-0 {
   padding-right: 0 !important; }
 .pb-xl-0,
 .py-xl-0 {
   padding-bottom: 0 !important; }
 .pl-xl-0,
 .px-xl-0 {
   padding-left: 0 !important; }
 .p-xl-1 {
   padding: 0.25rem !important; }
 .pt-xl-1,
 .py-xl-1 {
   padding-top: 0.25rem !important; }
 .pr-xl-1,
 .px-xl-1 {
   padding-right: 0.25rem !important; }
 .pb-xl-1,
 .py-xl-1 {
   padding-bottom: 0.25rem !important; }
 .pl-xl-1,
 .px-xl-1 {
   padding-left: 0.25rem !important; }
 .p-xl-2 {
   padding: 0.5rem !important; }
 .pt-xl-2,
 .py-xl-2 {
   padding-top: 0.5rem !important; }
 .pr-xl-2,
 .px-xl-2 {
   padding-right: 0.5rem !important; }
 .pb-xl-2,
 .py-xl-2 {
   padding-bottom: 0.5rem !important; }
 .pl-xl-2,
 .px-xl-2 {
   padding-left: 0.5rem !important; }
 .p-xl-3 {
   padding: 0.75rem !important; }
 .pt-xl-3,
 .py-xl-3 {
   padding-top: 0.75rem !important; }
 .pr-xl-3,
 .px-xl-3 {
   padding-right: 0.75rem !important; }
 .pb-xl-3,
 .py-xl-3 {
   padding-bottom: 0.75rem !important; }
 .pl-xl-3,
 .px-xl-3 {
   padding-left: 0.75rem !important; }
 .p-xl-4 {
   padding: 1rem !important; }
 .pt-xl-4,
 .py-xl-4 {
   padding-top: 1rem !important; }
 .pr-xl-4,
 .px-xl-4 {
   padding-right: 1rem !important; }
 .pb-xl-4,
 .py-xl-4 {
   padding-bottom: 1rem !important; }
 .pl-xl-4,
 .px-xl-4 {
   padding-left: 1rem !important; }
 .p-xl-5 {
   padding: 1.5rem !important; }
 .pt-xl-5,
 .py-xl-5 {
   padding-top: 1.5rem !important; }
 .pr-xl-5,
 .px-xl-5 {
   padding-right: 1.5rem !important; }
 .pb-xl-5,
 .py-xl-5 {
   padding-bottom: 1.5rem !important; }
 .pl-xl-5,
 .px-xl-5 {
   padding-left: 1.5rem !important; }
 .p-xl-6 {
   padding: 2rem !important; }
 .pt-xl-6,
 .py-xl-6 {
   padding-top: 2rem !important; }
 .pr-xl-6,
 .px-xl-6 {
   padding-right: 2rem !important; }
 .pb-xl-6,
 .py-xl-6 {
   padding-bottom: 2rem !important; }
 .pl-xl-6,
 .px-xl-6 {
   padding-left: 2rem !important; }
 .p-xl-7 {
   padding: 2.5rem !important; }
 .pt-xl-7,
 .py-xl-7 {
   padding-top: 2.5rem !important; }
 .pr-xl-7,
 .px-xl-7 {
   padding-right: 2.5rem !important; }
 .pb-xl-7,
 .py-xl-7 {
   padding-bottom: 2.5rem !important; }
 .pl-xl-7,
 .px-xl-7 {
   padding-left: 2.5rem !important; }
 .p-xl-8 {
   padding: 3rem !important; }
 .pt-xl-8,
 .py-xl-8 {
   padding-top: 3rem !important; }
 .pr-xl-8,
 .px-xl-8 {
   padding-right: 3rem !important; }
 .pb-xl-8,
 .py-xl-8 {
   padding-bottom: 3rem !important; }
 .pl-xl-8,
 .px-xl-8 {
   padding-left: 3rem !important; }
 .p-xl-9 {
   padding: 4rem !important; }
 .pt-xl-9,
 .py-xl-9 {
   padding-top: 4rem !important; }
 .pr-xl-9,
 .px-xl-9 {
   padding-right: 4rem !important; }
 .pb-xl-9,
 .py-xl-9 {
   padding-bottom: 4rem !important; }
 .pl-xl-9,
 .px-xl-9 {
   padding-left: 4rem !important; }
 .p-xl-10 {
   padding: 5rem !important; }
 .pt-xl-10,
 .py-xl-10 {
   padding-top: 5rem !important; }
 .pr-xl-10,
 .px-xl-10 {
   padding-right: 5rem !important; }
 .pb-xl-10,
 .py-xl-10 {
   padding-bottom: 5rem !important; }
 .pl-xl-10,
 .px-xl-10 {
   padding-left: 5rem !important; }
 .p-xl-11 {
   padding: 6rem !important; }
 .pt-xl-11,
 .py-xl-11 {
   padding-top: 6rem !important; }
 .pr-xl-11,
 .px-xl-11 {
   padding-right: 6rem !important; }
 .pb-xl-11,
 .py-xl-11 {
   padding-bottom: 6rem !important; }
 .pl-xl-11,
 .px-xl-11 {
   padding-left: 6rem !important; }
 .p-xl-12 {
   padding: 8rem !important; }
 .pt-xl-12,
 .py-xl-12 {
   padding-top: 8rem !important; }
 .pr-xl-12,
 .px-xl-12 {
   padding-right: 8rem !important; }
 .pb-xl-12,
 .py-xl-12 {
   padding-bottom: 8rem !important; }
 .pl-xl-12,
 .px-xl-12 {
   padding-left: 8rem !important; }
 .p-xl-13 {
   padding: 10rem !important; }
 .pt-xl-13,
 .py-xl-13 {
   padding-top: 10rem !important; }
 .pr-xl-13,
 .px-xl-13 {
   padding-right: 10rem !important; }
 .pb-xl-13,
 .py-xl-13 {
   padding-bottom: 10rem !important; }
 .pl-xl-13,
 .px-xl-13 {
   padding-left: 10rem !important; }
 .p-xl-14 {
   padding: 12rem !important; }
 .pt-xl-14,
 .py-xl-14 {
   padding-top: 12rem !important; }
 .pr-xl-14,
 .px-xl-14 {
   padding-right: 12rem !important; }
 .pb-xl-14,
 .py-xl-14 {
   padding-bottom: 12rem !important; }
 .pl-xl-14,
 .px-xl-14 {
   padding-left: 12rem !important; }
 .p-xl-15 {
   padding: 16rem !important; }
 .pt-xl-15,
 .py-xl-15 {
   padding-top: 16rem !important; }
 .pr-xl-15,
 .px-xl-15 {
   padding-right: 16rem !important; }
 .pb-xl-15,
 .py-xl-15 {
   padding-bottom: 16rem !important; }
 .pl-xl-15,
 .px-xl-15 {
   padding-left: 16rem !important; }
 .p-xl-16 {
   padding: 25rem !important; }
 .pt-xl-16,
 .py-xl-16 {
   padding-top: 25rem !important; }
 .pr-xl-16,
 .px-xl-16 {
   padding-right: 25rem !important; }
 .pb-xl-16,
 .py-xl-16 {
   padding-bottom: 25rem !important; }
 .pl-xl-16,
 .px-xl-16 {
   padding-left: 25rem !important; }
 .m-xl-n1 {
   margin: -0.25rem !important; }
 .mt-xl-n1,
 .my-xl-n1 {
   margin-top: -0.25rem !important; }
 .mr-xl-n1,
 .mx-xl-n1 {
   margin-right: -0.25rem !important; }
 .mb-xl-n1,
 .my-xl-n1 {
   margin-bottom: -0.25rem !important; }
 .ml-xl-n1,
 .mx-xl-n1 {
   margin-left: -0.25rem !important; }
 .m-xl-n2 {
   margin: -0.5rem !important; }
 .mt-xl-n2,
 .my-xl-n2 {
   margin-top: -0.5rem !important; }
 .mr-xl-n2,
 .mx-xl-n2 {
   margin-right: -0.5rem !important; }
 .mb-xl-n2,
 .my-xl-n2 {
   margin-bottom: -0.5rem !important; }
 .ml-xl-n2,
 .mx-xl-n2 {
   margin-left: -0.5rem !important; }
 .m-xl-n3 {
   margin: -0.75rem !important; }
 .mt-xl-n3,
 .my-xl-n3 {
   margin-top: -0.75rem !important; }
 .mr-xl-n3,
 .mx-xl-n3 {
   margin-right: -0.75rem !important; }
 .mb-xl-n3,
 .my-xl-n3 {
   margin-bottom: -0.75rem !important; }
 .ml-xl-n3,
 .mx-xl-n3 {
   margin-left: -0.75rem !important; }
 .m-xl-n4 {
   margin: -1rem !important; }
 .mt-xl-n4,
 .my-xl-n4 {
   margin-top: -1rem !important; }
 .mr-xl-n4,
 .mx-xl-n4 {
   margin-right: -1rem !important; }
 .mb-xl-n4,
 .my-xl-n4 {
   margin-bottom: -1rem !important; }
 .ml-xl-n4,
 .mx-xl-n4 {
   margin-left: -1rem !important; }
 .m-xl-n5 {
   margin: -1.5rem !important; }
 .mt-xl-n5,
 .my-xl-n5 {
   margin-top: -1.5rem !important; }
 .mr-xl-n5,
 .mx-xl-n5 {
   margin-right: -1.5rem !important; }
 .mb-xl-n5,
 .my-xl-n5 {
   margin-bottom: -1.5rem !important; }
 .ml-xl-n5,
 .mx-xl-n5 {
   margin-left: -1.5rem !important; }
 .m-xl-n6 {
   margin: -2rem !important; }
 .mt-xl-n6,
 .my-xl-n6 {
   margin-top: -2rem !important; }
 .mr-xl-n6,
 .mx-xl-n6 {
   margin-right: -2rem !important; }
 .mb-xl-n6,
 .my-xl-n6 {
   margin-bottom: -2rem !important; }
 .ml-xl-n6,
 .mx-xl-n6 {
   margin-left: -2rem !important; }
 .m-xl-n7 {
   margin: -2.5rem !important; }
 .mt-xl-n7,
 .my-xl-n7 {
   margin-top: -2.5rem !important; }
 .mr-xl-n7,
 .mx-xl-n7 {
   margin-right: -2.5rem !important; }
 .mb-xl-n7,
 .my-xl-n7 {
   margin-bottom: -2.5rem !important; }
 .ml-xl-n7,
 .mx-xl-n7 {
   margin-left: -2.5rem !important; }
 .m-xl-n8 {
   margin: -3rem !important; }
 .mt-xl-n8,
 .my-xl-n8 {
   margin-top: -3rem !important; }
 .mr-xl-n8,
 .mx-xl-n8 {
   margin-right: -3rem !important; }
 .mb-xl-n8,
 .my-xl-n8 {
   margin-bottom: -3rem !important; }
 .ml-xl-n8,
 .mx-xl-n8 {
   margin-left: -3rem !important; }
 .m-xl-n9 {
   margin: -4rem !important; }
 .mt-xl-n9,
 .my-xl-n9 {
   margin-top: -4rem !important; }
 .mr-xl-n9,
 .mx-xl-n9 {
   margin-right: -4rem !important; }
 .mb-xl-n9,
 .my-xl-n9 {
   margin-bottom: -4rem !important; }
 .ml-xl-n9,
 .mx-xl-n9 {
   margin-left: -4rem !important; }
 .m-xl-n10 {
   margin: -5rem !important; }
 .mt-xl-n10,
 .my-xl-n10 {
   margin-top: -5rem !important; }
 .mr-xl-n10,
 .mx-xl-n10 {
   margin-right: -5rem !important; }
 .mb-xl-n10,
 .my-xl-n10 {
   margin-bottom: -5rem !important; }
 .ml-xl-n10,
 .mx-xl-n10 {
   margin-left: -5rem !important; }
 .m-xl-n11 {
   margin: -6rem !important; }
 .mt-xl-n11,
 .my-xl-n11 {
   margin-top: -6rem !important; }
 .mr-xl-n11,
 .mx-xl-n11 {
   margin-right: -6rem !important; }
 .mb-xl-n11,
 .my-xl-n11 {
   margin-bottom: -6rem !important; }
 .ml-xl-n11,
 .mx-xl-n11 {
   margin-left: -6rem !important; }
 .m-xl-n12 {
   margin: -8rem !important; }
 .mt-xl-n12,
 .my-xl-n12 {
   margin-top: -8rem !important; }
 .mr-xl-n12,
 .mx-xl-n12 {
   margin-right: -8rem !important; }
 .mb-xl-n12,
 .my-xl-n12 {
   margin-bottom: -8rem !important; }
 .ml-xl-n12,
 .mx-xl-n12 {
   margin-left: -8rem !important; }
 .m-xl-n13 {
   margin: -10rem !important; }
 .mt-xl-n13,
 .my-xl-n13 {
   margin-top: -10rem !important; }
 .mr-xl-n13,
 .mx-xl-n13 {
   margin-right: -10rem !important; }
 .mb-xl-n13,
 .my-xl-n13 {
   margin-bottom: -10rem !important; }
 .ml-xl-n13,
 .mx-xl-n13 {
   margin-left: -10rem !important; }
 .m-xl-n14 {
   margin: -12rem !important; }
 .mt-xl-n14,
 .my-xl-n14 {
   margin-top: -12rem !important; }
 .mr-xl-n14,
 .mx-xl-n14 {
   margin-right: -12rem !important; }
 .mb-xl-n14,
 .my-xl-n14 {
   margin-bottom: -12rem !important; }
 .ml-xl-n14,
 .mx-xl-n14 {
   margin-left: -12rem !important; }
 .m-xl-n15 {
   margin: -16rem !important; }
 .mt-xl-n15,
 .my-xl-n15 {
   margin-top: -16rem !important; }
 .mr-xl-n15,
 .mx-xl-n15 {
   margin-right: -16rem !important; }
 .mb-xl-n15,
 .my-xl-n15 {
   margin-bottom: -16rem !important; }
 .ml-xl-n15,
 .mx-xl-n15 {
   margin-left: -16rem !important; }
 .m-xl-n16 {
   margin: -25rem !important; }
 .mt-xl-n16,
 .my-xl-n16 {
   margin-top: -25rem !important; }
 .mr-xl-n16,
 .mx-xl-n16 {
   margin-right: -25rem !important; }
 .mb-xl-n16,
 .my-xl-n16 {
   margin-bottom: -25rem !important; }
 .ml-xl-n16,
 .mx-xl-n16 {
   margin-left: -25rem !important; }
 .m-xl-auto {
   margin: auto !important; }
 .mt-xl-auto,
 .my-xl-auto {
   margin-top: auto !important; }
 .mr-xl-auto,
 .mx-xl-auto {
   margin-right: auto !important; }
 .mb-xl-auto,
 .my-xl-auto {
   margin-bottom: auto !important; }
 .ml-xl-auto,
 .mx-xl-auto {
   margin-left: auto !important; } }
.btn > img {
 max-height: 1em;
 width: auto; }
.btn-white {
 background-color: #FFFFFF;
 color: #335EEA; }
 .btn-white:hover, .btn-white:focus {
   background-color: #FFFFFF;
   color: #1c4ce8; }

 .input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-control-plaintext,
  .input-group > .custom-select,
  .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0; }
    .input-group > .form-control + .form-control,
    .input-group > .form-control + .custom-select,
    .input-group > .form-control + .custom-file,
    .input-group > .form-control-plaintext + .form-control,
    .input-group > .form-control-plaintext + .custom-select,
    .input-group > .form-control-plaintext + .custom-file,
    .input-group > .custom-select + .form-control,
    .input-group > .custom-select + .custom-select,
    .input-group > .custom-select + .custom-file,
    .input-group > .custom-file + .form-control,
    .input-group > .custom-file + .custom-select,
    .input-group > .custom-file + .custom-file {
      margin-left: -1px; }
  .input-group > .form-control:focus,
  .input-group > .custom-select:focus,
  .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
    z-index: 3; }
  .input-group > .custom-file .custom-file-input:focus {
    z-index: 4; }
  .input-group > .form-control:not(:last-child),
  .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .input-group > .form-control:not(:first-child),
  .input-group > .custom-select:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }
  .input-group > .custom-file {
    display: flex;
    align-items: center; }
    .input-group > .custom-file:not(:last-child) .custom-file-label,
    .input-group > .custom-file:not(:last-child) .custom-file-label::after {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0; }
    .input-group > .custom-file:not(:first-child) .custom-file-label {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0; }

.input-group-prepend,
.input-group-append {
  display: flex; }
  .input-group-prepend .btn,
  .input-group-append .btn {
    position: relative;
    z-index: 2; }
    .input-group-prepend .btn:focus,
    .input-group-append .btn:focus {
      z-index: 3; }
  .input-group-prepend .btn + .btn,
  .input-group-prepend .btn + .input-group-text,
  .input-group-prepend .input-group-text + .input-group-text,
  .input-group-prepend .input-group-text + .btn,
  .input-group-append .btn + .btn,
  .input-group-append .btn + .input-group-text,
  .input-group-append .input-group-text + .input-group-text,
  .input-group-append .input-group-text + .btn {
    margin-left: -1px; }

.input-group-prepend {
  margin-right: -1px; }

.input-group-append {
  margin-left: -1px; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.8125rem 1.25rem;
  margin-bottom: 0;
  font-size: 1.0625rem;
  font-weight: 400;
  line-height: 1.6;
  color: #869AB8;
  text-align: center;
  white-space: nowrap;
  background-color: #FFFFFF;
  border: 1px solid #F1F4F8;
  border-radius: 0.375rem; }
  .input-group-text input[type="radio"],
  .input-group-text input[type="checkbox"] {
    margin-top: 0; }

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.3em + 2.244rem + 2px); }

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 1.122rem 1.5rem;
  font-size: 1.0625rem;
  line-height: 1.3;
  border-radius: 0.375rem; }

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.3em + 1.125rem + 2px); }

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.5625rem 1rem;
  font-size: 1.0625rem;
  line-height: 1.3;
  border-radius: 0.375rem; }

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 2.25rem; }

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

  .badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    font-size: 75%;
    font-weight: 600;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.375rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .badge {
        transition: none; } }
    a.badge:hover, a.badge:focus {
      text-decoration: none; }
    .badge:empty {
      display: none; }
  
  .btn .badge {
    position: relative;
    top: -1px; }
  
  .badge-pill {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
    border-radius: 10rem; }
  
  .badge-primary {
    color: #FFFFFF;
    background-color: #335EEA; }
    a.badge-primary:hover, a.badge-primary:focus {
      color: #FFFFFF;
      background-color: #1643d4; }
    a.badge-primary:focus, a.badge-primary.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(51, 94, 234, 0.5); }
  
  .badge-secondary {
    color: #FFFFFF;
    background-color: #506690; }
    a.badge-secondary:hover, a.badge-secondary:focus {
      color: #FFFFFF;
      background-color: #3e4f6f; }
    a.badge-secondary:focus, a.badge-secondary.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(80, 102, 144, 0.5); }
  
  .badge-success {
    color: #FFFFFF;
    background-color: #42BA96; }
    a.badge-success:hover, a.badge-success:focus {
      color: #FFFFFF;
      background-color: #359478; }
    a.badge-success:focus, a.badge-success.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(66, 186, 150, 0.5); }
  
  .badge-info {
    color: #FFFFFF;
    background-color: #7C69EF; }
    a.badge-info:hover, a.badge-info:focus {
      color: #FFFFFF;
      background-color: #543bea; }
    a.badge-info:focus, a.badge-info.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(124, 105, 239, 0.5); }
  
  .badge-warning {
    color: #2B354F;
    background-color: #FAD776; }
    a.badge-warning:hover, a.badge-warning:focus {
      color: #2B354F;
      background-color: #f8c945; }
    a.badge-warning:focus, a.badge-warning.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(250, 215, 118, 0.5); }
  
  .badge-danger {
    color: #FFFFFF;
    background-color: #DF4759; }
    a.badge-danger:hover, a.badge-danger:focus {
      color: #FFFFFF;
      background-color: #cf2438; }
    a.badge-danger:focus, a.badge-danger.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(223, 71, 89, 0.5); }
  
  .badge-light {
    color: #2B354F;
    background-color: #F9FBFD; }
    a.badge-light:hover, a.badge-light:focus {
      color: #2B354F;
      background-color: #d3e2f0; }
    a.badge-light:focus, a.badge-light.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(249, 251, 253, 0.5); }
  
  .badge-dark {
    color: #FFFFFF;
    background-color: #2B354F; }
    a.badge-dark:hover, a.badge-dark:focus {
      color: #FFFFFF;
      background-color: #191f2e; }
    a.badge-dark:focus, a.badge-dark.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(43, 53, 79, 0.5); }
  
  .badge-primary-desat {
    color: #FFFFFF;
    background-color: #6C8AEC; }
    a.badge-primary-desat:hover, a.badge-primary-desat:focus {
      color: #FFFFFF;
      background-color: #3f66e6; }
    a.badge-primary-desat:focus, a.badge-primary-desat.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(108, 138, 236, 0.5); }
  
  .badge-black {
    color: #FFFFFF;
    background-color: #161C2D; }
    a.badge-black:hover, a.badge-black:focus {
      color: #FFFFFF;
      background-color: #05070b; }
    a.badge-black:focus, a.badge-black.focus {
      outline: 0;
      box-shadow: 0 0 0 0 rgba(22, 28, 45, 0.5); }

  .badge-primary-soft {
    background-color: rgba(51, 94, 234, 0.1);
    color: #335EEA; }
    a.badge-primary-soft:hover, a.badge-primary-soft:focus {
      background-color: rgba(51, 94, 234, 0.2);
      color: #335EEA; }
  
  .badge-secondary-soft {
    background-color: rgba(80, 102, 144, 0.1);
    color: #506690; }
    a.badge-secondary-soft:hover, a.badge-secondary-soft:focus {
      background-color: rgba(80, 102, 144, 0.2);
      color: #506690; }
  
  .badge-success-soft {
    background-color: rgba(66, 186, 150, 0.1);
    color: #42BA96; }
    a.badge-success-soft:hover, a.badge-success-soft:focus {
      background-color: rgba(66, 186, 150, 0.2);
      color: #42BA96; }
  
  .badge-info-soft {
    background-color: rgba(124, 105, 239, 0.1);
    color: #7C69EF; }
    a.badge-info-soft:hover, a.badge-info-soft:focus {
      background-color: rgba(124, 105, 239, 0.2);
      color: #7C69EF; }
  
  .badge-warning-soft {
    background-color: rgba(250, 215, 118, 0.1);
    color: #FAD776; }
    a.badge-warning-soft:hover, a.badge-warning-soft:focus {
      background-color: rgba(250, 215, 118, 0.2);
      color: #FAD776; }
  
  .badge-danger-soft {
    background-color: rgba(223, 71, 89, 0.1);
    color: #DF4759; }
    a.badge-danger-soft:hover, a.badge-danger-soft:focus {
      background-color: rgba(223, 71, 89, 0.2);
      color: #DF4759; }
  
  .badge-light-soft {
    background-color: rgba(249, 251, 253, 0.1);
    color: #F9FBFD; }
    a.badge-light-soft:hover, a.badge-light-soft:focus {
      background-color: rgba(249, 251, 253, 0.2);
      color: #F9FBFD; }
  
  .badge-dark-soft {
    background-color: rgba(43, 53, 79, 0.1);
    color: #2B354F; }
    a.badge-dark-soft:hover, a.badge-dark-soft:focus {
      background-color: rgba(43, 53, 79, 0.2);
      color: #2B354F; }
  
  .badge-primary-desat-soft {
    background-color: rgba(108, 138, 236, 0.1);
    color: #6C8AEC; }
    a.badge-primary-desat-soft:hover, a.badge-primary-desat-soft:focus {
      background-color: rgba(108, 138, 236, 0.2);
      color: #6C8AEC; }
  
  .badge-black-soft {
    background-color: rgba(22, 28, 45, 0.1);
    color: #161C2D; }
    a.badge-black-soft:hover, a.badge-black-soft:focus {
      background-color: rgba(22, 28, 45, 0.2);
      color: #161C2D; }
  
  .badge-gray-700-soft {
    background-color: rgba(80, 102, 144, 0.1);
    color: #506690; }
    a.badge-gray-700-soft:hover, a.badge-gray-700-soft:focus {
      background-color: rgba(80, 102, 144, 0.2);
      color: #506690; }
  
  .badge-gray-600 {
    background-color: #869AB8;
    color: #FFFFFF; }
  
  .badge-lg {
    padding: 0.7em 1.15em; }
  
  .badge-rounded-circle {
    height: calc(1em + 0.5rem);
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-radius: 10rem; }
    .badge-rounded-circle > * {
      display: block;
      width: 1em; }
    .badge-rounded-circle.badge-lg {
      height: calc(1em + 1.4em);
      padding-left: 0.7em;
      padding-right: 0.7em; }
  
  .badge-float {
    position: absolute;
    z-index: 1000; }
  
  .badge-float-outside {
    top: -.5rem;
    right: -.5rem; }
  
  .badge-float-inside {
        top: 1rem;
        right: 1rem; }
      

.jarallax {
  position: relative;
  background: no-repeat center center / cover;
  z-index: 0;
}
.jarallax > .jarallax-img {
    position: absolute;
    object-fit: cover;
    /* support for plugin https://github.com/bfred-it/object-fit-images */
    font-family: 'object-fit: cover;';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
}

.btn-gray-400 {
  background-color: #C6D3E6;
  color: #FFFFFF; }
  .btn-gray-400:hover, .btn-gray-400:focus {
    background-color: #b4c5de;
    color: #f2f2f2; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important; }

.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); }

.top-0 {
  top: 0 !important; }

.right-0 {
  right: 0 !important; }

.bottom-0 {
  bottom: 0 !important; }

.left-0 {
  left: 0 !important; }

.btn-pill {
  border-radius: 50rem; }

.screenshot {
  border-radius: 0.625rem;
  box-shadow: 25px 60px 125px -25px rgba(80, 102, 144, 0.1), 16px 40px 75px -40px rgba(0, 0, 0, 0.2); }
  
  .img-fluid {
    max-width: 100%;
    height: auto; }
  
  .img-thumbnail {
    padding: 0.25rem;
    background-color: #FFFFFF;
    border: 1px solid #D9E2EF;
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px rgba(22, 28, 45, 0.075);
    max-width: 100%;
    height: auto; }
  
  .figure {
    display: inline-block; }
  
  .figure-img {
    margin-bottom: 0.5rem;
    line-height: 1; }
  
  .figure-caption {
    font-size: 88.2%;
    color: #869AB8; }
  
  code {
    font-size: 0.8125rem;
    color: #e83e8c;
    word-break: break-word; }
    a > code {
      color: inherit; }
  
  kbd {
    padding: 0.2rem 0.4rem;
    font-size: 0.8125rem;
    color: #FFFFFF;
    background-color: #2B354F;
    border-radius: 0.2rem;
    box-shadow: inset 0 -0.1rem 0 rgba(22, 28, 45, 0.25); }
    kbd kbd {
      padding: 0;
      font-size: 100%;
      font-weight: 600;
      box-shadow: none; }
  
  pre {
    display: block;
    font-size: 0.8125rem;
    color: #2B354F; }
    pre code {
      font-size: inherit;
      color: inherit;
      word-break: normal; }
  
  .pre-scrollable {
    max-height: 340px;
    overflow-y: scroll; }
  
  .container {
    width: 100%;
    padding-right: 20px;
    padding-left: 20px;
    margin-right: auto;
    margin-left: auto; }
    @media (min-width: 576px) {
      .container {
        max-width: 540px; } }
    @media (min-width: 768px) {
      .container {
        max-width: 720px; } }
    @media (min-width: 992px) {
      .container {
        max-width: 960px; } }
    @media (min-width: 1200px) {
      .container {
        max-width: 1040px; } }
  
.container-fluid {
  @media (max-width: 768px) {
    padding-right:0px;
    padding-left:0px;
  }
  width: 100%;
  padding-right: 20px;
  padding-left: 20px;
  margin-right: auto;
  margin-left: auto;
}

#app {
  margin: 0;
  padding-left: 0;
  padding-right: 0;
}

.container-fluid-v2 {
  @media (max-width: 768px) {
    padding-right:0px;
    padding-left:0px;
  }
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

.avatar {
  position: relative;
  display: inline-block;
  width: 1.875rem;
  height: 1.875rem;
  font-size: 0.625rem; }
  
.avatar:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0; }
  
.avatar-img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover; }

 .card-meta {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0 2rem 1.5rem; }

.card-meta-divider {
  width: 100%;
  margin: 0 0 1.5rem; }

.search-bar {
  border-radius: 10rem;
  background: #fff;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
}

.search-bar .form-group {
  position: relative;
  margin-bottom: 0;
}

.search-bar .form-group::after {
  display: block;
  width: 1px;
  height: 60%;
  content: '';
  background: #ddd;
  position: absolute;
  top: 20%;
  right: 0;
} 

.search-bar .form-group.no-divider::after, .search-bar .form-group:last-of-type::after {
  display: none;
}

.search-bar .form-control {
  height: calc(1.5em + 1rem + 2px);
}

.search-bar .input-label-absolute-right .label-absolute {
  right: 0;
}

@media (max-width: 991.98px) {
  .search-bar {
    border-radius: 20px;
  }
  .search-bar .form-group {
    margin-bottom: 1rem;
  }
  .search-bar .form-group::after {
    display: block;
    width: calc(100% - 4rem);
    height: 1px;
    content: '';
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #dee2e6;
    position: absolute;
    top: auto;
    right: auto;
    bottom: 0;
    left: 50%;
  }
  .search-bar .form-control {
    height: calc(1.6em + 0.75rem + 2px);
    padding: 10px 20px;
  }
  .search-bar .input-label-absolute-right .label-absolute {
    right: 1rem;
  }
  .search-bar .bootstrap-select {
    display: block !important;
    width: 100% !important;
    padding: 0;
  }
  .search-bar .bootstrap-select button {
    display: block;
    width: 100% !important;
    padding: 10px 20px;
  }
}

.z-index-20 {
  z-index: 20;
}

.d-flex {
  display: -ms-flexbox !important;
  display: flex !important;
}

.flex-wrap-initial {
  flex-wrap: initial;
}

.input-label-absolute {
  position: relative;
}

.label-absolute {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  color: #868e96;
}

.input-label-absolute-left .label-absolute {
  left: .7rem;
}

.input-label-absolute-left .form-control {
  padding-left: 2rem;
}

.input-label-absolute-right .label-absolute {
  right: .7rem;
}

.input-label-absolute-right .form-control {
  padding-right: 2rem;
}

.input-expand {
  position: relative;
  z-index: 50;
}

.input-expand .form-control {
  width: 100%;
  max-width: 15rem;
  transition: all .5s !important;
}

.input-expand.focus .form-control {
  width: 15rem !important;
}

.input-reset.focus .form-control {
  padding-right: 2rem;
}

.input-reset.focus .btn-reset {
  display: block;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.align-items-center {
  -ms-flex-align: center !important;
  align-items: center !important;
}

.align-items-baseline {
  -ms-flex-align: baseline !important;
  align-items: baseline !important;
}

.align-items-stretch {
  -ms-flex-align: stretch !important;
  align-items: stretch !important;
}

.align-content-start {
  -ms-flex-line-pack: start !important;
  align-content: flex-start !important;
}

.align-content-end {
  -ms-flex-line-pack: end !important;
  align-content: flex-end !important;
}

.align-content-center {
  -ms-flex-line-pack: center !important;
  align-content: center !important;
}

.align-content-between {
  -ms-flex-line-pack: justify !important;
  align-content: space-between !important;
}

.align-content-around {
  -ms-flex-line-pack: distribute !important;
  align-content: space-around !important;
}

.align-content-stretch {
  -ms-flex-line-pack: stretch !important;
  align-content: stretch !important;
}

.align-self-auto {
  -ms-flex-item-align: auto !important;
  align-self: auto !important;
}

.align-self-start {
  -ms-flex-item-align: start !important;
  align-self: flex-start !important;
}

.align-self-end {
  -ms-flex-item-align: end !important;
  align-self: flex-end !important;
}

.align-self-center {
  -ms-flex-item-align: center !important;
  align-self: center !important;
}

.align-self-baseline {
  -ms-flex-item-align: baseline !important;
  align-self: baseline !important;
}

.align-self-stretch {
  -ms-flex-item-align: stretch !important;
  align-self: stretch !important;
}

select.selectpicker {
  height: calc(1.6em + 0.75rem + 2px) !important;
}

.btn.btn-form-control {
  color: #ced4da;
  border-color: #ced4da;
  color: #495057;
  border: none;
  font-size: 1rem;
  text-transform: none;
  font-weight: normal;
  letter-spacing: normal;
}

.btn.btn-form-control:hover {
  color: #212529;
  background-color: #ced4da;
  border-color: #ced4da;
}

.btn.btn-form-control:focus, .btn.btn-form-control.focus {
  box-shadow: 0 0 0 0.2rem rgba(206, 212, 218, 0.5);
}

.small {
  font-size: 80%;
}

.item-center {
  display: flex !important;
  justify-content: center !important;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.vh-100 {
  height: 100vh !important; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.display-inline-block {
  display: inline-block
}

.navbar-brand-img {
  max-height: 2.4rem;
  width: auto; }

  .font-size-sm {
    font-size: 1.06rem;
  }

.display-block {
  display: block;
}

.flex-principal-search { 
  @media (min-width: 992px) {
    .container {
      flex: 0 0 20% !important;
      max-width: 20% !important; } 
    }
}

.toggle-container {
  min-width: 40px; /* Ajustar el ancho para acomodar el botón incluso en su posición más a la derecha */
  max-width: 40px;
  height: 20px;
  overflow: hidden;
  position: relative;
  border-radius: 15px;
  background-color: #ccc;
}

.toggle-button {
  width: 20px;
  height: 20px;
  background-color: #f44336; /* Color de fondo cuando está activo */
  border: none;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  transition: left 0.3s ease;
}

.toggle-button.active {
  background-color: #4CAF50; /* Color de fondo cuando está desactivado */
  left: calc(100% - 20px); /* Asegurar que el botón no se salga del contenedor */
}

#seccionCabecera p {
  text-align: center;
  padding-left: 0;
}

@media (min-width: 992px) {
  #seccionCabecera p {
    text-align: left;
    padding-left: 1.5rem; /* equivalente a Bootstrap's ps-lg-4 */
  }
}


.trashbin-tabla td,
.user-tabla td {
  white-space: normal !important;
  word-wrap: break-word;
  word-break: break-word;
  margin-bottom: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/css/theme.css"],"names":[],"mappings":"AAAA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;;AAGA;EACE;AACF;AACA;EACE,wBAAwB;EACxB,UAAU;EACV;AACF;AACA;EACE;AACF;;AAEA;;CAEC,8CAA8C;CAC9C;;;;;;EAMC,cAAc;CACf;;EAEC,8CAA8C;CAC/C;;;;;;EAMC,cAAc;CACf;;IAEG,8CAA8C;CACjD;;;;;;EAMC,cAAc;CACf;;;;CAIA,mEAAmE;CACnE;IACG,kBAAkB;EACpB,YAAY;EACZ,aAAa;CACd;EACC,mEAAmE;CACpE;IACG,kBAAkB;EACpB,YAAY;EACZ,aAAa;CACd;IACG,mEAAmE;CACtE;IACG,kBAAkB;EACpB,YAAY;EACZ,aAAa;CACd;;CAEA,qBAAqB,sBAAsB,EAAE;EAC5C,2BAA2B,sBAAsB,EAAE;EACnD,4BAA4B,sBAAsB,EAAE;;EAEpD;IACE,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,kCAAkC;IAClC,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,kCAAkC;IAClC,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,kCAAkC;IAClC,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;;GAEC;;EAED,iDAAiD,kBAAkB,EAAE,oBAAoB,EAAE;EAC3F,iDAAiD,gBAAgB,EAAE,oBAAoB,EAAE;EACzF,iDAAiD,kBAAkB,EAAE,oBAAoB,EAAE;EAC3F,iDAAiD,yBAAyB,EAAE,oBAAoB,EAAE;;EAElG,kDAAkD,iBAAiB,EAAE,oBAAoB,EAAE;EAC3F,kDAAkD,gBAAgB,EAAE,oBAAoB,EAAE;EAC1F,kDAAkD,kBAAkB,EAAE,oBAAoB,EAAE;EAC5F,kDAAkD,yBAAyB,EAAE,oBAAoB,EAAE;;EAEnG,2CAA2C,wBAAwB,EAAE,oBAAoB,EAAE;EAC3F,2CAA2C,kBAAkB,EAAE,oBAAoB,EAAE;EACrF,2CAA2C,oBAAoB,EAAE,oBAAoB,EAAE;EACvF,2CAA2C,sBAAsB,EAAE,oBAAoB,CAAC;EACxF,2CAA2C,iBAAiB,EAAE,oBAAoB,CAAC;EACnF,2CAA2C,8BAA8B,EAAE,oBAAoB,CAAC;EAChG,2CAA2C,6BAA6B,EAAE,oBAAoB,CAAC;EAC/F,2CAA2C,6BAA6B,EAAE,oBAAoB,CAAC;EAC/F,2CAA2C,mBAAmB,EAAE,oBAAoB,CAAC;EACrF,4CAA4C,sBAAsB,EAAE,oBAAoB,CAAC;EACzF,4CAA4C,+BAA+B,EAAE,oBAAoB,CAAC;;AAEpG;;AAEA;EACE,0BAA0B;EAC1B,wEAAwE;EACxE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B,EAAE,iDAAiD;AACpF;;AAEA;EACE,qBAAqB,EAAE,sDAAsD;AAC/E;;AAEA;EACE,eAAe;AACjB;;AAEA,2EAA2E;AAC3E;;;EAGE,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA,iFAAiF;AACjF;EACE,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;;EAEf;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;;EAEf;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;;EAEf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;;EAEf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;;EAEf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;;EAEf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;;EAEf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;;EAEf;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;;EAEf;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;;EAEf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;;EAEf;AACF;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;;EAEf;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;;EAEf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;;EAEf;AACF;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;;EAEf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;;EAEf;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;;EAEf;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;;EAEf;AACF;;;;AAIA;EACE;IACE,YAAY;EACd;AACF;;AAEA,+DAA+D;AAC/D;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,uCAAuC;EACvC,0CAA0C;AAC5C;;;AAGA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,kCAAkC;IAClC,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,kCAAkC;EAClC,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA,yFAAyF;AACzF;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;oCACoC;AACpC;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,uCAAuC;EACvC,0CAA0C;EAC1C,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB,YAAY;gBACZ,aAAa;gBACb,iBAAiB;gBACjB,kBAAkB;gBAClB,cAAc;gBACd,0BAA0B;gBAC1B,uCAAuC;gBACvC,UAAU;cACZ,CAAC;sBACO,eAAe;sBACf,eAAe;sBACf,uBAAuB;sBACvB,gCAAgC;sBAChC,kBAAkB;sBAClB,0BAA0B;oBAC5B,CAAC;;;;EAInB,qBAAqB;EACrB,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;;;EAGE,wCAAwC;AAC1C;AACA,uFAAuF;AACvF;EACE,oEAAoE;EACpE;IACE,0BAA0B;IAC1B,OAAO;IACP,MAAM;IACN,aAAa;EACf;EACA,iBAAiB,iBAAiB,CAAC,eAAe;EAClD,wEAAwE;EACxE,uBAAuB,qBAAqB;AAC9C;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA,yFAAyF;AACzF;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,mFAAmF;AACnF;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;qBACqB,eAAe;qBACf,gCAAgC;qBAChC,aAAa;;AAElC,eAAe,wBAAwB,CAAC;qBACnB,aAAa,CAAC;qBACd,uCAAuC;;AAE5D,4DAA4D;AAC5D;EACE;;IAEE,kBAAkB;GACnB;;AAEH;;AAEA;;yEAEyE;AACzE;IACI,sBAAsB;IACtB,yBAAyB;AAC7B,EAAE;IACE,sBAAsB;AAC1B;;AAEA;AACA;;;AAGA;EACE,0DAA0D;EAC1D,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;;AAEpC;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb;AACF;;;AAGA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,sCAAsC;IACtC,sBAAsB;AAC1B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,SAAS;IACT,qNAAqN;IACrN,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,8BAA8B;IAC9B,6CAA6C;AACjD;AACA;IACI,sBAAsB;AAC1B;;AAEA,gEAAgE;AAChE;EACE;MACI,aAAa;MACb,cAAc;IAChB;AACJ;AACA;gCACgC;AAChC;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE;MACI,aAAa;MACb,cAAc;IAChB;AACJ;;;AAGA;2BAC2B;AAC3B;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,iGAAiG;AACjG;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,uBAAuB;CACxB,CAAC;EACA,uBAAuB;AACzB,CAAC;EACC,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,mCAAmC;EACnC,sCAAsC;AACxC;;;;AAIA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,kCAAkC;EAClC,uCAAuC;EACvC,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;EAEE,wGAAwG;EACxG,kCAAkC;AACpC;;AAEA;;EAEE,uGAAuG;EACvG,kCAAkC;AACpC;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB,EAAE;;AAEpB;EACE,aAAa,EAAE,uFAAuF;AACxG;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc,EAAE;;AAElB;EACE,2CAA2C,EAAE;;AAE/C;EACE,oCAAoC,EAAE;;AAExC;;EAEE;AACF;EACE,sEAAsE,EAAE;;AAE1E;EACE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;EACE,kBAAkB;EAClB,UAAU,EAAE,wDAAwD;EACpE,WAAW;EACX,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa,EAAE,mDAAmD;EAClE,eAAe,EAAE,2DAA2D;EAC5E,UAAU,EAAE,uBAAuB;EACnC,YAAY;EACZ,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;IACI,SAAS;IACT,UAAU,EAAE,sBAAsB;AACtC;;;AAGA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,wGAAwG;AAC1G;;AAEA;EACE,6BAA6B,EAAE;AACjC,qCAAqC;;AAErC;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB,EAAE;EACpB;IACE,kBAAkB,EAAE;;AAExB;EACE,WAAW;EACX,yBAAyB,EAAE;;AAE7B;;EAEE,kBAAkB;EAClB,oBAAoB;KACjB,iBAAiB,EAAE;;AAExB;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB,EAAE;;AAEzB;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB,EAAE;;AAEtB;EACE,2BAA2B,EAAE;;AAE/B;EACE,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,UAAU,EAAE;;AAEd;EACE,MAAM;EACN,QAAQ;EACR,kBAAkB,EAAE;;AAEtB;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,kBAAkB,EAAE;;AAEtB;;EAEE,kBAAkB;EAClB,UAAU,EAAE;;AAEd;EACE,MAAM;EACN,OAAO,EAAE;;AAEX;EACE,MAAM;EACN,QAAQ,EAAE;;AAEZ;EACE,SAAS;EACT,QAAQ,EAAE;;AAEZ;EACE,SAAS;EACT,OAAO,EAAE;;AAEX;EACE;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;;IAET,0BAA0B;IAC1B,cAAc,EAAE,EAAE;;;AAGtB;EACE;IACE,OAAO,EAAE,EAAE;;AAEf;EACE;IACE,QAAQ,EAAE,EAAE;;AAEhB;EACE;IACE,aAAa,EAAE,EAAE;;IAEjB;MACE,kBAAkB;MAClB,oBAAoB;IACtB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,MAAM;MACN,QAAQ;MACR,OAAO,EAAE;;IAEX;MACE,+BAA+B;IACjC;;IAEA;MACE,MAAM;MACN,QAAQ;MACR,SAAS;MACT,OAAO,EAAE;;IAEX;MACE,iBAAiB;MACjB,YAAY;MACZ,eAAe;MACf,cAAc;MACd,6BAA6B,EAAE;;IAEjC;MACE,QAAQ;MACR,SAAS;MACT,OAAO,EAAE;;IAEX;MACE,4BAA4B;IAC9B;;IAEA;MACE,MAAM;MACN,QAAQ;MACR,SAAS;MACT,OAAO;IACT;;IAEA;MACE,iBAAiB;MACjB,YAAY;MACZ,eAAe;MACf,aAAa;MACb,8BAA8B;IAChC;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,MAAM;MACN,QAAQ;MACR,OAAO;IACT;;MAEE;QACE;UACE,SAAS;UACT,SAAS;UACT,WAAW,EAAE,EAAE;;IAErB;MACE,WAAW;MACX,YAAY,EAAE;MACd;QACE;UACE,WAAW;UACX,YAAY,EAAE,EAAE;;IAEtB;MACE,MAAM;MACN,QAAQ;MACR,OAAO,EAAE;MACT;QACE;UACE,SAAS;UACT,UAAU;UACV,UAAU,EAAE,EAAE;;IAEpB;MACE,WAAW;MACX,YAAY,EAAE;MACd;QACE;UACE,WAAW;UACX,YAAY;UACZ,YAAY,EAAE,EAAE;;IAEtB;MACE,MAAM;MACN,QAAQ;MACR,OAAO,EAAE;;IAEX;MACE,WAAW;MACX,YAAY,EAAE;;IAEhB;MACE,MAAM;MACN,SAAS;MACT,SAAS;MACT,sCAAsC,EAAE;;IAE1C;MACE,WAAW;MACX,YAAY,EAAE;;AAEpB;EACE,kBAAkB,EAAE;IAClB;MACE,WAAW;MACX,kBAAkB;MAClB,MAAM;MACN,QAAQ;MACR,SAAS;MACT,OAAO;MACP,sBAAsB,EAAE;;EAE5B;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,yBAAyB,EAAE;;EAE7B;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,8EAA8E,EAAE,EAAE;;EAExF;IACE,kEAAkE,EAAE;;EAEtE;IACE,kEAAkE,EAAE;IACpE;MACE;QACE,6EAA6E,EAAE,EAAE;;EAEvF;IACE,YAAY,EAAE;;EAEhB;IACE,YAAY,EAAE;;EAEhB;IACE,YAAY,EAAE;;EAEhB;IACE,YAAY,EAAE;;EAEhB;IACE,YAAY,EAAE;;EAEhB;IACE,YAAY,EAAE;;EAEhB;IACE,YAAY,EAAE;;EAEhB;IACE,YAAY,EAAE;;EAEhB;IACE,YAAY,EAAE;;AAElB;EACE,kBAAkB;EAClB,oBAAoB,EAAE;;AAExB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB,EAAE;;AAEvB;EACE,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB,EAAE;EACtB;IACE,cAAc;IACd,cAAc;IACd,UAAU,EAAE;;AAEhB;EACE,sBAAsB;EACtB,uBAAuB,EAAE;;AAE3B;EACE,uBAAuB;EACvB,wBAAwB,EAAE;;AAE5B;;;;;;;;;;EAUE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;;AAGA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;AAChB;;;AAGA;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,0CAA0C,EAAE;;AAE9C;EACE,2CAA2C,EAAE;;AAE/C;EACE,0CAA0C,EAAE;;AAE9C;EACE,qBAAqB;AACvB;;AAEA;CACC,oBAAoB,EAAE;AACvB;;CAEC,wBAAwB,EAAE;AAC3B;;CAEC,0BAA0B,EAAE;AAC7B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,yBAAyB,EAAE;AAC5B;CACC,0BAA0B,EAAE;AAC7B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,+BAA+B,EAAE;AAClC;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,0BAA0B,EAAE;AAC7B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,+BAA+B,EAAE;AAClC;CACC,uBAAuB,EAAE;AAC1B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,4BAA4B,EAAE;AAC/B;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,uBAAuB,EAAE;AAC1B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,4BAA4B,EAAE;AAC/B;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,uBAAuB,EAAE;AAC1B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,4BAA4B,EAAE;AAC/B;CACC,uBAAuB,EAAE;AAC1B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,4BAA4B,EAAE;AAC/B;CACC,uBAAuB,EAAE;AAC1B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,4BAA4B,EAAE;AAC/B;CACC,uBAAuB,EAAE;AAC1B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,4BAA4B,EAAE;AAC/B;CACC,uBAAuB,EAAE;AAC1B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,4BAA4B,EAAE;AAC/B;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,qBAAqB,EAAE;AACxB;;CAEC,yBAAyB,EAAE;AAC5B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,0BAA0B,EAAE;AAC7B;CACC,2BAA2B,EAAE;AAC9B;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,kCAAkC,EAAE;AACrC;;CAEC,gCAAgC,EAAE;AACnC;CACC,0BAA0B,EAAE;AAC7B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,+BAA+B,EAAE;AAClC;CACC,2BAA2B,EAAE;AAC9B;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,kCAAkC,EAAE;AACrC;;CAEC,gCAAgC,EAAE;AACnC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,0BAA0B,EAAE;AAC7B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,+BAA+B,EAAE;AAClC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,0BAA0B,EAAE;AAC7B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,+BAA+B,EAAE;AAClC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,2BAA2B,EAAE;AAC9B;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,kCAAkC,EAAE;AACrC;;CAEC,gCAAgC,EAAE;AACnC;CACC,0BAA0B,EAAE;AAC7B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,+BAA+B,EAAE;AAClC;CACC,2BAA2B,EAAE;AAC9B;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,kCAAkC,EAAE;AACrC;;CAEC,gCAAgC,EAAE;AACnC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,0BAA0B,EAAE;AAC7B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,+BAA+B,EAAE;AAClC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,0BAA0B,EAAE;AAC7B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,iCAAiC,EAAE;AACpC;;CAEC,+BAA+B,EAAE;AAClC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,wBAAwB,EAAE;AAC3B;;CAEC,4BAA4B,EAAE;AAC/B;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,6BAA6B,EAAE;AAChC;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,yBAAyB,EAAE;AAC5B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,+BAA+B,EAAE;AAClC;;CAEC,gCAAgC,EAAE;AACnC;;CAEC,8BAA8B,EAAE;AACjC;CACC,uBAAuB,EAAE;AAC1B;;CAEC,2BAA2B,EAAE;AAC9B;;CAEC,6BAA6B,EAAE;AAChC;;CAEC,8BAA8B,EAAE;AACjC;;CAEC,4BAA4B,EAAE;AAC/B;CACC;GACE,oBAAoB,EAAE;CACxB;;GAEE,wBAAwB,EAAE;CAC5B;;GAEE,0BAA0B,EAAE;CAC9B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,yBAAyB,EAAE;CAC7B;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,qBAAqB,EAAE;CACzB;;GAEE,yBAAyB,EAAE;CAC7B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,0BAA0B,EAAE;CAC9B;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE,EAAE;AACnC;CACC;GACE,oBAAoB,EAAE;CACxB;;GAEE,wBAAwB,EAAE;CAC5B;;GAEE,0BAA0B,EAAE;CAC9B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,yBAAyB,EAAE;CAC7B;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,qBAAqB,EAAE;CACzB;;GAEE,yBAAyB,EAAE;CAC7B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,0BAA0B,EAAE;CAC9B;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE,EAAE;AACnC;CACC;GACE,oBAAoB,EAAE;CACxB;;GAEE,wBAAwB,EAAE;CAC5B;;GAEE,0BAA0B,EAAE;CAC9B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,yBAAyB,EAAE;CAC7B;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,qBAAqB,EAAE;CACzB;;GAEE,yBAAyB,EAAE;CAC7B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,0BAA0B,EAAE;CAC9B;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE,EAAE;AACnC;CACC;GACE,oBAAoB,EAAE;CACxB;;GAEE,wBAAwB,EAAE;CAC5B;;GAEE,0BAA0B,EAAE;CAC9B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,yBAAyB,EAAE;CAC7B;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE;CAChC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,qBAAqB,EAAE;CACzB;;GAEE,yBAAyB,EAAE;CAC7B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,0BAA0B,EAAE;CAC9B;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,2BAA2B,EAAE;CAC/B;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,kCAAkC,EAAE;CACtC;;GAEE,gCAAgC,EAAE;CACpC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,0BAA0B,EAAE;CAC9B;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,iCAAiC,EAAE;CACrC;;GAEE,+BAA+B,EAAE;CACnC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,wBAAwB,EAAE;CAC5B;;GAEE,4BAA4B,EAAE;CAChC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,6BAA6B,EAAE;CACjC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,yBAAyB,EAAE;CAC7B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,+BAA+B,EAAE;CACnC;;GAEE,gCAAgC,EAAE;CACpC;;GAEE,8BAA8B,EAAE;CAClC;GACE,uBAAuB,EAAE;CAC3B;;GAEE,2BAA2B,EAAE;CAC/B;;GAEE,6BAA6B,EAAE;CACjC;;GAEE,8BAA8B,EAAE;CAClC;;GAEE,4BAA4B,EAAE,EAAE;AACnC;CACC,eAAe;CACf,WAAW,EAAE;AACd;CACC,yBAAyB;CACzB,cAAc,EAAE;CAChB;GACE,yBAAyB;GACzB,cAAc,EAAE;;CAElB;EACC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAE;EACb;;;;IAIE,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,gBAAgB,EAAE;IAClB;;;;;;;;;;;;MAYE,iBAAiB,EAAE;EACvB;;;IAGE,UAAU,EAAE;EACd;IACE,UAAU,EAAE;EACd;;IAEE,0BAA0B;IAC1B,6BAA6B,EAAE;EACjC;;IAEE,yBAAyB;IACzB,4BAA4B,EAAE;EAChC;IACE,aAAa;IACb,mBAAmB,EAAE;IACrB;;MAEE,0BAA0B;MAC1B,6BAA6B,EAAE;IACjC;MACE,yBAAyB;MACzB,4BAA4B,EAAE;;AAEpC;;EAEE,aAAa,EAAE;EACf;;IAEE,kBAAkB;IAClB,UAAU,EAAE;IACZ;;MAEE,UAAU,EAAE;EAChB;;;;;;;;IAQE,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB,EAAE;EACzB;;IAEE,aAAa,EAAE;;AAEnB;;EAEE,oCAAoC,EAAE;;AAExC;;;;;;EAME,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB,EAAE;;AAE3B;;EAEE,oCAAoC,EAAE;;AAExC;;;;;;EAME,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB,EAAE;;AAE3B;;EAEE,sBAAsB,EAAE;;AAE1B;;;;;;EAME,0BAA0B;EAC1B,6BAA6B,EAAE;;AAEjC;;;;;;EAME,yBAAyB;EACzB,4BAA4B,EAAE;;EAE9B;IACE,qBAAqB;IACrB,wBAAwB;IACxB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,qIAAqI,EAAE;IACvI;MACE;QACE,gBAAgB,EAAE,EAAE;IACxB;MACE,qBAAqB,EAAE;IACzB;MACE,aAAa,EAAE;;EAEnB;IACE,kBAAkB;IAClB,SAAS,EAAE;;EAEb;IACE,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB,EAAE;;EAExB;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,0CAA0C,EAAE;;EAEhD;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,2CAA2C,EAAE;;EAEjD;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,2CAA2C,EAAE;;EAEjD;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,4CAA4C,EAAE;;EAElD;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,4CAA4C,EAAE;;EAElD;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,0CAA0C,EAAE;;EAEhD;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,4CAA4C,EAAE;;EAElD;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,yCAAyC,EAAE;;EAE/C;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,4CAA4C,EAAE;;EAElD;IACE,cAAc;IACd,yBAAyB,EAAE;IAC3B;MACE,cAAc;MACd,yBAAyB,EAAE;IAC7B;MACE,UAAU;MACV,yCAAyC,EAAE;;EAE/C;IACE,wCAAwC;IACxC,cAAc,EAAE;IAChB;MACE,wCAAwC;MACxC,cAAc,EAAE;;EAEpB;IACE,yCAAyC;IACzC,cAAc,EAAE;IAChB;MACE,yCAAyC;MACzC,cAAc,EAAE;;EAEpB;IACE,yCAAyC;IACzC,cAAc,EAAE;IAChB;MACE,yCAAyC;MACzC,cAAc,EAAE;;EAEpB;IACE,0CAA0C;IAC1C,cAAc,EAAE;IAChB;MACE,0CAA0C;MAC1C,cAAc,EAAE;;EAEpB;IACE,0CAA0C;IAC1C,cAAc,EAAE;IAChB;MACE,0CAA0C;MAC1C,cAAc,EAAE;;EAEpB;IACE,wCAAwC;IACxC,cAAc,EAAE;IAChB;MACE,wCAAwC;MACxC,cAAc,EAAE;;EAEpB;IACE,0CAA0C;IAC1C,cAAc,EAAE;IAChB;MACE,0CAA0C;MAC1C,cAAc,EAAE;;EAEpB;IACE,uCAAuC;IACvC,cAAc,EAAE;IAChB;MACE,uCAAuC;MACvC,cAAc,EAAE;;EAEpB;IACE,0CAA0C;IAC1C,cAAc,EAAE;IAChB;MACE,0CAA0C;MAC1C,cAAc,EAAE;;EAEpB;IACE,uCAAuC;IACvC,cAAc,EAAE;IAChB;MACE,uCAAuC;MACvC,cAAc,EAAE;;EAEpB;IACE,yCAAyC;IACzC,cAAc,EAAE;IAChB;MACE,yCAAyC;MACzC,cAAc,EAAE;;EAEpB;IACE,yBAAyB;IACzB,cAAc,EAAE;;EAElB;IACE,qBAAqB,EAAE;;EAEzB;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB,EAAE;IACtB;MACE,cAAc;MACd,UAAU,EAAE;IACd;MACE,yBAAyB;MACzB,mBAAmB;MACnB,oBAAoB,EAAE;;EAE1B;IACE,kBAAkB;IAClB,aAAa,EAAE;;EAEjB;IACE,WAAW;IACX,aAAa,EAAE;;EAEjB;QACM,SAAS;QACT,WAAW,EAAE;;;AAGrB;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,UAAU;AACZ;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,qEAAqE;IACrE,iCAAiC;IACjC,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc,EAAE;EAChB;IACE,yBAAyB;IACzB,cAAc,EAAE;;AAEpB;EACE,yBAAyB,EAAE;;AAE7B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,6BAA6B,EAAE;;AAEjC;EACE,6BAA6B,EAAE;;AAEjC;EACE,0BAA0B,EAAE;;AAE9B;EACE,mCAAmC;EACnC,2BAA2B,EAAE;;AAE/B;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC,EAAE;;AAEpC;EACE,iBAAiB,EAAE;;AAErB;EACE,mBAAmB,EAAE;;AAEvB;EACE,oBAAoB,EAAE;;AAExB;EACE,kBAAkB,EAAE;;AAEtB;EACE,oBAAoB,EAAE;;AAExB;EACE,uBAAuB;EACvB,kGAAkG,EAAE;;EAEpG;IACE,eAAe;IACf,YAAY,EAAE;;EAEhB;IACE,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,6CAA6C;IAC7C,eAAe;IACf,YAAY,EAAE;;EAEhB;IACE,qBAAqB,EAAE;;EAEzB;IACE,qBAAqB;IACrB,cAAc,EAAE;;EAElB;IACE,gBAAgB;IAChB,cAAc,EAAE;;EAElB;IACE,oBAAoB;IACpB,cAAc;IACd,sBAAsB,EAAE;IACxB;MACE,cAAc,EAAE;;EAEpB;IACE,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,oDAAoD,EAAE;IACtD;MACE,UAAU;MACV,eAAe;MACf,gBAAgB;MAChB,gBAAgB,EAAE;;EAEtB;IACE,cAAc;IACd,oBAAoB;IACpB,cAAc,EAAE;IAChB;MACE,kBAAkB;MAClB,cAAc;MACd,kBAAkB,EAAE;;EAExB;IACE,iBAAiB;IACjB,kBAAkB,EAAE;;EAEtB;IACE,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB,EAAE;IACnB;MACE;QACE,gBAAgB,EAAE,EAAE;IACxB;MACE;QACE,gBAAgB,EAAE,EAAE;IACxB;MACE;QACE,gBAAgB,EAAE,EAAE;IACxB;MACE;QACE,iBAAiB,EAAE,EAAE;;AAE7B;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS,EAAE;;AAEb;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;KACjB,iBAAiB,EAAE;;CAEvB;EACC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,oBAAoB;EACpB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,SAAS;IACT,SAAS;EACX;EACA;IACE,mCAAmC;IACnC,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mCAAmC;EACnC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB,EAAE;;AAE5B;EACE,mCAAmC,EAAE;;AAEvC;EACE,8BAA8B,EAAE;;AAElC;EACE,iCAAiC,EAAE;;AAErC;EACE,iCAAiC,EAAE;;AAErC;EACE,sCAAsC,EAAE;;AAE1C;EACE,mCAAmC,EAAE;;AAEvC;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE;;EAEb;IACE,kBAAkB;EACpB;;AAEF;EACE,cAAc;AAChB;;AAEA;EACE;IACE;MACE,wBAAwB;MACxB,yBAAyB,EAAE;IAC7B;AACJ;;AAEA;EACE,eAAe,EAAE,oFAAoF;EACrG,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,sCAAsC;EACjE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB,EAAE,2CAA2C;EACtE,uBAAuB,EAAE,qDAAqD;AAChF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB,EAAE,sCAAsC;EAC9D;AACF;;;AAGA;;EAEE,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":["/**\n * Custom variables followed by theme variables followed by Bootstrap variables\n * to ensure cascade of styles.\n **/\n\nhtml {\n  min-height: 100%;\n  position: relative;\n}\nbody {\n  margin: 0;\n  margin-bottom: 100px;\n}\n\n*, *::before, *::after {\n  box-sizing: border-box;\n}\nfooter {\n  margin-top: 20px;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 40px;\n  color:#2B354F;\n}\n\n.ocultar-movil {\n  @media (max-width: 572px) {\n    display: none;\n  }\n}\n\n\n#wrapper {\n  display:flex\n}\n#wrapper #content-wrapper {\n  background-color:#f8f9fc;\n  width:100%;\n  overflow-x:hidden\n}\n#wrapper #content-wrapper #content{\n  flex:1 0 auto\n}\n\n@media only screen and (max-width: 1200px) {\n  \n\t/* Force table to not be like tables anymore */\n\t#no-more-tables table, \n\t#no-more-tables thead, \n\t#no-more-tables tbody, \n\t#no-more-tables th, \n\t#no-more-tables td, \n\t#no-more-tables tr { \n\t\tdisplay: block; \n\t}\n\n  /* Force table to not be like tables anymore */\n\t#no-more-tables-users table, \n\t#no-more-tables-users thead, \n\t#no-more-tables-users tbody, \n\t#no-more-tables-users th, \n\t#no-more-tables-users td, \n\t#no-more-tables-users tr { \n\t\tdisplay: block; \n\t}\n\n    /* Force table to not be like tables anymore */\n\t#no-more-tables-borrar table, \n\t#no-more-tables-borrar thead, \n\t#no-more-tables-borrar tbody, \n\t#no-more-tables-borrar th, \n\t#no-more-tables-borrar td, \n\t#no-more-tables-borrar tr { \n\t\tdisplay: block; \n\t}\n\n\n \n\t/* Hide table headers (but not display: none;, for accessibility) */\n\t#no-more-tables thead th { \n    position: absolute;\n\t\ttop: -9999px;\n\t\tleft: -9999px;\n\t}\n  /* Hide table headers (but not display: none;, for accessibility) */\n\t#no-more-tables-users thead th { \n    position: absolute;\n\t\ttop: -9999px;\n\t\tleft: -9999px;\n\t}\n    /* Hide table headers (but not display: none;, for accessibility) */\n\t#no-more-tables-borrar thead th { \n    position: absolute;\n\t\ttop: -9999px;\n\t\tleft: -9999px;\n\t}\n \n\t#no-more-tables tr { border: 1px solid #ccc; }\n  #no-more-tables-users tr { border: 1px solid #ccc; }\n  #no-more-tables-borrar tr { border: 1px solid #ccc; }\n \n  #no-more-tables td { \n    /* Behave  like a \"row\" */\n    border: none;\n    border-bottom: 1px solid #eee; \n    position: relative;\n    padding-left: 50%; \n    white-space: normal;\n    text-align:left;\n  }\n  #no-more-tables-users td { \n    /* Behave  like a \"row\" */\n    border: none;\n    border-bottom: 1px solid #eee; \n    position: relative;\n    padding-left: 50%; \n    white-space: normal;\n    text-align:left;\n  }\n  #no-more-tables-borrar td { \n    /* Behave  like a \"row\" */\n    border: none;\n    border-bottom: 1px solid #eee; \n    position: relative;\n    padding-left: 50%; \n    white-space: normal;\n    text-align:left;\n  }\n  \n  #no-more-tables td:before { \n    /* Now like a table header */\n    position: absolute;\n    /* Top/left values mimic padding */\n    top: 6px;\n    left: 6px;\n    width: 45%; \n    padding-right: 10px; \n    white-space: nowrap;\n    text-align:left;\n    font-weight: bold;\n  }\n  #no-more-tables-users td:before { \n    /* Now like a table header */\n    position: absolute;\n    /* Top/left values mimic padding */\n    top: 6px;\n    left: 6px;\n    width: 45%; \n    padding-right: 10px; \n    white-space: nowrap;\n    text-align:left;\n    font-weight: bold;\n  }\n  #no-more-tables-borrar td:before { \n    /* Now like a table header */\n    position: absolute;\n    /* Top/left values mimic padding */\n    top: 6px;\n    left: 6px;\n    width: 45%; \n    padding-right: 10px; \n    white-space: nowrap;\n    text-align:left;\n    font-weight: bold;\n  }\n  \n  /*\n  Generamos cabeceras cuando activamos la tabla vertical para dispositivos móviles\n  */\n\n  #no-more-tables-users td:nth-of-type(1):before { content: \"Guardar\"; padding-top: 0.40rem; }\n  #no-more-tables-users td:nth-of-type(2):before { content: \"Email\"; padding-top: 0.40rem; }\n  #no-more-tables-users td:nth-of-type(3):before { content: \"Edición\"; padding-top: 0.40rem; }\n  #no-more-tables-users td:nth-of-type(4):before { content: \"Administración\"; padding-top: 0.40rem; }\n\n  #no-more-tables-borrar td:nth-of-type(1):before { content: \"Borrar\"; padding-top: 0.40rem; }\n  #no-more-tables-borrar td:nth-of-type(2):before { content: \"Email\"; padding-top: 0.40rem; }\n  #no-more-tables-borrar td:nth-of-type(3):before { content: \"Edición\"; padding-top: 0.40rem; }\n  #no-more-tables-borrar td:nth-of-type(4):before { content: \"Administración\"; padding-top: 0.40rem; }\n\n  #no-more-tables td:nth-of-type(1):before { content: \"ID incidencia\"; padding-top: 0.40rem; }\n  #no-more-tables td:nth-of-type(2):before { content: \"Dominio\"; padding-top: 0.40rem; }\n  #no-more-tables td:nth-of-type(3):before { content: \"Severidad\"; padding-top: 0.40rem; }\n  #no-more-tables td:nth-of-type(4):before { content: \"Descripción\"; padding-top: 0.40rem;}\n  #no-more-tables td:nth-of-type(5):before { content: \"Estado\"; padding-top: 0.40rem;}\n  #no-more-tables td:nth-of-type(6):before { content: \"Servicios Afectados\"; padding-top: 0.40rem;}\n  #no-more-tables td:nth-of-type(7):before { content: \"Clientes Afectados\"; padding-top: 0.40rem;}\n  #no-more-tables td:nth-of-type(8):before { content: \"Red/Infr. afectada\"; padding-top: 0.40rem;}\n  #no-more-tables td:nth-of-type(9):before { content: \"Duración\"; padding-top: 0.40rem;}\n  #no-more-tables td:nth-of-type(10):before { content: \"Actualizado\"; padding-top: 0.40rem;}\n  #no-more-tables td:nth-of-type(11):before { content: \"Última actualización\"; padding-top: 0.40rem;}\n\n}\n\n.bg-somosierra {\n  background-color: #FF7900 ;\n  background-image: linear-gradient(180deg,#FF7900  10%,rgb(173, 103, 56));\n  background-size: cover;\n}\n\n.icon-hover-grow {\n  transition: transform 0.3s ease; /* Smooth transition for the transform property */\n}\n\n.icon-hover-grow:hover {\n  transform: scale(1.5); /* Increase the size of the icon by 50% when hovered */\n}\n\n.listaDashboard .nav-item:hover {\n  transform: none;\n}\n\n/* Brand wordmark is a static title — no link hover, underline, or scale. */\n.sidebar .sidebar-brand.sidebar-brand-title,\n.sidebar .sidebar-brand.sidebar-brand-title:hover,\n.sidebar .sidebar-brand.sidebar-brand-title:focus {\n  cursor: default;\n  text-decoration: none !important;\n  transform: none;\n  color: inherit;\n}\n\n.sidebar .sidebar-brand.sidebar-brand-title .sidebar-brand-text,\n.sidebar .sidebar-brand.sidebar-brand-title .sidebar-brand-text:hover {\n  transform: none;\n  text-decoration: none !important;\n}\n\n.auto-width-fecha {\n  min-width: 200px;\n  width: auto;\n}\n\n.auto-width-duracion {\n  min-width: 150px;\n  width: auto;\n}\n\n.auto-width-severity {\n  min-width: 120px;\n  width: auto;\n}\n\n.auto-width-ticket {\n  min-width: 150px;\n  width: auto;\n}\n\n.auto-height {\n  min-height: 150px;\n  height: auto;\n}\n\n.masmovil-button {\n  background-color: #FF7900;\n  background-size: cover;\n}\n\n.chart-container {\n  overflow: hidden;\n}\n\n.borde-seleccion {\n  border-bottom: 1px solid rgb(192, 190, 190);\n}\n\n.columna_todo_espacio {\n  height: 75vh;\n}\n\n.contenedor-interno-con-borde {\n  border: 1px solid rgb(192, 190, 190);\n  padding: 20px;\n  height: 75vh;\n  border-radius: 1%;\n  overflow-y: auto;\n}\n\n.centro-chart-donut {\n  position: absolute !important; \n  top: 50% !important; \n  left: 50% !important; \n  transform: translate(-50%, -50%) !important; \n  text-align: center !important; \n  color: #000 !important;\n}\n\n.avatar-miperfil {\n  vertical-align: middle;\n  width: 50% !important;\n  height: 50% !important;\n  border-radius: 50%;\n}\n\n.sidebar-footer {\n  margin-top: auto;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n/* Keep sidebar chrome (footer) in the viewport even when main content is tall. */\n.sidebar.navbar {\n  align-self: flex-start;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  max-height: 100vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.caja-valor {\n  display: flex;\n  flex-direction: column; \n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  padding:12px;\n  position: relative;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid;\n  border-color: #cfd6d7;\n}\n\n.caja-1 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 0rem;\n    margin-right: 1.5vw;\n    margin-bottom: 1rem;\n    flex: 1 0 40%;\n    \n  }\n  @media (min-width: 1280px) {\n    margin-left: 0rem;\n    margin-right: 1vw;\n    flex: 1 0 20%;\n    \n  }  \n}\n.caja-2 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 1.5vw;\n    margin-right: 0vw;\n    margin-bottom: 1rem;\n    flex: 1 0 40%;\n   \n  }\n  @media (min-width: 1280px) {\n    margin-left: 1vw;;\n    margin-right: 1vw;;\n    flex: 1 0 20%;\n   \n  }  \n}\n\n.caja-3 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 0vw;\n    margin-right: 1.5vw;\n    flex: 1 0 40%;\n  }\n  @media (min-width: 1280px) {\n    margin-top: 0rem;\n    margin-left: 1vw;\n    margin-right: 1vw;\n    flex: 1 0 20%;\n    \n  }  \n}\n\n.caja-4 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 1.5vw;\n    margin-right: 0vw;\n    flex: 1 0 40%;\n   \n  }\n  @media (min-width: 1280px) {\n    margin-top: 0rem;\n    margin-right: 0px;\n    margin-left: 1vw;\n    flex: 1 0 20%;\n   \n  }  \n}\n\n.caja-detalle {\n  display: flex;\n  flex-direction: column; \n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  padding:12px;\n  position: relative;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid;\n  border-color: #cfd6d7;\n}\n.caja-detalle-1 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 0vw;\n    margin-right: 1.5vw;\n    margin-bottom: 1vw;\n    flex: 1 0 40%;\n    \n  }\n  @media (min-width: 1280px) {\n    margin-left: 0rem;\n    margin-right: 1vw;\n    flex: 1 0 10%;\n    \n  }  \n}\n.caja-detalle-2 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 1.5vw;\n    margin-right: 0vw;\n    margin-bottom: 1vw;\n    flex: 1 0 40%;\n   \n  }\n  @media (min-width: 1280px) {\n    margin-left: 1vw;;\n    margin-right: 1vw;;\n    flex: 1 0 10%;\n   \n  }  \n}\n.caja-detalle-3 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 0vw;\n    margin-right: 1.5vw;\n    margin-bottom: 1vw;\n    flex: 1 0 40%;\n  }\n  @media (min-width: 1280px) {\n    margin-top: 0rem;\n    margin-left: 1vw;\n    margin-right: 1vw;\n    flex: 1 0 10%;\n  }  \n}\n.caja-detalle-4 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 1.5vw;\n    margin-right: 0vw;\n    margin-bottom: 1vw;\n    flex: 1 0 40%;\n  }\n  @media (min-width: 1280px) {\n    margin-top: 0rem;\n    margin-right: 1vw;\n    margin-left: 1vw;\n    flex: 1 0 10%;\n  }  \n}\n.caja-detalle-5 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 0vw;\n    margin-right: 1.5vw;\n    margin-bottom: 1vw;\n    flex: 1 0 40%;\n  }\n  @media (min-width: 1280px) {\n    margin-top: 0rem;\n    margin-right: 1vw;\n    margin-left: 1vw;\n    flex: 1 0 10%;\n   \n  }  \n}\n.caja-detalle-6 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 1.5vw;\n    margin-right: 0vw;\n    margin-bottom: 1vw;\n    flex: 1 0 40%;\n   \n  }\n  @media (min-width: 1280px) {\n    margin-top: 0rem;\n    margin-right: 1vw;\n    margin-left: 1vw;\n    flex: 1 0 10%;\n   \n  }  \n}\n.caja-detalle-7 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 0vw;\n    margin-right: 1.5vw;\n    flex: 1 0 40%;\n   \n  }\n  @media (min-width: 1280px) {\n    margin-top: 0rem;\n    margin-right: 1vw;\n    margin-left: 1vw;\n    flex: 1 0 10%;\n   \n  }  \n}\n.caja-detalle-8 {\n  @media (min-width: 375px) and (max-width: 1279px) {\n    margin-left: 1.5vw;\n    margin-right: 0vw;\n    flex: 1 0 40%;\n   \n  }\n  @media (min-width: 1280px) {\n    margin-top: 0rem;\n    margin-right: 0vw;\n    margin-left: 1vw;\n    flex: 1 0 10%;\n   \n  }  \n}\n\n\n\n.altura-chart {\n  @media (max-width: 1280px) {\n    height:250px;\n  }  \n}\n\n/* Formato de la card que da todos los datos de las entidades */\n.card-datos-entidad {\n  border: 0.5px solid #2B3550;\n  border-radius: 10px 10px 10px 10px;\n  -moz-border-radius: 10px 10px 10px 10px;\n  -webkit-border-radius: 10px 10px 10px 10px;\n}\n\n.card-resultado {\n  border: 0.5px solid #2B3550;\n  margin-right: 1px;\n  margin-left: 1px;\n  /*background-color: #F1F4F8;*/\n  border-radius: 10px 10px 10px 10px;\n  -moz-border-radius: 10px 10px 10px 10px;\n  -webkit-border-radius: 10px 10px 10px 10px;\n}\n\n\n.card-blue-entidades {\n    border: 0.5px solid #2B3550;\n    background-color: #2B354F;\n    border-radius: 10px 10px 10px 10px;\n    -moz-border-radius: 10px 10px 10px 10px;\n    -webkit-border-radius: 10px 10px 10px 10px;\n}\n\n.card-blue-exterior {\n  border: 0.5px solid #2B354F;\n  background-color: rgb(219, 224, 238);\n  border-radius: 20px 20px 20px 20px;\n  -moz-border-radius: 20px 20px 20px 20px;\n  -webkit-border-radius: 20px 20px 20px 20px;\n}\n\n/* Amplio el ancho del footer ya que no consigo que se extienda el ancho de la pantalla */\n.container-footer {\n  margin-left: -20px !important;\n  margin-right: -20px !important;\n  width: 101% !important;\n}\n\n/* Contenedor de cartas para consulta general de todas\nlas tipologias, todos los sevicios */\n.containerL {\n  border: 0.5px solid #2B3550;\n  border-radius: 20px 20px 20px 20px;\n  -moz-border-radius: 20px 20px 20px 20px;\n  -webkit-border-radius: 20px 20px 20px 20px;\n  background-color: white;\n  display: flex;\n}\n\n.colL {\n  margin: 10px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.item-containerL {\n  padding: 0px;\n  margin: 1px;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n#sidebarToggle {width:2.5rem;\n                height:2.5rem;\n                text-align:center;\n                margin-bottom:1rem;\n                cursor:pointer;\n                transform: none !important;\n                transition: background-color 0.15s ease;\n                padding: 0;\n              }.sidebar \n#sidebarToggle:after {font-weight:900;\n                      content:\"\\f104\";\n                      color: white !important;\n                      font-family:Font Awesome\\ 5 Free;\n                      margin-right:.1rem;\n                      transform: none !important;\n                    }.sidebar \n#sidebarToggle:hover,\n#sidebarToggle:focus,\n#sidebarToggle:active {\n  text-decoration: none;\n  outline: none;\n  transform: none !important;\n  box-shadow: none;\n  background-color: hsla(0, 0%, 100%, 0.2);\n}\n.sidebar-dark #sidebarToggle:hover,\n.sidebar-dark #sidebarToggle:focus,\n.sidebar-dark #sidebarToggle:active {\n  background-color: hsla(0, 0%, 100%, 0.2);\n}\n/* Zero width only below desktop mid: desktop toggled stays SB Admin icons (~6.5rem). */\n@media (max-width: 767.98px) {\n  /* Out of flow so opening the drawer does not shrink main content. */\n  .sidebar.navbar {\n    position: fixed !important;\n    left: 0;\n    top: 0;\n    z-index: 1040;\n  }\n  .sidebar.toggled{width:0!important;overflow:hidden}\n  /* Open mobile drawer matches expanded desktop width (icons + labels). */\n  .sidebar:not(.toggled){width:14rem!important}\n}\n\n.sidebar .listaDashboard .nav-item .nav-link {\n  box-sizing: border-box;\n  width: 100% !important;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n/* Expanded / open-drawer rows: icon column + wrapping label, highlight stays in-strip. */\n.sidebar:not(.toggled) .listaDashboard .nav-item .nav-link {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  text-align: left;\n  padding: 0.65rem 0.75rem;\n}\n\n.sidebar:not(.toggled) .listaDashboard .nav-item .nav-link > i {\n  flex: 0 0 1.25rem;\n  width: 1.25rem;\n  margin-right: 0.5rem;\n  padding-right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar:not(.toggled) .listaDashboard .nav-item .nav-link > span {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: block;\n  padding-left: 0;\n  white-space: normal;\n  overflow-wrap: break-word;\n  line-height: 1.25;\n}\n\n/* Icons mode: no brand/divider chrome — first icon sits at the top of the strip. */\n.sidebar.sidebar-mode-icons .sidebar-divider {\n  display: none !important;\n}\n\n.sidebar.sidebar-mode-icons > .d-flex.flex-column {\n  padding-top: 0.25rem !important;\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n  flex-direction: column !important;\n}\n\n.sidebar.sidebar-mode-icons .sidebar-brand {\n  display: none !important;\n  height: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  overflow: hidden;\n}\n\n.sidebar.sidebar-mode-icons .listaDashboard {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n}\n\n.sidebar.sidebar-mode-icons .listaDashboard .nav-item {\n  width: 100%;\n  max-width: 100%;\n}\n\n.sidebar.sidebar-mode-icons .listaDashboard .nav-item .nav-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100% !important;\n  max-width: 100%;\n  padding: 0.75rem 0.25rem;\n  text-align: center;\n}\n\n.sidebar.sidebar-mode-icons .listaDashboard .nav-item .nav-link > span {\n  display: none;\n}\n\n.sidebar.sidebar-mode-icons .listaDashboard .nav-item .nav-link > i {\n  margin-right: 0;\n  padding-right: 0;\n}\n\n.sidebar.sidebar-mode-icons .sidebar-footer {\n  font-size: 0.75rem;\n  line-height: 1.2;\n  padding-left: 0.15rem;\n  padding-right: 0.15rem;\n  overflow: hidden;\n}\n\n.sidebar.sidebar-mode-icons .sidebar-collapse-control {\n  width: 100%;\n  overflow: hidden;\n}\n\n.sidebar.sidebar-mode-icons #sidebarToggle {\n  width: 2rem;\n  height: 2rem;\n  margin-bottom: 0.75rem;\n  transform: none !important;\n}\n.sidebar.toggled \n#sidebarToggle:after{content:\"\\f105\";\n                     font-family:Font Awesome\\ 5 Free;\n                     margin-left:0}\n\n#sidebarToggle{background-color:#eaecf4}.sidebar-light \n#sidebarToggle:after{color:#b7b9cc}.sidebar-light \n#sidebarToggle:hover{background-color:hsla(0, 0%, 100%, 0.2)}\n\n/* Margen en el paso 4 para que se vea espaciado en móviles*/\n#Paso4 {\n  @media (max-width: 768px)\n   { \n    margin-top: 1.5rem;\n   }\n\n}\n\n/* Añado el after porque la transición que general el lift cambia\nde color el texto de blanco a negro y quiero evitarla, pongo el after\ncon el text a blanco y añado el important, sin el important no funciona */\n.btn-card-entidades {\n    color: #fff !important;\n    background-color: #2B354F;\n} ::after {\n    color: #fff !important;\n}\n\nelement.style {\n}\n\n\n.card-header {\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n  padding: 1.25rem 1.25rem;\n  border-bottom: none;\n  background-color: rgba(33,18,27,0);\n\n}\n\n.card-header:after {\n  /* Para pintar el borde inferior del header como una línea */\n  content : \"\";\n  max-width:1280px;\n  height  : 15px;\n  width   : 100%; \n  border-bottom: 1px solid #2B3550;\n  margin:0 auto;\n  padding: 1px 0px\n}\n\n\n.card-title {\n    margin-bottom: 0.75rem;\n}\np {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\n\n.pais-cartera {\n  position: absolute;\n  padding-top: 4px;\n  padding-left: 15px;\n  font-size: 25px;\n}\n\n.fuentes-cabecera-card {\n  font-size: 20px;\n}\n\n.pt-detalles {\n  padding-top: 1.2rem;\n}\n\n/* user agent stylesheet */\np {\n    display: block;\n    margin-block-start: 1em;\n    margin-block-end: 1em;\n    margin-inline-start: 0px;\n    margin-inline-end: 0px;\n}\n.card {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0.25rem;\n}\n.font-weight-bold {\n    font-weight: 700 !important;\n}\n.text-center {\n    text-align: center !important;\n}\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    text-align: left;\n    background-color: #fff;\n}\nhtml {\n    font-family: sans-serif;\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n*, *::before, *::after {\n    box-sizing: border-box;\n}\n\n/* Usada en la barra de desplegables del buscador de entidades */\n.local-grid-barra-desplegables { \n  @media (min-width: 992px) {\n      flex: 0 0 22%;\n      max-width: 22%;\n    }\n}\n/* Selectores de clase y de Id para ajustar la barra principal  de busqueda\na 4 desplegables y un botón de */\n#local-boton-busqueda-principal {\n  display:block;\n  width:100%; \n}\n.local-grid-boton-busqueda { \n  @media (min-width: 992px) {\n      flex: 0 0 12%;\n      max-width: 12%;\n    }\n}\n\n\n/* Cambio de ancho por defecto del cuadro que se muestra al darle a la flecha\nde la clase deowdown-menu */\n.dropdown-menu.show {\n  min-width: 20rem;\n  padding-left: 1rem !important;\n  padding-right: 1rem !important;\n}\n\n/* Usada en el texto de política de privacidad para separar la línea del blockquote del párrafo */\n.blockquote-politica-privacidad {\n  border-left: 2px solid #4E66F8;\n  padding-left: 3rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.power-off-personalized-color{\n  color: black !important;\n }::after {\n  color: black !important;\n}::after {\n  color: black !important;\n}\n.card-border-rounded {\n  border: 0.5px solid rgba(50,156,156, 1.05);\n  border-radius: 20px 20px 20px 20px;\n  -moz-border-radius: 20px 20px 20px 20px;\n  -webkit-border-radius: 20px 20px 20px 20px;\n}\n\n.button-border-rounded {\n  border: 0.5px solid rgba(50,156,156, 1.05);\n  border-radius: 7px 7px 7px 7px;\n  -moz-border-radius: 7px 7px 7px 7px;\n  -webkit-border-radius: 7px 7px 7px 7px;\n}\n\n\n\n.card-footer {\n  border-top: none;\n  background-color: rgba(33,18,27,0);\n}\n\n.align-star-rating {\n  display: inline-flex !important;\n}\n.card-footer-short {\n  padding: 20px 10px 20px 10px !important;\n}\n\n.btn-align {\n  padding: 1px 1px;\n  margin-bottom: 7px;\n  line-height: 1.12857143;\n  vertical-align: middle;\n}\n\n.hero {\n  position: relative;\n  text-align: center;\n  background: #f8f9fa;\n  box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.bg-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\nimg.bg-image {\n  font-family: 'object-fit: cover;';\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.dark-overlay,\n.gradient-overlay {\n  position: relative;\n  overflow: hidden;\n}\n\n.img-thumbnail {\n  margin-top: 5px\n}\n\n.img-adjust {\n  width: 90% !important;\n  height: 75% !important;\n  margin-left: 10px !important;\n  margin-right: 0px !important;\n  border-radius: 25px 25px 25px 25px;\n  -moz-border-radius: 25px 25px 25px 25px;\n  -webkit-border-radius: 25px 25px 25px 25px;\n  display: inline-block !important;\n}\n\n.modal-backdrop {\n  opacity:0.3 !important;\n}\n\n.lift {\n  transition: box-shadow .25s ease, transform .25s ease; \n}\n\n.lift:hover,\n.lift:focus {\n  box-shadow: 0 1rem 2.5rem rgba(22, 28, 45, 0.1), 0 0.5rem 1rem -0.75rem rgba(22, 28, 45, 0.1) !important;\n  transform: translate3d(0, -3px, 0); \n}\n\n.lift-lg:hover,\n.lift-lg:focus {\n  box-shadow: 0 2rem 5rem rgba(22, 28, 45, 0.1), 0 0.5rem 1rem -0.75rem rgba(22, 28, 45, 0.05) !important;\n  transform: translate3d(0, -5px, 0);\n}\n\n.inline-block {\n  display: inline\n}\n\n.lead {\n  font-size: 1.3125rem;\n  font-weight: 400; }\n\ninput[type=text]::-ms-clear {\n  display: none; /* We disable delete icon,  https://developer.mozilla.org/es/docs/Web/CSS/::-ms-clear */\n}\n\n.card-img-top {\n  width: 100%;\n  border-top-left-radius: calc(0.375rem - 0px);\n  border-top-right-radius: calc(0.375rem - 0px); \n}\n\n.display-2 {\n  font-size: 3.8125rem;\n  font-weight: 400;\n  line-height: 1; }\n\n.bg-cover {\n  background: no-repeat center center / cover; }\n\n.bg-dark {\n  background-color: #2B354F !important; }\n\n/*.bg-image {\n  background-image: url('/imgs/cover-5.jpg');\n}*/\n.bg-gradient-light {\n  background-image: linear-gradient(to bottom, #F9FBFD 0%, #FFFFFF 100%); }\n\n.bg-gray-200 {\n  background-color: #F1F4F8 !important; }\n\n.bg-gray-300 {\n  background-color: #D9E2EF !important; }\n\n.bg-gray-800 {\n  background-color: #384C74 !important; }\n\n.bg-black {\n  background-color: #161C2D !important; }\n\n.alert-box {\n  position: absolute;\n  top: -50px; /* Comienza fuera de la pantalla, en la parte superior */\n  left: 200px;\n  font-size: 0.7rem;\n  background-color: rgb(209, 102, 102) !important;\n  z-index: 1000; /* Asegura que esté por encima de otros elementos */\n  font-size: 20px; /* Ajusta el tamaño del texto para pantallas más pequeñas */\n  opacity: 0; /* Comienza invisible */\n  color: white;\n  transition: top 0.5s ease, opacity 0.5s ease;\n  font-weight: bold;\n}\n\n.alert-box.alert-box-active {\n    top: 10px;\n    opacity: 1; /* Se vuelve visible */\n}\n\n\n.shadow-light {\n  box-shadow: 0 0.5rem 1.5rem rgba(22, 28, 45, 0.05) !important; \n}\n\n.shadow-light-lg {\n  box-shadow: 0 1.5rem 4rem rgba(22, 28, 45, 0.05) !important; \n}\n\n.shadow-dark {\n  box-shadow: 0 0.5rem 1.5rem rgba(22, 28, 45, 0.15) !important; \n}\n\n.shadow-dark-lg {\n  box-shadow: 0 1.5rem 4rem rgba(22, 28, 45, 0.15) !important; \n}\n\n.shadow-lift {\n  box-shadow: 0 1rem 2.5rem rgba(22, 28, 45, 0.1), 0 0.5rem 1rem -0.75rem rgba(22, 28, 45, 0.1) !important; \n}\n\n.position-relative {\n  position: relative !important; }\n/* Personalized styles for some Ids */\n\n#cardTecnicosDisponibles {\n  padding-top: 10px;\n}\n\n.device {\n  position: relative; }\n  .device > .img-fluid {\n    position: relative; }\n\n.device::before {\n  content: \"\";\n  background-color: #F9FBFD; }\n\n.device::before,\n.device-screen {\n  position: absolute;\n  -o-object-fit: cover;\n     object-fit: cover; }\n\n.device-iphonex::before,\n.device-iphonex > .device-screen {\n  top: 7.784431138%;\n  left: 16.4021164%;\n  width: 66.137566137%;\n  height: 80.838323353%; }\n\n.device-macbook::before,\n.device-macbook > .device-screen {\n  top: 11.53846154%;\n  left: 13.38709677%;\n  width: 73.548387096%;\n  height: 73.076923076%; }\n\n.device-combo {\n  position: relative; }\n\n.device-combo > .device {\n  position: absolute; }\n\n.device-combo-iphonex-iphonex {\n  padding-bottom: 130.250482%; }\n\n.device-combo-iphonex-iphonex > .device-iphonex:first-child {\n  bottom: 0;\n  left: 0;\n  width: 65.5260116%;\n  z-index: 1; }\n\n.device-combo-iphonex-iphonex > .device-iphonex:last-child {\n  top: 0;\n  right: 0;\n  width: 72.8323699%; }\n\n.device-combo-macbook-iphonex,\n.device-combo-iphonex-macbook {\n  padding-bottom: 62.4260355%; }\n\n.device-combo-macbook-iphonex > .device-macbook,\n.device-combo-iphonex-macbook > .device-macbook {\n  width: 91.7159763%; }\n\n.device-combo-macbook-iphonex > .device-iphonex,\n.device-combo-iphonex-macbook > .device-iphonex {\n  width: 27.9585799%;\n  z-index: 1; }\n\n.device-combo-macbook-iphonex > .device-macbook {\n  top: 0;\n  left: 0; }\n\n.device-combo-iphonex-macbook > .device-macbook {\n  top: 0;\n  right: 0; }\n\n.device-combo-macbook-iphonex > .device-iphonex {\n  bottom: 0;\n  right: 0; }\n\n.device-combo-iphonex-macbook > .device-iphonex {\n  bottom: 0;\n  left: 0; }\n\n@media (max-width: 576px) {\n  .card-body {\n    font-size: 0.7rem;\n  }\n  .img-adjust {\n    width: 100% !important;\n    height: 65% !important;\n  }\n  .align-star-rating {\n    font-size: 0.7rem !important;\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .sidenav {\n    position: fixed;\n    top: 84px;\n    \n    height: calc(100vh - 84px);\n    overflow: auto; } }\n\n\n@media (min-width: 992px) {\n  .sidenav-left {\n    left: 0; } }\n\n@media (min-width: 992px) {\n  .sidenav-right {\n    right: 0; } }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .shape > svg {\n    display: none; } }\n\n    .shape {\n      position: absolute;\n      pointer-events: none; \n    }\n    \n    .shape > * {\n      display: block; \n    }\n    \n    .shape:not([class*=\"shape-blur\"]) {\n      overflow: hidden; \n    }\n    \n    .shape:not([class*=\"shape-blur\"]) > * {\n      transform: scale(2); \n    }\n    \n    .shape-top {\n      top: 0;\n      right: 0;\n      left: 0; }\n    \n    .shape-top > * {\n      transform-origin: bottom center; \n    }\n    \n    .shape-right {\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0; }\n    \n    .shape-right > * {\n      position: inherit;\n      top: inherit;\n      bottom: inherit;\n      right: inherit;\n      transform-origin: center left; }\n    \n    .shape-bottom {\n      right: 0;\n      bottom: 0;\n      left: 0; }\n    \n    .shape-bottom > * {\n      transform-origin: top center; \n    }\n    \n    .shape-left {\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0; \n    }\n    \n    .shape-left > * {\n      position: inherit;\n      top: inherit;\n      bottom: inherit;\n      left: inherit;\n      transform-origin: center right; \n    }\n    \n    .shape-fluid-x > * {\n      width: 100%;\n      height: auto; \n    }\n    \n    .shape-fluid-y > * {\n      width: auto;\n      height: 100%; \n    }\n    \n    .shape-blur-1 {\n      top: 0;\n      right: 0;\n      left: 0; \n    }\n    \n      @media (min-width: 768px) {\n        .shape-blur-1 {\n          bottom: 0;\n          left: 50%;\n          right: auto; } }\n    \n    .shape-blur-1 > * {\n      width: 100%;\n      height: auto; }\n      @media (min-width: 768px) {\n        .shape-blur-1 > * {\n          width: auto;\n          height: 100%; } }\n    \n    .shape-blur-2 {\n      top: 0;\n      right: 0;\n      left: 0; }\n      @media (min-width: 768px) {\n        .shape-blur-2 {\n          bottom: 0;\n          right: 50%;\n          left: auto; } }\n    \n    .shape-blur-2 > * {\n      width: 100%;\n      height: auto; }\n      @media (min-width: 768px) {\n        .shape-blur-2 > * {\n          width: auto;\n          height: 100%;\n          float: right; } }\n    \n    .shape-blur-3 {\n      top: 0;\n      right: 0;\n      left: 0; }\n    \n    .shape-blur-3 > * {\n      width: 100%;\n      height: auto; }\n    \n    .shape-blur-4 {\n      top: 0;\n      bottom: 0;\n      left: 50%;\n      transform: translateX(-50%) scale(1.3); }\n    \n    .shape-blur-4 > * {\n      width: auto;\n      height: 100%; }\n\n.overlay {\n  position: relative; }\n    .overlay::before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      border-radius: inherit; }\n  \n  .overlay-primary::before {\n    background-color: #335EEA; }\n  \n  .overlay-gradient-primary-right::before {\n    background-image: linear-gradient(to bottom, transparent, #335EEA); }\n    @media (min-width: 768px) {\n      .overlay-gradient-primary-right::before {\n        background-image: linear-gradient(to right, transparent, #335EEA 50%, #335EEA); } }\n  \n  .overlay-gradient-primary-down::before {\n    background-image: linear-gradient(to bottom, transparent, #335EEA); }\n  \n  .overlay-gradient-primary-left::before {\n    background-image: linear-gradient(to bottom, transparent, #335EEA); }\n    @media (min-width: 768px) {\n      .overlay-gradient-primary-left::before {\n        background-image: linear-gradient(to left, transparent, #335EEA 50%, #335EEA); } }\n  \n  .overlay-secondary::before {\n    background-color: #506690; }\n  \n  .overlay-gradient-secondary-right::before {\n    background-image: linear-gradient(to bottom, transparent, #506690); }\n    @media (min-width: 768px) {\n      .overlay-gradient-secondary-right::before {\n        background-image: linear-gradient(to right, transparent, #506690 50%, #506690); } }\n  \n  .overlay-gradient-secondary-down::before {\n    background-image: linear-gradient(to bottom, transparent, #506690); }\n  \n  .overlay-gradient-secondary-left::before {\n    background-image: linear-gradient(to bottom, transparent, #506690); }\n    @media (min-width: 768px) {\n      .overlay-gradient-secondary-left::before {\n        background-image: linear-gradient(to left, transparent, #506690 50%, #506690); } }\n  \n  .overlay-success::before {\n    background-color: #42BA96; }\n  \n  .overlay-gradient-success-right::before {\n    background-image: linear-gradient(to bottom, transparent, #42BA96); }\n    @media (min-width: 768px) {\n      .overlay-gradient-success-right::before {\n        background-image: linear-gradient(to right, transparent, #42BA96 50%, #42BA96); } }\n  \n  .overlay-gradient-success-down::before {\n    background-image: linear-gradient(to bottom, transparent, #42BA96); }\n  \n  .overlay-gradient-success-left::before {\n    background-image: linear-gradient(to bottom, transparent, #42BA96); }\n    @media (min-width: 768px) {\n      .overlay-gradient-success-left::before {\n        background-image: linear-gradient(to left, transparent, #42BA96 50%, #42BA96); } }\n  \n  .overlay-info::before {\n    background-color: #7C69EF; }\n  \n  .overlay-gradient-info-right::before {\n    background-image: linear-gradient(to bottom, transparent, #7C69EF); }\n    @media (min-width: 768px) {\n      .overlay-gradient-info-right::before {\n        background-image: linear-gradient(to right, transparent, #7C69EF 50%, #7C69EF); } }\n  \n  .overlay-gradient-info-down::before {\n    background-image: linear-gradient(to bottom, transparent, #7C69EF); }\n  \n  .overlay-gradient-info-left::before {\n    background-image: linear-gradient(to bottom, transparent, #7C69EF); }\n    @media (min-width: 768px) {\n      .overlay-gradient-info-left::before {\n        background-image: linear-gradient(to left, transparent, #7C69EF 50%, #7C69EF); } }\n  \n  .overlay-warning::before {\n    background-color: #FAD776; }\n  \n  .overlay-gradient-warning-right::before {\n    background-image: linear-gradient(to bottom, transparent, #FAD776); }\n    @media (min-width: 768px) {\n      .overlay-gradient-warning-right::before {\n        background-image: linear-gradient(to right, transparent, #FAD776 50%, #FAD776); } }\n  \n  .overlay-gradient-warning-down::before {\n    background-image: linear-gradient(to bottom, transparent, #FAD776); }\n  \n  .overlay-gradient-warning-left::before {\n    background-image: linear-gradient(to bottom, transparent, #FAD776); }\n    @media (min-width: 768px) {\n      .overlay-gradient-warning-left::before {\n        background-image: linear-gradient(to left, transparent, #FAD776 50%, #FAD776); } }\n  \n  .overlay-danger::before {\n    background-color: #DF4759; }\n  \n  .overlay-gradient-danger-right::before {\n    background-image: linear-gradient(to bottom, transparent, #DF4759); }\n    @media (min-width: 768px) {\n      .overlay-gradient-danger-right::before {\n        background-image: linear-gradient(to right, transparent, #DF4759 50%, #DF4759); } }\n  \n  .overlay-gradient-danger-down::before {\n    background-image: linear-gradient(to bottom, transparent, #DF4759); }\n  \n  .overlay-gradient-danger-left::before {\n    background-image: linear-gradient(to bottom, transparent, #DF4759); }\n    @media (min-width: 768px) {\n      .overlay-gradient-danger-left::before {\n        background-image: linear-gradient(to left, transparent, #DF4759 50%, #DF4759); } }\n  \n  .overlay-light::before {\n    background-color: #F9FBFD; }\n  \n  .overlay-gradient-light-right::before {\n    background-image: linear-gradient(to bottom, transparent, #F9FBFD); }\n    @media (min-width: 768px) {\n      .overlay-gradient-light-right::before {\n        background-image: linear-gradient(to right, transparent, #F9FBFD 50%, #F9FBFD); } }\n  \n  .overlay-gradient-light-down::before {\n    background-image: linear-gradient(to bottom, transparent, #F9FBFD); }\n  \n  .overlay-gradient-light-left::before {\n    background-image: linear-gradient(to bottom, transparent, #F9FBFD); }\n    @media (min-width: 768px) {\n      .overlay-gradient-light-left::before {\n        background-image: linear-gradient(to left, transparent, #F9FBFD 50%, #F9FBFD); } }\n  \n  .overlay-dark::before {\n    background-color: #2B354F; }\n  \n  .overlay-gradient-dark-right::before {\n    background-image: linear-gradient(to bottom, transparent, #2B354F); }\n    @media (min-width: 768px) {\n      .overlay-gradient-dark-right::before {\n        background-image: linear-gradient(to right, transparent, #2B354F 50%, #2B354F); } }\n  \n  .overlay-gradient-dark-down::before {\n    background-image: linear-gradient(to bottom, transparent, #2B354F); }\n  \n  .overlay-gradient-dark-left::before {\n    background-image: linear-gradient(to bottom, transparent, #2B354F); }\n    @media (min-width: 768px) {\n      .overlay-gradient-dark-left::before {\n        background-image: linear-gradient(to left, transparent, #2B354F 50%, #2B354F); } }\n  \n  .overlay-primary-desat::before {\n    background-color: #6C8AEC; }\n  \n  .overlay-gradient-primary-desat-right::before {\n    background-image: linear-gradient(to bottom, transparent, #6C8AEC); }\n    @media (min-width: 768px) {\n      .overlay-gradient-primary-desat-right::before {\n        background-image: linear-gradient(to right, transparent, #6C8AEC 50%, #6C8AEC); } }\n  \n  .overlay-gradient-primary-desat-down::before {\n    background-image: linear-gradient(to bottom, transparent, #6C8AEC); }\n  \n  .overlay-gradient-primary-desat-left::before {\n    background-image: linear-gradient(to bottom, transparent, #6C8AEC); }\n    @media (min-width: 768px) {\n      .overlay-gradient-primary-desat-left::before {\n        background-image: linear-gradient(to left, transparent, #6C8AEC 50%, #6C8AEC); } }\n  \n  .overlay-black::before {\n    background-color: #161C2D; }\n  \n  .overlay-gradient-black-right::before {\n    background-image: linear-gradient(to bottom, transparent, #161C2D); }\n    @media (min-width: 768px) {\n      .overlay-gradient-black-right::before {\n        background-image: linear-gradient(to right, transparent, #161C2D 50%, #161C2D); } }\n  \n  .overlay-gradient-black-down::before {\n    background-image: linear-gradient(to bottom, transparent, #161C2D); }\n  \n  .overlay-gradient-black-left::before {\n    background-image: linear-gradient(to bottom, transparent, #161C2D); }\n    @media (min-width: 768px) {\n      .overlay-gradient-black-left::before {\n        background-image: linear-gradient(to left, transparent, #161C2D 50%, #161C2D); } }\n  \n  .overlay-10::before {\n    opacity: 0.1; }\n  \n  .overlay-20::before {\n    opacity: 0.2; }\n  \n  .overlay-30::before {\n    opacity: 0.3; }\n  \n  .overlay-40::before {\n    opacity: 0.4; }\n  \n  .overlay-50::before {\n    opacity: 0.5; }\n  \n  .overlay-60::before {\n    opacity: 0.6; }\n  \n  .overlay-70::before {\n    opacity: 0.7; }\n  \n  .overlay-80::before {\n    opacity: 0.8; }\n  \n  .overlay-90::before {\n    opacity: 0.9; }\n\n.shape {\n  position: absolute;\n  pointer-events: none; }\n\n.shape > * {\n  display: block; }\n\n.shape:not([class*=\"shape-blur\"]) {\n  overflow: hidden; }\n\n.shape:not([class*=\"shape-blur\"]) > * {\n  transform: scale(2); }\n\n.btn-rounded-circle {\n  padding-left: 0.8125rem;\n  padding-right: 0.8125rem;\n  border-radius: 50rem; }\n  .btn-rounded-circle > * {\n    display: block;\n    line-height: 1;\n    width: 1em; }\n\n.btn-rounded-circle.btn-lg, .btn-group-lg > .btn-rounded-circle.btn {\n  padding-left: 1.122rem;\n  padding-right: 1.122rem; }\n\n.btn-rounded-circle.btn-sm, .btn-group-sm > .btn-rounded-circle.btn {\n  padding-left: 0.5625rem;\n  padding-right: 0.5625rem; }\n\n.text-content h1,\n.text-content h2,\n.text-content h3,\n.text-content h4,\n.text-content h5,block\n.text-content h6,\n.text-content p,\n.text-content ul,\n.text-content ol,\n.text-content blockquote {\n  margin-bottom: 2rem;\n}\n\n.blockquote {\n  padding: 1rem;\n  border-left: 2px solid #4E66F8;\n} \n\n.breadcrumb {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 0.5rem;\n  list-style: none;\n  background-color: transparent;\n  border-radius: 0.4rem;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  display: inline-block;\n  padding-right: 0.5rem;\n  color: #868e96;\n  content: \"—\";\n}\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n\n.breadcrumb-item.active {\n  color: #868e96;\n}\n\n\n.text-content p,\n.text-content ul,\n.text-content ol {\n  font-size: 1.1rem;\n}\n\n.text-content p,\n.text-content ul,\n.text-content ol {\n  color: #868e96;\n}\n\n\n.text-gray-100 {\n  color: #F9FBFD !important; }\n\n.text-gray-200 {\n  color: #F1F4F8 !important; }\n\n.text-gray-300 {\n  color: #D9E2EF !important; }\n\n.text-gray-400 {\n  color: #C6D3E6 !important; }\n\n.text-gray-500 {\n  color: #ABBCD5 !important; }\n\n.text-gray-600 {\n  color: #869AB8 !important; }\n\n.text-gray-700 {\n  color: #506690 !important; }\n\n.text-gray-800 {\n  color: #384C74 !important; }\n\n.text-gray-900 {\n  color: #2B354F !important; }\n\n.text-white-70 {\n  color: rgba(255, 255, 255, 0.7) !important; }\n\n.text-white-75 {\n  color: rgba(255, 255, 255, 0.75) !important; }\n\n.text-white-80 {\n  color: rgba(255, 255, 255, 0.8) !important; }\n\n.text-white {\n  color: #fff!important;\n}\n\n.m-0 {\n margin: 0 !important; }\n.mt-0,\n.my-0 {\n margin-top: 0 !important; }\n.mr-0,\n.mx-0 {\n margin-right: 0 !important; }\n.mb-0,\n.my-0 {\n margin-bottom: 0 !important; }\n.ml-0,\n.mx-0 {\n margin-left: 0 !important; }\n.m-1 {\n margin: 0.25rem !important; }\n.mt-1,\n.my-1 {\n margin-top: 0.25rem !important; }\n.mr-1,\n.mx-1 {\n margin-right: 0.25rem !important; }\n.mb-1,\n.my-1 {\n margin-bottom: 0.25rem !important; }\n.ml-1,\n.mx-1 {\n margin-left: 0.25rem !important; }\n.m-2 {\n margin: 0.5rem !important; }\n.mt-2,\n.my-2 {\n margin-top: 0.5rem !important; }\n.mr-2,\n.mx-2 {\n margin-right: 0.5rem !important; }\n.mb-2,\n.my-2 {\n margin-bottom: 0.5rem !important; }\n.ml-2,\n.mx-2 {\n margin-left: 0.5rem !important; }\n.m-3 {\n margin: 0.75rem !important; }\n.mt-3,\n.my-3 {\n margin-top: 0.75rem !important; }\n.mr-3,\n.mx-3 {\n margin-right: 0.75rem !important; }\n.mb-3,\n.my-3 {\n margin-bottom: 0.75rem !important; }\n.ml-3,\n.mx-3 {\n margin-left: 0.75rem !important; }\n.m-4 {\n margin: 1rem !important; }\n.mt-4,\n.my-4 {\n margin-top: 1rem !important; }\n.mr-4,\n.mx-4 {\n margin-right: 1rem !important; }\n.mb-4,\n.my-4 {\n margin-bottom: 1rem !important; }\n.ml-4,\n.mx-4 {\n margin-left: 1rem !important; }\n.m-5 {\n margin: 1.5rem !important; }\n.mt-5,\n.my-5 {\n margin-top: 1.5rem !important; }\n.mr-5,\n.mx-5 {\n margin-right: 1.5rem !important; }\n.mb-5,\n.my-5 {\n margin-bottom: 1.5rem !important; }\n.ml-5,\n.mx-5 {\n margin-left: 1.5rem !important; }\n.m-6 {\n margin: 2rem !important; }\n.mt-6,\n.my-6 {\n margin-top: 2rem !important; }\n.mr-6,\n.mx-6 {\n margin-right: 2rem !important; }\n.mb-6,\n.my-6 {\n margin-bottom: 2rem !important; }\n.ml-6,\n.mx-6 {\n margin-left: 2rem !important; }\n.m-7 {\n margin: 2.5rem !important; }\n.mt-7,\n.my-7 {\n margin-top: 2.5rem !important; }\n.mr-7,\n.mx-7 {\n margin-right: 2.5rem !important; }\n.mb-7,\n.my-7 {\n margin-bottom: 2.5rem !important; }\n.ml-7,\n.mx-7 {\n margin-left: 2.5rem !important; }\n.m-8 {\n margin: 3rem !important; }\n.mt-8,\n.my-8 {\n margin-top: 3rem !important; }\n.mr-8,\n.mx-8 {\n margin-right: 3rem !important; }\n.mb-8,\n.my-8 {\n margin-bottom: 3rem !important; }\n.ml-8,\n.mx-8 {\n margin-left: 3rem !important; }\n.m-9 {\n margin: 4rem !important; }\n.mt-9,\n.my-9 {\n margin-top: 4rem !important; }\n.mr-9,\n.mx-9 {\n margin-right: 4rem !important; }\n.mb-9,\n.my-9 {\n margin-bottom: 4rem !important; }\n.ml-9,\n.mx-9 {\n margin-left: 4rem !important; }\n.m-10 {\n margin: 5rem !important; }\n.mt-10,\n.my-10 {\n margin-top: 5rem !important; }\n.mr-10,\n.mx-10 {\n margin-right: 5rem !important; }\n.mb-10,\n.my-10 {\n margin-bottom: 5rem !important; }\n.ml-10,\n.mx-10 {\n margin-left: 5rem !important; }\n.m-11 {\n margin: 6rem !important; }\n.mt-11,\n.my-11 {\n margin-top: 6rem !important; }\n.mr-11,\n.mx-11 {\n margin-right: 6rem !important; }\n.mb-11,\n.my-11 {\n margin-bottom: 6rem !important; }\n.ml-11,\n.mx-11 {\n margin-left: 6rem !important; }\n.m-12 {\n margin: 8rem !important; }\n.mt-12,\n.my-12 {\n margin-top: 8rem !important; }\n.mr-12,\n.mx-12 {\n margin-right: 8rem !important; }\n.mb-12,\n.my-12 {\n margin-bottom: 8rem !important; }\n.ml-12,\n.mx-12 {\n margin-left: 8rem !important; }\n.m-13 {\n margin: 10rem !important; }\n.mt-13,\n.my-13 {\n margin-top: 10rem !important; }\n.mr-13,\n.mx-13 {\n margin-right: 10rem !important; }\n.mb-13,\n.my-13 {\n margin-bottom: 10rem !important; }\n.ml-13,\n.mx-13 {\n margin-left: 10rem !important; }\n.m-14 {\n margin: 12rem !important; }\n.mt-14,\n.my-14 {\n margin-top: 12rem !important; }\n.mr-14,\n.mx-14 {\n margin-right: 12rem !important; }\n.mb-14,\n.my-14 {\n margin-bottom: 12rem !important; }\n.ml-14,\n.mx-14 {\n margin-left: 12rem !important; }\n.m-15 {\n margin: 16rem !important; }\n.mt-15,\n.my-15 {\n margin-top: 16rem !important; }\n.mr-15,\n.mx-15 {\n margin-right: 16rem !important; }\n.mb-15,\n.my-15 {\n margin-bottom: 16rem !important; }\n.ml-15,\n.mx-15 {\n margin-left: 16rem !important; }\n.m-16 {\n margin: 25rem !important; }\n.mt-16,\n.my-16 {\n margin-top: 25rem !important; }\n.mr-16,\n.mx-16 {\n margin-right: 25rem !important; }\n.mb-16,\n.my-16 {\n margin-bottom: 25rem !important; }\n.ml-16,\n.mx-16 {\n margin-left: 25rem !important; }\n.p-0 {\n padding: 0 !important; }\n.pt-0,\n.py-0 {\n padding-top: 0 !important; }\n.pr-0,\n.px-0 {\n padding-right: 0 !important; }\n.pb-0,\n.py-0 {\n padding-bottom: 0 !important; }\n.pl-0,\n.px-0 {\n padding-left: 0 !important; }\n.p-1 {\n padding: 0.25rem !important; }\n.pt-1,\n.py-1 {\n padding-top: 0.25rem !important; }\n.pr-1,\n.px-1 {\n padding-right: 0.25rem !important; }\n.pb-1,\n.py-1 {\n padding-bottom: 0.25rem !important; }\n.pl-1,\n.px-1 {\n padding-left: 0.25rem !important; }\n.p-2 {\n padding: 0.5rem !important; }\n.pt-2,\n.py-2 {\n padding-top: 0.5rem !important; }\n.pr-2,\n.px-2 {\n padding-right: 0.5rem !important; }\n.pb-2,\n.py-2 {\n padding-bottom: 0.5rem !important; }\n.pl-2,\n.px-2 {\n padding-left: 0.5rem !important; }\n.p-3 {\n padding: 0.75rem !important; }\n.pt-3,\n.py-3 {\n padding-top: 0.75rem !important; }\n.pr-3,\n.px-3 {\n padding-right: 0.75rem !important; }\n.pb-3,\n.py-3 {\n padding-bottom: 0.75rem !important; }\n.pl-3,\n.px-3 {\n padding-left: 0.75rem !important; }\n.p-4 {\n padding: 1rem !important; }\n.pt-4,\n.py-4 {\n padding-top: 1rem !important; }\n.pr-4,\n.px-4 {\n padding-right: 1rem !important; }\n.pb-4,\n.py-4 {\n padding-bottom: 1rem !important; }\n.pl-4,\n.px-4 {\n padding-left: 1rem !important; }\n.p-5 {\n padding: 1.5rem !important; }\n.pt-5,\n.py-5 {\n padding-top: 1.5rem !important; }\n.pr-5,\n.px-5 {\n padding-right: 1.5rem !important; }\n.pb-5,\n.py-5 {\n padding-bottom: 1.5rem !important; }\n.pl-5,\n.px-5 {\n padding-left: 1.5rem !important; }\n.p-6 {\n padding: 2rem !important; }\n.pt-6,\n.py-6 {\n padding-top: 2rem !important; }\n.pr-6,\n.px-6 {\n padding-right: 2rem !important; }\n.pb-6,\n.py-6 {\n padding-bottom: 2rem !important; }\n.pl-6,\n.px-6 {\n padding-left: 2rem !important; }\n.p-7 {\n padding: 2.5rem !important; }\n.pt-7,\n.py-7 {\n padding-top: 2.5rem !important; }\n.pr-7,\n.px-7 {\n padding-right: 2.5rem !important; }\n.pb-7,\n.py-7 {\n padding-bottom: 2.5rem !important; }\n.pl-7,\n.px-7 {\n padding-left: 2.5rem !important; }\n.p-8 {\n padding: 3rem !important; }\n.pt-8,\n.py-8 {\n padding-top: 3rem !important; }\n.pr-8,\n.px-8 {\n padding-right: 3rem !important; }\n.pb-8,\n.py-8 {\n padding-bottom: 3rem !important; }\n.pl-8,\n.px-8 {\n padding-left: 3rem !important; }\n.p-9 {\n padding: 4rem !important; }\n.pt-9,\n.py-9 {\n padding-top: 4rem !important; }\n.pr-9,\n.px-9 {\n padding-right: 4rem !important; }\n.pb-9,\n.py-9 {\n padding-bottom: 4rem !important; }\n.pl-9,\n.px-9 {\n padding-left: 4rem !important; }\n.p-10 {\n padding: 5rem !important; }\n.pt-10,\n.py-10 {\n padding-top: 5rem !important; }\n.pr-10,\n.px-10 {\n padding-right: 5rem !important; }\n.pb-10,\n.py-10 {\n padding-bottom: 5rem !important; }\n.pl-10,\n.px-10 {\n padding-left: 5rem !important; }\n.p-11 {\n padding: 6rem !important; }\n.pt-11,\n.py-11 {\n padding-top: 6rem !important; }\n.pr-11,\n.px-11 {\n padding-right: 6rem !important; }\n.pb-11,\n.py-11 {\n padding-bottom: 6rem !important; }\n.pl-11,\n.px-11 {\n padding-left: 6rem !important; }\n.p-12 {\n padding: 8rem !important; }\n.pt-12,\n.py-12 {\n padding-top: 8rem !important; }\n.pr-12,\n.px-12 {\n padding-right: 8rem !important; }\n.pb-12,\n.py-12 {\n padding-bottom: 8rem !important; }\n.pl-12,\n.px-12 {\n padding-left: 8rem !important; }\n.p-13 {\n padding: 10rem !important; }\n.pt-13,\n.py-13 {\n padding-top: 10rem !important; }\n.pr-13,\n.px-13 {\n padding-right: 10rem !important; }\n.pb-13,\n.py-13 {\n padding-bottom: 10rem !important; }\n.pl-13,\n.px-13 {\n padding-left: 10rem !important; }\n.p-14 {\n padding: 12rem !important; }\n.pt-14,\n.py-14 {\n padding-top: 12rem !important; }\n.pr-14,\n.px-14 {\n padding-right: 12rem !important; }\n.pb-14,\n.py-14 {\n padding-bottom: 12rem !important; }\n.pl-14,\n.px-14 {\n padding-left: 12rem !important; }\n.p-15 {\n padding: 16rem !important; }\n.pt-15,\n.py-15 {\n padding-top: 16rem !important; }\n.pr-15,\n.px-15 {\n padding-right: 16rem !important; }\n.pb-15,\n.py-15 {\n padding-bottom: 16rem !important; }\n.pl-15,\n.px-15 {\n padding-left: 16rem !important; }\n.p-16 {\n padding: 25rem !important; }\n.pt-16,\n.py-16 {\n padding-top: 25rem !important; }\n.pr-16,\n.px-16 {\n padding-right: 25rem !important; }\n.pb-16,\n.py-16 {\n padding-bottom: 25rem !important; }\n.pl-16,\n.px-16 {\n padding-left: 25rem !important; }\n.m-n1 {\n margin: -0.25rem !important; }\n.mt-n1,\n.my-n1 {\n margin-top: -0.25rem !important; }\n.mr-n1,\n.mx-n1 {\n margin-right: -0.25rem !important; }\n.mb-n1,\n.my-n1 {\n margin-bottom: -0.25rem !important; }\n.ml-n1,\n.mx-n1 {\n margin-left: -0.25rem !important; }\n.m-n2 {\n margin: -0.5rem !important; }\n.mt-n2,\n.my-n2 {\n margin-top: -0.5rem !important; }\n.mr-n2,\n.mx-n2 {\n margin-right: -0.5rem !important; }\n.mb-n2,\n.my-n2 {\n margin-bottom: -0.5rem !important; }\n.ml-n2,\n.mx-n2 {\n margin-left: -0.5rem !important; }\n.m-n3 {\n margin: -0.75rem !important; }\n.mt-n3,\n.my-n3 {\n margin-top: -0.75rem !important; }\n.mr-n3,\n.mx-n3 {\n margin-right: -0.75rem !important; }\n.mb-n3,\n.my-n3 {\n margin-bottom: -0.75rem !important; }\n.ml-n3,\n.mx-n3 {\n margin-left: -0.75rem !important; }\n.m-n4 {\n margin: -1rem !important; }\n.mt-n4,\n.my-n4 {\n margin-top: -1rem !important; }\n.mr-n4,\n.mx-n4 {\n margin-right: -1rem !important; }\n.mb-n4,\n.my-n4 {\n margin-bottom: -1rem !important; }\n.ml-n4,\n.mx-n4 {\n margin-left: -1rem !important; }\n.m-n5 {\n margin: -1.5rem !important; }\n.mt-n5,\n.my-n5 {\n margin-top: -1.5rem !important; }\n.mr-n5,\n.mx-n5 {\n margin-right: -1.5rem !important; }\n.mb-n5,\n.my-n5 {\n margin-bottom: -1.5rem !important; }\n.ml-n5,\n.mx-n5 {\n margin-left: -1.5rem !important; }\n.m-n6 {\n margin: -2rem !important; }\n.mt-n6,\n.my-n6 {\n margin-top: -2rem !important; }\n.mr-n6,\n.mx-n6 {\n margin-right: -2rem !important; }\n.mb-n6,\n.my-n6 {\n margin-bottom: -2rem !important; }\n.ml-n6,\n.mx-n6 {\n margin-left: -2rem !important; }\n.m-n7 {\n margin: -2.5rem !important; }\n.mt-n7,\n.my-n7 {\n margin-top: -2.5rem !important; }\n.mr-n7,\n.mx-n7 {\n margin-right: -2.5rem !important; }\n.mb-n7,\n.my-n7 {\n margin-bottom: -2.5rem !important; }\n.ml-n7,\n.mx-n7 {\n margin-left: -2.5rem !important; }\n.m-n8 {\n margin: -3rem !important; }\n.mt-n8,\n.my-n8 {\n margin-top: -3rem !important; }\n.mr-n8,\n.mx-n8 {\n margin-right: -3rem !important; }\n.mb-n8,\n.my-n8 {\n margin-bottom: -3rem !important; }\n.ml-n8,\n.mx-n8 {\n margin-left: -3rem !important; }\n.m-n9 {\n margin: -4rem !important; }\n.mt-n9,\n.my-n9 {\n margin-top: -4rem !important; }\n.mr-n9,\n.mx-n9 {\n margin-right: -4rem !important; }\n.mb-n9,\n.my-n9 {\n margin-bottom: -4rem !important; }\n.ml-n9,\n.mx-n9 {\n margin-left: -4rem !important; }\n.m-n10 {\n margin: -5rem !important; }\n.mt-n10,\n.my-n10 {\n margin-top: -5rem !important; }\n.mr-n10,\n.mx-n10 {\n margin-right: -5rem !important; }\n.mb-n10,\n.my-n10 {\n margin-bottom: -5rem !important; }\n.ml-n10,\n.mx-n10 {\n margin-left: -5rem !important; }\n.m-n11 {\n margin: -6rem !important; }\n.mt-n11,\n.my-n11 {\n margin-top: -6rem !important; }\n.mr-n11,\n.mx-n11 {\n margin-right: -6rem !important; }\n.mb-n11,\n.my-n11 {\n margin-bottom: -6rem !important; }\n.ml-n11,\n.mx-n11 {\n margin-left: -6rem !important; }\n.m-n12 {\n margin: -8rem !important; }\n.mt-n12,\n.my-n12 {\n margin-top: -8rem !important; }\n.mr-n12,\n.mx-n12 {\n margin-right: -8rem !important; }\n.mb-n12,\n.my-n12 {\n margin-bottom: -8rem !important; }\n.ml-n12,\n.mx-n12 {\n margin-left: -8rem !important; }\n.m-n13 {\n margin: -10rem !important; }\n.mt-n13,\n.my-n13 {\n margin-top: -10rem !important; }\n.mr-n13,\n.mx-n13 {\n margin-right: -10rem !important; }\n.mb-n13,\n.my-n13 {\n margin-bottom: -10rem !important; }\n.ml-n13,\n.mx-n13 {\n margin-left: -10rem !important; }\n.m-n14 {\n margin: -12rem !important; }\n.mt-n14,\n.my-n14 {\n margin-top: -12rem !important; }\n.mr-n14,\n.mx-n14 {\n margin-right: -12rem !important; }\n.mb-n14,\n.my-n14 {\n margin-bottom: -12rem !important; }\n.ml-n14,\n.mx-n14 {\n margin-left: -12rem !important; }\n.m-n15 {\n margin: -16rem !important; }\n.mt-n15,\n.my-n15 {\n margin-top: -16rem !important; }\n.mr-n15,\n.mx-n15 {\n margin-right: -16rem !important; }\n.mb-n15,\n.my-n15 {\n margin-bottom: -16rem !important; }\n.ml-n15,\n.mx-n15 {\n margin-left: -16rem !important; }\n.m-n16 {\n margin: -25rem !important; }\n.mt-n16,\n.my-n16 {\n margin-top: -25rem !important; }\n.mr-n16,\n.mx-n16 {\n margin-right: -25rem !important; }\n.mb-n16,\n.my-n16 {\n margin-bottom: -25rem !important; }\n.ml-n16,\n.mx-n16 {\n margin-left: -25rem !important; }\n.m-auto {\n margin: auto !important; }\n.mt-auto,\n.my-auto {\n margin-top: auto !important; }\n.mr-auto,\n.mx-auto {\n margin-right: auto !important; }\n.mb-auto,\n.my-auto {\n margin-bottom: auto !important; }\n.ml-auto,\n.mx-auto {\n margin-left: auto !important; }\n@media (min-width: 576px) {\n .m-sm-0 {\n   margin: 0 !important; }\n .mt-sm-0,\n .my-sm-0 {\n   margin-top: 0 !important; }\n .mr-sm-0,\n .mx-sm-0 {\n   margin-right: 0 !important; }\n .mb-sm-0,\n .my-sm-0 {\n   margin-bottom: 0 !important; }\n .ml-sm-0,\n .mx-sm-0 {\n   margin-left: 0 !important; }\n .m-sm-1 {\n   margin: 0.25rem !important; }\n .mt-sm-1,\n .my-sm-1 {\n   margin-top: 0.25rem !important; }\n .mr-sm-1,\n .mx-sm-1 {\n   margin-right: 0.25rem !important; }\n .mb-sm-1,\n .my-sm-1 {\n   margin-bottom: 0.25rem !important; }\n .ml-sm-1,\n .mx-sm-1 {\n   margin-left: 0.25rem !important; }\n .m-sm-2 {\n   margin: 0.5rem !important; }\n .mt-sm-2,\n .my-sm-2 {\n   margin-top: 0.5rem !important; }\n .mr-sm-2,\n .mx-sm-2 {\n   margin-right: 0.5rem !important; }\n .mb-sm-2,\n .my-sm-2 {\n   margin-bottom: 0.5rem !important; }\n .ml-sm-2,\n .mx-sm-2 {\n   margin-left: 0.5rem !important; }\n .m-sm-3 {\n   margin: 0.75rem !important; }\n .mt-sm-3,\n .my-sm-3 {\n   margin-top: 0.75rem !important; }\n .mr-sm-3,\n .mx-sm-3 {\n   margin-right: 0.75rem !important; }\n .mb-sm-3,\n .my-sm-3 {\n   margin-bottom: 0.75rem !important; }\n .ml-sm-3,\n .mx-sm-3 {\n   margin-left: 0.75rem !important; }\n .m-sm-4 {\n   margin: 1rem !important; }\n .mt-sm-4,\n .my-sm-4 {\n   margin-top: 1rem !important; }\n .mr-sm-4,\n .mx-sm-4 {\n   margin-right: 1rem !important; }\n .mb-sm-4,\n .my-sm-4 {\n   margin-bottom: 1rem !important; }\n .ml-sm-4,\n .mx-sm-4 {\n   margin-left: 1rem !important; }\n .m-sm-5 {\n   margin: 1.5rem !important; }\n .mt-sm-5,\n .my-sm-5 {\n   margin-top: 1.5rem !important; }\n .mr-sm-5,\n .mx-sm-5 {\n   margin-right: 1.5rem !important; }\n .mb-sm-5,\n .my-sm-5 {\n   margin-bottom: 1.5rem !important; }\n .ml-sm-5,\n .mx-sm-5 {\n   margin-left: 1.5rem !important; }\n .m-sm-6 {\n   margin: 2rem !important; }\n .mt-sm-6,\n .my-sm-6 {\n   margin-top: 2rem !important; }\n .mr-sm-6,\n .mx-sm-6 {\n   margin-right: 2rem !important; }\n .mb-sm-6,\n .my-sm-6 {\n   margin-bottom: 2rem !important; }\n .ml-sm-6,\n .mx-sm-6 {\n   margin-left: 2rem !important; }\n .m-sm-7 {\n   margin: 2.5rem !important; }\n .mt-sm-7,\n .my-sm-7 {\n   margin-top: 2.5rem !important; }\n .mr-sm-7,\n .mx-sm-7 {\n   margin-right: 2.5rem !important; }\n .mb-sm-7,\n .my-sm-7 {\n   margin-bottom: 2.5rem !important; }\n .ml-sm-7,\n .mx-sm-7 {\n   margin-left: 2.5rem !important; }\n .m-sm-8 {\n   margin: 3rem !important; }\n .mt-sm-8,\n .my-sm-8 {\n   margin-top: 3rem !important; }\n .mr-sm-8,\n .mx-sm-8 {\n   margin-right: 3rem !important; }\n .mb-sm-8,\n .my-sm-8 {\n   margin-bottom: 3rem !important; }\n .ml-sm-8,\n .mx-sm-8 {\n   margin-left: 3rem !important; }\n .m-sm-9 {\n   margin: 4rem !important; }\n .mt-sm-9,\n .my-sm-9 {\n   margin-top: 4rem !important; }\n .mr-sm-9,\n .mx-sm-9 {\n   margin-right: 4rem !important; }\n .mb-sm-9,\n .my-sm-9 {\n   margin-bottom: 4rem !important; }\n .ml-sm-9,\n .mx-sm-9 {\n   margin-left: 4rem !important; }\n .m-sm-10 {\n   margin: 5rem !important; }\n .mt-sm-10,\n .my-sm-10 {\n   margin-top: 5rem !important; }\n .mr-sm-10,\n .mx-sm-10 {\n   margin-right: 5rem !important; }\n .mb-sm-10,\n .my-sm-10 {\n   margin-bottom: 5rem !important; }\n .ml-sm-10,\n .mx-sm-10 {\n   margin-left: 5rem !important; }\n .m-sm-11 {\n   margin: 6rem !important; }\n .mt-sm-11,\n .my-sm-11 {\n   margin-top: 6rem !important; }\n .mr-sm-11,\n .mx-sm-11 {\n   margin-right: 6rem !important; }\n .mb-sm-11,\n .my-sm-11 {\n   margin-bottom: 6rem !important; }\n .ml-sm-11,\n .mx-sm-11 {\n   margin-left: 6rem !important; }\n .m-sm-12 {\n   margin: 8rem !important; }\n .mt-sm-12,\n .my-sm-12 {\n   margin-top: 8rem !important; }\n .mr-sm-12,\n .mx-sm-12 {\n   margin-right: 8rem !important; }\n .mb-sm-12,\n .my-sm-12 {\n   margin-bottom: 8rem !important; }\n .ml-sm-12,\n .mx-sm-12 {\n   margin-left: 8rem !important; }\n .m-sm-13 {\n   margin: 10rem !important; }\n .mt-sm-13,\n .my-sm-13 {\n   margin-top: 10rem !important; }\n .mr-sm-13,\n .mx-sm-13 {\n   margin-right: 10rem !important; }\n .mb-sm-13,\n .my-sm-13 {\n   margin-bottom: 10rem !important; }\n .ml-sm-13,\n .mx-sm-13 {\n   margin-left: 10rem !important; }\n .m-sm-14 {\n   margin: 12rem !important; }\n .mt-sm-14,\n .my-sm-14 {\n   margin-top: 12rem !important; }\n .mr-sm-14,\n .mx-sm-14 {\n   margin-right: 12rem !important; }\n .mb-sm-14,\n .my-sm-14 {\n   margin-bottom: 12rem !important; }\n .ml-sm-14,\n .mx-sm-14 {\n   margin-left: 12rem !important; }\n .m-sm-15 {\n   margin: 16rem !important; }\n .mt-sm-15,\n .my-sm-15 {\n   margin-top: 16rem !important; }\n .mr-sm-15,\n .mx-sm-15 {\n   margin-right: 16rem !important; }\n .mb-sm-15,\n .my-sm-15 {\n   margin-bottom: 16rem !important; }\n .ml-sm-15,\n .mx-sm-15 {\n   margin-left: 16rem !important; }\n .m-sm-16 {\n   margin: 25rem !important; }\n .mt-sm-16,\n .my-sm-16 {\n   margin-top: 25rem !important; }\n .mr-sm-16,\n .mx-sm-16 {\n   margin-right: 25rem !important; }\n .mb-sm-16,\n .my-sm-16 {\n   margin-bottom: 25rem !important; }\n .ml-sm-16,\n .mx-sm-16 {\n   margin-left: 25rem !important; }\n .p-sm-0 {\n   padding: 0 !important; }\n .pt-sm-0,\n .py-sm-0 {\n   padding-top: 0 !important; }\n .pr-sm-0,\n .px-sm-0 {\n   padding-right: 0 !important; }\n .pb-sm-0,\n .py-sm-0 {\n   padding-bottom: 0 !important; }\n .pl-sm-0,\n .px-sm-0 {\n   padding-left: 0 !important; }\n .p-sm-1 {\n   padding: 0.25rem !important; }\n .pt-sm-1,\n .py-sm-1 {\n   padding-top: 0.25rem !important; }\n .pr-sm-1,\n .px-sm-1 {\n   padding-right: 0.25rem !important; }\n .pb-sm-1,\n .py-sm-1 {\n   padding-bottom: 0.25rem !important; }\n .pl-sm-1,\n .px-sm-1 {\n   padding-left: 0.25rem !important; }\n .p-sm-2 {\n   padding: 0.5rem !important; }\n .pt-sm-2,\n .py-sm-2 {\n   padding-top: 0.5rem !important; }\n .pr-sm-2,\n .px-sm-2 {\n   padding-right: 0.5rem !important; }\n .pb-sm-2,\n .py-sm-2 {\n   padding-bottom: 0.5rem !important; }\n .pl-sm-2,\n .px-sm-2 {\n   padding-left: 0.5rem !important; }\n .p-sm-3 {\n   padding: 0.75rem !important; }\n .pt-sm-3,\n .py-sm-3 {\n   padding-top: 0.75rem !important; }\n .pr-sm-3,\n .px-sm-3 {\n   padding-right: 0.75rem !important; }\n .pb-sm-3,\n .py-sm-3 {\n   padding-bottom: 0.75rem !important; }\n .pl-sm-3,\n .px-sm-3 {\n   padding-left: 0.75rem !important; }\n .p-sm-4 {\n   padding: 1rem !important; }\n .pt-sm-4,\n .py-sm-4 {\n   padding-top: 1rem !important; }\n .pr-sm-4,\n .px-sm-4 {\n   padding-right: 1rem !important; }\n .pb-sm-4,\n .py-sm-4 {\n   padding-bottom: 1rem !important; }\n .pl-sm-4,\n .px-sm-4 {\n   padding-left: 1rem !important; }\n .p-sm-5 {\n   padding: 1.5rem !important; }\n .pt-sm-5,\n .py-sm-5 {\n   padding-top: 1.5rem !important; }\n .pr-sm-5,\n .px-sm-5 {\n   padding-right: 1.5rem !important; }\n .pb-sm-5,\n .py-sm-5 {\n   padding-bottom: 1.5rem !important; }\n .pl-sm-5,\n .px-sm-5 {\n   padding-left: 1.5rem !important; }\n .p-sm-6 {\n   padding: 2rem !important; }\n .pt-sm-6,\n .py-sm-6 {\n   padding-top: 2rem !important; }\n .pr-sm-6,\n .px-sm-6 {\n   padding-right: 2rem !important; }\n .pb-sm-6,\n .py-sm-6 {\n   padding-bottom: 2rem !important; }\n .pl-sm-6,\n .px-sm-6 {\n   padding-left: 2rem !important; }\n .p-sm-7 {\n   padding: 2.5rem !important; }\n .pt-sm-7,\n .py-sm-7 {\n   padding-top: 2.5rem !important; }\n .pr-sm-7,\n .px-sm-7 {\n   padding-right: 2.5rem !important; }\n .pb-sm-7,\n .py-sm-7 {\n   padding-bottom: 2.5rem !important; }\n .pl-sm-7,\n .px-sm-7 {\n   padding-left: 2.5rem !important; }\n .p-sm-8 {\n   padding: 3rem !important; }\n .pt-sm-8,\n .py-sm-8 {\n   padding-top: 3rem !important; }\n .pr-sm-8,\n .px-sm-8 {\n   padding-right: 3rem !important; }\n .pb-sm-8,\n .py-sm-8 {\n   padding-bottom: 3rem !important; }\n .pl-sm-8,\n .px-sm-8 {\n   padding-left: 3rem !important; }\n .p-sm-9 {\n   padding: 4rem !important; }\n .pt-sm-9,\n .py-sm-9 {\n   padding-top: 4rem !important; }\n .pr-sm-9,\n .px-sm-9 {\n   padding-right: 4rem !important; }\n .pb-sm-9,\n .py-sm-9 {\n   padding-bottom: 4rem !important; }\n .pl-sm-9,\n .px-sm-9 {\n   padding-left: 4rem !important; }\n .p-sm-10 {\n   padding: 5rem !important; }\n .pt-sm-10,\n .py-sm-10 {\n   padding-top: 5rem !important; }\n .pr-sm-10,\n .px-sm-10 {\n   padding-right: 5rem !important; }\n .pb-sm-10,\n .py-sm-10 {\n   padding-bottom: 5rem !important; }\n .pl-sm-10,\n .px-sm-10 {\n   padding-left: 5rem !important; }\n .p-sm-11 {\n   padding: 6rem !important; }\n .pt-sm-11,\n .py-sm-11 {\n   padding-top: 6rem !important; }\n .pr-sm-11,\n .px-sm-11 {\n   padding-right: 6rem !important; }\n .pb-sm-11,\n .py-sm-11 {\n   padding-bottom: 6rem !important; }\n .pl-sm-11,\n .px-sm-11 {\n   padding-left: 6rem !important; }\n .p-sm-12 {\n   padding: 8rem !important; }\n .pt-sm-12,\n .py-sm-12 {\n   padding-top: 8rem !important; }\n .pr-sm-12,\n .px-sm-12 {\n   padding-right: 8rem !important; }\n .pb-sm-12,\n .py-sm-12 {\n   padding-bottom: 8rem !important; }\n .pl-sm-12,\n .px-sm-12 {\n   padding-left: 8rem !important; }\n .p-sm-13 {\n   padding: 10rem !important; }\n .pt-sm-13,\n .py-sm-13 {\n   padding-top: 10rem !important; }\n .pr-sm-13,\n .px-sm-13 {\n   padding-right: 10rem !important; }\n .pb-sm-13,\n .py-sm-13 {\n   padding-bottom: 10rem !important; }\n .pl-sm-13,\n .px-sm-13 {\n   padding-left: 10rem !important; }\n .p-sm-14 {\n   padding: 12rem !important; }\n .pt-sm-14,\n .py-sm-14 {\n   padding-top: 12rem !important; }\n .pr-sm-14,\n .px-sm-14 {\n   padding-right: 12rem !important; }\n .pb-sm-14,\n .py-sm-14 {\n   padding-bottom: 12rem !important; }\n .pl-sm-14,\n .px-sm-14 {\n   padding-left: 12rem !important; }\n .p-sm-15 {\n   padding: 16rem !important; }\n .pt-sm-15,\n .py-sm-15 {\n   padding-top: 16rem !important; }\n .pr-sm-15,\n .px-sm-15 {\n   padding-right: 16rem !important; }\n .pb-sm-15,\n .py-sm-15 {\n   padding-bottom: 16rem !important; }\n .pl-sm-15,\n .px-sm-15 {\n   padding-left: 16rem !important; }\n .p-sm-16 {\n   padding: 25rem !important; }\n .pt-sm-16,\n .py-sm-16 {\n   padding-top: 25rem !important; }\n .pr-sm-16,\n .px-sm-16 {\n   padding-right: 25rem !important; }\n .pb-sm-16,\n .py-sm-16 {\n   padding-bottom: 25rem !important; }\n .pl-sm-16,\n .px-sm-16 {\n   padding-left: 25rem !important; }\n .m-sm-n1 {\n   margin: -0.25rem !important; }\n .mt-sm-n1,\n .my-sm-n1 {\n   margin-top: -0.25rem !important; }\n .mr-sm-n1,\n .mx-sm-n1 {\n   margin-right: -0.25rem !important; }\n .mb-sm-n1,\n .my-sm-n1 {\n   margin-bottom: -0.25rem !important; }\n .ml-sm-n1,\n .mx-sm-n1 {\n   margin-left: -0.25rem !important; }\n .m-sm-n2 {\n   margin: -0.5rem !important; }\n .mt-sm-n2,\n .my-sm-n2 {\n   margin-top: -0.5rem !important; }\n .mr-sm-n2,\n .mx-sm-n2 {\n   margin-right: -0.5rem !important; }\n .mb-sm-n2,\n .my-sm-n2 {\n   margin-bottom: -0.5rem !important; }\n .ml-sm-n2,\n .mx-sm-n2 {\n   margin-left: -0.5rem !important; }\n .m-sm-n3 {\n   margin: -0.75rem !important; }\n .mt-sm-n3,\n .my-sm-n3 {\n   margin-top: -0.75rem !important; }\n .mr-sm-n3,\n .mx-sm-n3 {\n   margin-right: -0.75rem !important; }\n .mb-sm-n3,\n .my-sm-n3 {\n   margin-bottom: -0.75rem !important; }\n .ml-sm-n3,\n .mx-sm-n3 {\n   margin-left: -0.75rem !important; }\n .m-sm-n4 {\n   margin: -1rem !important; }\n .mt-sm-n4,\n .my-sm-n4 {\n   margin-top: -1rem !important; }\n .mr-sm-n4,\n .mx-sm-n4 {\n   margin-right: -1rem !important; }\n .mb-sm-n4,\n .my-sm-n4 {\n   margin-bottom: -1rem !important; }\n .ml-sm-n4,\n .mx-sm-n4 {\n   margin-left: -1rem !important; }\n .m-sm-n5 {\n   margin: -1.5rem !important; }\n .mt-sm-n5,\n .my-sm-n5 {\n   margin-top: -1.5rem !important; }\n .mr-sm-n5,\n .mx-sm-n5 {\n   margin-right: -1.5rem !important; }\n .mb-sm-n5,\n .my-sm-n5 {\n   margin-bottom: -1.5rem !important; }\n .ml-sm-n5,\n .mx-sm-n5 {\n   margin-left: -1.5rem !important; }\n .m-sm-n6 {\n   margin: -2rem !important; }\n .mt-sm-n6,\n .my-sm-n6 {\n   margin-top: -2rem !important; }\n .mr-sm-n6,\n .mx-sm-n6 {\n   margin-right: -2rem !important; }\n .mb-sm-n6,\n .my-sm-n6 {\n   margin-bottom: -2rem !important; }\n .ml-sm-n6,\n .mx-sm-n6 {\n   margin-left: -2rem !important; }\n .m-sm-n7 {\n   margin: -2.5rem !important; }\n .mt-sm-n7,\n .my-sm-n7 {\n   margin-top: -2.5rem !important; }\n .mr-sm-n7,\n .mx-sm-n7 {\n   margin-right: -2.5rem !important; }\n .mb-sm-n7,\n .my-sm-n7 {\n   margin-bottom: -2.5rem !important; }\n .ml-sm-n7,\n .mx-sm-n7 {\n   margin-left: -2.5rem !important; }\n .m-sm-n8 {\n   margin: -3rem !important; }\n .mt-sm-n8,\n .my-sm-n8 {\n   margin-top: -3rem !important; }\n .mr-sm-n8,\n .mx-sm-n8 {\n   margin-right: -3rem !important; }\n .mb-sm-n8,\n .my-sm-n8 {\n   margin-bottom: -3rem !important; }\n .ml-sm-n8,\n .mx-sm-n8 {\n   margin-left: -3rem !important; }\n .m-sm-n9 {\n   margin: -4rem !important; }\n .mt-sm-n9,\n .my-sm-n9 {\n   margin-top: -4rem !important; }\n .mr-sm-n9,\n .mx-sm-n9 {\n   margin-right: -4rem !important; }\n .mb-sm-n9,\n .my-sm-n9 {\n   margin-bottom: -4rem !important; }\n .ml-sm-n9,\n .mx-sm-n9 {\n   margin-left: -4rem !important; }\n .m-sm-n10 {\n   margin: -5rem !important; }\n .mt-sm-n10,\n .my-sm-n10 {\n   margin-top: -5rem !important; }\n .mr-sm-n10,\n .mx-sm-n10 {\n   margin-right: -5rem !important; }\n .mb-sm-n10,\n .my-sm-n10 {\n   margin-bottom: -5rem !important; }\n .ml-sm-n10,\n .mx-sm-n10 {\n   margin-left: -5rem !important; }\n .m-sm-n11 {\n   margin: -6rem !important; }\n .mt-sm-n11,\n .my-sm-n11 {\n   margin-top: -6rem !important; }\n .mr-sm-n11,\n .mx-sm-n11 {\n   margin-right: -6rem !important; }\n .mb-sm-n11,\n .my-sm-n11 {\n   margin-bottom: -6rem !important; }\n .ml-sm-n11,\n .mx-sm-n11 {\n   margin-left: -6rem !important; }\n .m-sm-n12 {\n   margin: -8rem !important; }\n .mt-sm-n12,\n .my-sm-n12 {\n   margin-top: -8rem !important; }\n .mr-sm-n12,\n .mx-sm-n12 {\n   margin-right: -8rem !important; }\n .mb-sm-n12,\n .my-sm-n12 {\n   margin-bottom: -8rem !important; }\n .ml-sm-n12,\n .mx-sm-n12 {\n   margin-left: -8rem !important; }\n .m-sm-n13 {\n   margin: -10rem !important; }\n .mt-sm-n13,\n .my-sm-n13 {\n   margin-top: -10rem !important; }\n .mr-sm-n13,\n .mx-sm-n13 {\n   margin-right: -10rem !important; }\n .mb-sm-n13,\n .my-sm-n13 {\n   margin-bottom: -10rem !important; }\n .ml-sm-n13,\n .mx-sm-n13 {\n   margin-left: -10rem !important; }\n .m-sm-n14 {\n   margin: -12rem !important; }\n .mt-sm-n14,\n .my-sm-n14 {\n   margin-top: -12rem !important; }\n .mr-sm-n14,\n .mx-sm-n14 {\n   margin-right: -12rem !important; }\n .mb-sm-n14,\n .my-sm-n14 {\n   margin-bottom: -12rem !important; }\n .ml-sm-n14,\n .mx-sm-n14 {\n   margin-left: -12rem !important; }\n .m-sm-n15 {\n   margin: -16rem !important; }\n .mt-sm-n15,\n .my-sm-n15 {\n   margin-top: -16rem !important; }\n .mr-sm-n15,\n .mx-sm-n15 {\n   margin-right: -16rem !important; }\n .mb-sm-n15,\n .my-sm-n15 {\n   margin-bottom: -16rem !important; }\n .ml-sm-n15,\n .mx-sm-n15 {\n   margin-left: -16rem !important; }\n .m-sm-n16 {\n   margin: -25rem !important; }\n .mt-sm-n16,\n .my-sm-n16 {\n   margin-top: -25rem !important; }\n .mr-sm-n16,\n .mx-sm-n16 {\n   margin-right: -25rem !important; }\n .mb-sm-n16,\n .my-sm-n16 {\n   margin-bottom: -25rem !important; }\n .ml-sm-n16,\n .mx-sm-n16 {\n   margin-left: -25rem !important; }\n .m-sm-auto {\n   margin: auto !important; }\n .mt-sm-auto,\n .my-sm-auto {\n   margin-top: auto !important; }\n .mr-sm-auto,\n .mx-sm-auto {\n   margin-right: auto !important; }\n .mb-sm-auto,\n .my-sm-auto {\n   margin-bottom: auto !important; }\n .ml-sm-auto,\n .mx-sm-auto {\n   margin-left: auto !important; } }\n@media (min-width: 768px) {\n .m-md-0 {\n   margin: 0 !important; }\n .mt-md-0,\n .my-md-0 {\n   margin-top: 0 !important; }\n .mr-md-0,\n .mx-md-0 {\n   margin-right: 0 !important; }\n .mb-md-0,\n .my-md-0 {\n   margin-bottom: 0 !important; }\n .ml-md-0,\n .mx-md-0 {\n   margin-left: 0 !important; }\n .m-md-1 {\n   margin: 0.25rem !important; }\n .mt-md-1,\n .my-md-1 {\n   margin-top: 0.25rem !important; }\n .mr-md-1,\n .mx-md-1 {\n   margin-right: 0.25rem !important; }\n .mb-md-1,\n .my-md-1 {\n   margin-bottom: 0.25rem !important; }\n .ml-md-1,\n .mx-md-1 {\n   margin-left: 0.25rem !important; }\n .m-md-2 {\n   margin: 0.5rem !important; }\n .mt-md-2,\n .my-md-2 {\n   margin-top: 0.5rem !important; }\n .mr-md-2,\n .mx-md-2 {\n   margin-right: 0.5rem !important; }\n .mb-md-2,\n .my-md-2 {\n   margin-bottom: 0.5rem !important; }\n .ml-md-2,\n .mx-md-2 {\n   margin-left: 0.5rem !important; }\n .m-md-3 {\n   margin: 0.75rem !important; }\n .mt-md-3,\n .my-md-3 {\n   margin-top: 0.75rem !important; }\n .mr-md-3,\n .mx-md-3 {\n   margin-right: 0.75rem !important; }\n .mb-md-3,\n .my-md-3 {\n   margin-bottom: 0.75rem !important; }\n .ml-md-3,\n .mx-md-3 {\n   margin-left: 0.75rem !important; }\n .m-md-4 {\n   margin: 1rem !important; }\n .mt-md-4,\n .my-md-4 {\n   margin-top: 1rem !important; }\n .mr-md-4,\n .mx-md-4 {\n   margin-right: 1rem !important; }\n .mb-md-4,\n .my-md-4 {\n   margin-bottom: 1rem !important; }\n .ml-md-4,\n .mx-md-4 {\n   margin-left: 1rem !important; }\n .m-md-5 {\n   margin: 1.5rem !important; }\n .mt-md-5,\n .my-md-5 {\n   margin-top: 1.5rem !important; }\n .mr-md-5,\n .mx-md-5 {\n   margin-right: 1.5rem !important; }\n .mb-md-5,\n .my-md-5 {\n   margin-bottom: 1.5rem !important; }\n .ml-md-5,\n .mx-md-5 {\n   margin-left: 1.5rem !important; }\n .m-md-6 {\n   margin: 2rem !important; }\n .mt-md-6,\n .my-md-6 {\n   margin-top: 2rem !important; }\n .mr-md-6,\n .mx-md-6 {\n   margin-right: 2rem !important; }\n .mb-md-6,\n .my-md-6 {\n   margin-bottom: 2rem !important; }\n .ml-md-6,\n .mx-md-6 {\n   margin-left: 2rem !important; }\n .m-md-7 {\n   margin: 2.5rem !important; }\n .mt-md-7,\n .my-md-7 {\n   margin-top: 2.5rem !important; }\n .mr-md-7,\n .mx-md-7 {\n   margin-right: 2.5rem !important; }\n .mb-md-7,\n .my-md-7 {\n   margin-bottom: 2.5rem !important; }\n .ml-md-7,\n .mx-md-7 {\n   margin-left: 2.5rem !important; }\n .m-md-8 {\n   margin: 3rem !important; }\n .mt-md-8,\n .my-md-8 {\n   margin-top: 3rem !important; }\n .mr-md-8,\n .mx-md-8 {\n   margin-right: 3rem !important; }\n .mb-md-8,\n .my-md-8 {\n   margin-bottom: 3rem !important; }\n .ml-md-8,\n .mx-md-8 {\n   margin-left: 3rem !important; }\n .m-md-9 {\n   margin: 4rem !important; }\n .mt-md-9,\n .my-md-9 {\n   margin-top: 4rem !important; }\n .mr-md-9,\n .mx-md-9 {\n   margin-right: 4rem !important; }\n .mb-md-9,\n .my-md-9 {\n   margin-bottom: 4rem !important; }\n .ml-md-9,\n .mx-md-9 {\n   margin-left: 4rem !important; }\n .m-md-10 {\n   margin: 5rem !important; }\n .mt-md-10,\n .my-md-10 {\n   margin-top: 5rem !important; }\n .mr-md-10,\n .mx-md-10 {\n   margin-right: 5rem !important; }\n .mb-md-10,\n .my-md-10 {\n   margin-bottom: 5rem !important; }\n .ml-md-10,\n .mx-md-10 {\n   margin-left: 5rem !important; }\n .m-md-11 {\n   margin: 6rem !important; }\n .mt-md-11,\n .my-md-11 {\n   margin-top: 6rem !important; }\n .mr-md-11,\n .mx-md-11 {\n   margin-right: 6rem !important; }\n .mb-md-11,\n .my-md-11 {\n   margin-bottom: 6rem !important; }\n .ml-md-11,\n .mx-md-11 {\n   margin-left: 6rem !important; }\n .m-md-12 {\n   margin: 8rem !important; }\n .mt-md-12,\n .my-md-12 {\n   margin-top: 8rem !important; }\n .mr-md-12,\n .mx-md-12 {\n   margin-right: 8rem !important; }\n .mb-md-12,\n .my-md-12 {\n   margin-bottom: 8rem !important; }\n .ml-md-12,\n .mx-md-12 {\n   margin-left: 8rem !important; }\n .m-md-13 {\n   margin: 10rem !important; }\n .mt-md-13,\n .my-md-13 {\n   margin-top: 10rem !important; }\n .mr-md-13,\n .mx-md-13 {\n   margin-right: 10rem !important; }\n .mb-md-13,\n .my-md-13 {\n   margin-bottom: 10rem !important; }\n .ml-md-13,\n .mx-md-13 {\n   margin-left: 10rem !important; }\n .m-md-14 {\n   margin: 12rem !important; }\n .mt-md-14,\n .my-md-14 {\n   margin-top: 12rem !important; }\n .mr-md-14,\n .mx-md-14 {\n   margin-right: 12rem !important; }\n .mb-md-14,\n .my-md-14 {\n   margin-bottom: 12rem !important; }\n .ml-md-14,\n .mx-md-14 {\n   margin-left: 12rem !important; }\n .m-md-15 {\n   margin: 16rem !important; }\n .mt-md-15,\n .my-md-15 {\n   margin-top: 16rem !important; }\n .mr-md-15,\n .mx-md-15 {\n   margin-right: 16rem !important; }\n .mb-md-15,\n .my-md-15 {\n   margin-bottom: 16rem !important; }\n .ml-md-15,\n .mx-md-15 {\n   margin-left: 16rem !important; }\n .m-md-16 {\n   margin: 25rem !important; }\n .mt-md-16,\n .my-md-16 {\n   margin-top: 25rem !important; }\n .mr-md-16,\n .mx-md-16 {\n   margin-right: 25rem !important; }\n .mb-md-16,\n .my-md-16 {\n   margin-bottom: 25rem !important; }\n .ml-md-16,\n .mx-md-16 {\n   margin-left: 25rem !important; }\n .p-md-0 {\n   padding: 0 !important; }\n .pt-md-0,\n .py-md-0 {\n   padding-top: 0 !important; }\n .pr-md-0,\n .px-md-0 {\n   padding-right: 0 !important; }\n .pb-md-0,\n .py-md-0 {\n   padding-bottom: 0 !important; }\n .pl-md-0,\n .px-md-0 {\n   padding-left: 0 !important; }\n .p-md-1 {\n   padding: 0.25rem !important; }\n .pt-md-1,\n .py-md-1 {\n   padding-top: 0.25rem !important; }\n .pr-md-1,\n .px-md-1 {\n   padding-right: 0.25rem !important; }\n .pb-md-1,\n .py-md-1 {\n   padding-bottom: 0.25rem !important; }\n .pl-md-1,\n .px-md-1 {\n   padding-left: 0.25rem !important; }\n .p-md-2 {\n   padding: 0.5rem !important; }\n .pt-md-2,\n .py-md-2 {\n   padding-top: 0.5rem !important; }\n .pr-md-2,\n .px-md-2 {\n   padding-right: 0.5rem !important; }\n .pb-md-2,\n .py-md-2 {\n   padding-bottom: 0.5rem !important; }\n .pl-md-2,\n .px-md-2 {\n   padding-left: 0.5rem !important; }\n .p-md-3 {\n   padding: 0.75rem !important; }\n .pt-md-3,\n .py-md-3 {\n   padding-top: 0.75rem !important; }\n .pr-md-3,\n .px-md-3 {\n   padding-right: 0.75rem !important; }\n .pb-md-3,\n .py-md-3 {\n   padding-bottom: 0.75rem !important; }\n .pl-md-3,\n .px-md-3 {\n   padding-left: 0.75rem !important; }\n .p-md-4 {\n   padding: 1rem !important; }\n .pt-md-4,\n .py-md-4 {\n   padding-top: 1rem !important; }\n .pr-md-4,\n .px-md-4 {\n   padding-right: 1rem !important; }\n .pb-md-4,\n .py-md-4 {\n   padding-bottom: 1rem !important; }\n .pl-md-4,\n .px-md-4 {\n   padding-left: 1rem !important; }\n .p-md-5 {\n   padding: 1.5rem !important; }\n .pt-md-5,\n .py-md-5 {\n   padding-top: 1.5rem !important; }\n .pr-md-5,\n .px-md-5 {\n   padding-right: 1.5rem !important; }\n .pb-md-5,\n .py-md-5 {\n   padding-bottom: 1.5rem !important; }\n .pl-md-5,\n .px-md-5 {\n   padding-left: 1.5rem !important; }\n .p-md-6 {\n   padding: 2rem !important; }\n .pt-md-6,\n .py-md-6 {\n   padding-top: 2rem !important; }\n .pr-md-6,\n .px-md-6 {\n   padding-right: 2rem !important; }\n .pb-md-6,\n .py-md-6 {\n   padding-bottom: 2rem !important; }\n .pl-md-6,\n .px-md-6 {\n   padding-left: 2rem !important; }\n .p-md-7 {\n   padding: 2.5rem !important; }\n .pt-md-7,\n .py-md-7 {\n   padding-top: 2.5rem !important; }\n .pr-md-7,\n .px-md-7 {\n   padding-right: 2.5rem !important; }\n .pb-md-7,\n .py-md-7 {\n   padding-bottom: 2.5rem !important; }\n .pl-md-7,\n .px-md-7 {\n   padding-left: 2.5rem !important; }\n .p-md-8 {\n   padding: 3rem !important; }\n .pt-md-8,\n .py-md-8 {\n   padding-top: 3rem !important; }\n .pr-md-8,\n .px-md-8 {\n   padding-right: 3rem !important; }\n .pb-md-8,\n .py-md-8 {\n   padding-bottom: 3rem !important; }\n .pl-md-8,\n .px-md-8 {\n   padding-left: 3rem !important; }\n .p-md-9 {\n   padding: 4rem !important; }\n .pt-md-9,\n .py-md-9 {\n   padding-top: 4rem !important; }\n .pr-md-9,\n .px-md-9 {\n   padding-right: 4rem !important; }\n .pb-md-9,\n .py-md-9 {\n   padding-bottom: 4rem !important; }\n .pl-md-9,\n .px-md-9 {\n   padding-left: 4rem !important; }\n .p-md-10 {\n   padding: 5rem !important; }\n .pt-md-10,\n .py-md-10 {\n   padding-top: 5rem !important; }\n .pr-md-10,\n .px-md-10 {\n   padding-right: 5rem !important; }\n .pb-md-10,\n .py-md-10 {\n   padding-bottom: 5rem !important; }\n .pl-md-10,\n .px-md-10 {\n   padding-left: 5rem !important; }\n .p-md-11 {\n   padding: 6rem !important; }\n .pt-md-11,\n .py-md-11 {\n   padding-top: 6rem !important; }\n .pr-md-11,\n .px-md-11 {\n   padding-right: 6rem !important; }\n .pb-md-11,\n .py-md-11 {\n   padding-bottom: 6rem !important; }\n .pl-md-11,\n .px-md-11 {\n   padding-left: 6rem !important; }\n .p-md-12 {\n   padding: 8rem !important; }\n .pt-md-12,\n .py-md-12 {\n   padding-top: 8rem !important; }\n .pr-md-12,\n .px-md-12 {\n   padding-right: 8rem !important; }\n .pb-md-12,\n .py-md-12 {\n   padding-bottom: 8rem !important; }\n .pl-md-12,\n .px-md-12 {\n   padding-left: 8rem !important; }\n .p-md-13 {\n   padding: 10rem !important; }\n .pt-md-13,\n .py-md-13 {\n   padding-top: 10rem !important; }\n .pr-md-13,\n .px-md-13 {\n   padding-right: 10rem !important; }\n .pb-md-13,\n .py-md-13 {\n   padding-bottom: 10rem !important; }\n .pl-md-13,\n .px-md-13 {\n   padding-left: 10rem !important; }\n .p-md-14 {\n   padding: 12rem !important; }\n .pt-md-14,\n .py-md-14 {\n   padding-top: 12rem !important; }\n .pr-md-14,\n .px-md-14 {\n   padding-right: 12rem !important; }\n .pb-md-14,\n .py-md-14 {\n   padding-bottom: 12rem !important; }\n .pl-md-14,\n .px-md-14 {\n   padding-left: 12rem !important; }\n .p-md-15 {\n   padding: 16rem !important; }\n .pt-md-15,\n .py-md-15 {\n   padding-top: 16rem !important; }\n .pr-md-15,\n .px-md-15 {\n   padding-right: 16rem !important; }\n .pb-md-15,\n .py-md-15 {\n   padding-bottom: 16rem !important; }\n .pl-md-15,\n .px-md-15 {\n   padding-left: 16rem !important; }\n .p-md-16 {\n   padding: 25rem !important; }\n .pt-md-16,\n .py-md-16 {\n   padding-top: 25rem !important; }\n .pr-md-16,\n .px-md-16 {\n   padding-right: 25rem !important; }\n .pb-md-16,\n .py-md-16 {\n   padding-bottom: 25rem !important; }\n .pl-md-16,\n .px-md-16 {\n   padding-left: 25rem !important; }\n .m-md-n1 {\n   margin: -0.25rem !important; }\n .mt-md-n1,\n .my-md-n1 {\n   margin-top: -0.25rem !important; }\n .mr-md-n1,\n .mx-md-n1 {\n   margin-right: -0.25rem !important; }\n .mb-md-n1,\n .my-md-n1 {\n   margin-bottom: -0.25rem !important; }\n .ml-md-n1,\n .mx-md-n1 {\n   margin-left: -0.25rem !important; }\n .m-md-n2 {\n   margin: -0.5rem !important; }\n .mt-md-n2,\n .my-md-n2 {\n   margin-top: -0.5rem !important; }\n .mr-md-n2,\n .mx-md-n2 {\n   margin-right: -0.5rem !important; }\n .mb-md-n2,\n .my-md-n2 {\n   margin-bottom: -0.5rem !important; }\n .ml-md-n2,\n .mx-md-n2 {\n   margin-left: -0.5rem !important; }\n .m-md-n3 {\n   margin: -0.75rem !important; }\n .mt-md-n3,\n .my-md-n3 {\n   margin-top: -0.75rem !important; }\n .mr-md-n3,\n .mx-md-n3 {\n   margin-right: -0.75rem !important; }\n .mb-md-n3,\n .my-md-n3 {\n   margin-bottom: -0.75rem !important; }\n .ml-md-n3,\n .mx-md-n3 {\n   margin-left: -0.75rem !important; }\n .m-md-n4 {\n   margin: -1rem !important; }\n .mt-md-n4,\n .my-md-n4 {\n   margin-top: -1rem !important; }\n .mr-md-n4,\n .mx-md-n4 {\n   margin-right: -1rem !important; }\n .mb-md-n4,\n .my-md-n4 {\n   margin-bottom: -1rem !important; }\n .ml-md-n4,\n .mx-md-n4 {\n   margin-left: -1rem !important; }\n .m-md-n5 {\n   margin: -1.5rem !important; }\n .mt-md-n5,\n .my-md-n5 {\n   margin-top: -1.5rem !important; }\n .mr-md-n5,\n .mx-md-n5 {\n   margin-right: -1.5rem !important; }\n .mb-md-n5,\n .my-md-n5 {\n   margin-bottom: -1.5rem !important; }\n .ml-md-n5,\n .mx-md-n5 {\n   margin-left: -1.5rem !important; }\n .m-md-n6 {\n   margin: -2rem !important; }\n .mt-md-n6,\n .my-md-n6 {\n   margin-top: -2rem !important; }\n .mr-md-n6,\n .mx-md-n6 {\n   margin-right: -2rem !important; }\n .mb-md-n6,\n .my-md-n6 {\n   margin-bottom: -2rem !important; }\n .ml-md-n6,\n .mx-md-n6 {\n   margin-left: -2rem !important; }\n .m-md-n7 {\n   margin: -2.5rem !important; }\n .mt-md-n7,\n .my-md-n7 {\n   margin-top: -2.5rem !important; }\n .mr-md-n7,\n .mx-md-n7 {\n   margin-right: -2.5rem !important; }\n .mb-md-n7,\n .my-md-n7 {\n   margin-bottom: -2.5rem !important; }\n .ml-md-n7,\n .mx-md-n7 {\n   margin-left: -2.5rem !important; }\n .m-md-n8 {\n   margin: -3rem !important; }\n .mt-md-n8,\n .my-md-n8 {\n   margin-top: -3rem !important; }\n .mr-md-n8,\n .mx-md-n8 {\n   margin-right: -3rem !important; }\n .mb-md-n8,\n .my-md-n8 {\n   margin-bottom: -3rem !important; }\n .ml-md-n8,\n .mx-md-n8 {\n   margin-left: -3rem !important; }\n .m-md-n9 {\n   margin: -4rem !important; }\n .mt-md-n9,\n .my-md-n9 {\n   margin-top: -4rem !important; }\n .mr-md-n9,\n .mx-md-n9 {\n   margin-right: -4rem !important; }\n .mb-md-n9,\n .my-md-n9 {\n   margin-bottom: -4rem !important; }\n .ml-md-n9,\n .mx-md-n9 {\n   margin-left: -4rem !important; }\n .m-md-n10 {\n   margin: -5rem !important; }\n .mt-md-n10,\n .my-md-n10 {\n   margin-top: -5rem !important; }\n .mr-md-n10,\n .mx-md-n10 {\n   margin-right: -5rem !important; }\n .mb-md-n10,\n .my-md-n10 {\n   margin-bottom: -5rem !important; }\n .ml-md-n10,\n .mx-md-n10 {\n   margin-left: -5rem !important; }\n .m-md-n11 {\n   margin: -6rem !important; }\n .mt-md-n11,\n .my-md-n11 {\n   margin-top: -6rem !important; }\n .mr-md-n11,\n .mx-md-n11 {\n   margin-right: -6rem !important; }\n .mb-md-n11,\n .my-md-n11 {\n   margin-bottom: -6rem !important; }\n .ml-md-n11,\n .mx-md-n11 {\n   margin-left: -6rem !important; }\n .m-md-n12 {\n   margin: -8rem !important; }\n .mt-md-n12,\n .my-md-n12 {\n   margin-top: -8rem !important; }\n .mr-md-n12,\n .mx-md-n12 {\n   margin-right: -8rem !important; }\n .mb-md-n12,\n .my-md-n12 {\n   margin-bottom: -8rem !important; }\n .ml-md-n12,\n .mx-md-n12 {\n   margin-left: -8rem !important; }\n .m-md-n13 {\n   margin: -10rem !important; }\n .mt-md-n13,\n .my-md-n13 {\n   margin-top: -10rem !important; }\n .mr-md-n13,\n .mx-md-n13 {\n   margin-right: -10rem !important; }\n .mb-md-n13,\n .my-md-n13 {\n   margin-bottom: -10rem !important; }\n .ml-md-n13,\n .mx-md-n13 {\n   margin-left: -10rem !important; }\n .m-md-n14 {\n   margin: -12rem !important; }\n .mt-md-n14,\n .my-md-n14 {\n   margin-top: -12rem !important; }\n .mr-md-n14,\n .mx-md-n14 {\n   margin-right: -12rem !important; }\n .mb-md-n14,\n .my-md-n14 {\n   margin-bottom: -12rem !important; }\n .ml-md-n14,\n .mx-md-n14 {\n   margin-left: -12rem !important; }\n .m-md-n15 {\n   margin: -16rem !important; }\n .mt-md-n15,\n .my-md-n15 {\n   margin-top: -16rem !important; }\n .mr-md-n15,\n .mx-md-n15 {\n   margin-right: -16rem !important; }\n .mb-md-n15,\n .my-md-n15 {\n   margin-bottom: -16rem !important; }\n .ml-md-n15,\n .mx-md-n15 {\n   margin-left: -16rem !important; }\n .m-md-n16 {\n   margin: -25rem !important; }\n .mt-md-n16,\n .my-md-n16 {\n   margin-top: -25rem !important; }\n .mr-md-n16,\n .mx-md-n16 {\n   margin-right: -25rem !important; }\n .mb-md-n16,\n .my-md-n16 {\n   margin-bottom: -25rem !important; }\n .ml-md-n16,\n .mx-md-n16 {\n   margin-left: -25rem !important; }\n .m-md-auto {\n   margin: auto !important; }\n .mt-md-auto,\n .my-md-auto {\n   margin-top: auto !important; }\n .mr-md-auto,\n .mx-md-auto {\n   margin-right: auto !important; }\n .mb-md-auto,\n .my-md-auto {\n   margin-bottom: auto !important; }\n .ml-md-auto,\n .mx-md-auto {\n   margin-left: auto !important; } }\n@media (min-width: 992px) {\n .m-lg-0 {\n   margin: 0 !important; }\n .mt-lg-0,\n .my-lg-0 {\n   margin-top: 0 !important; }\n .mr-lg-0,\n .mx-lg-0 {\n   margin-right: 0 !important; }\n .mb-lg-0,\n .my-lg-0 {\n   margin-bottom: 0 !important; }\n .ml-lg-0,\n .mx-lg-0 {\n   margin-left: 0 !important; }\n .m-lg-1 {\n   margin: 0.25rem !important; }\n .mt-lg-1,\n .my-lg-1 {\n   margin-top: 0.25rem !important; }\n .mr-lg-1,\n .mx-lg-1 {\n   margin-right: 0.25rem !important; }\n .mb-lg-1,\n .my-lg-1 {\n   margin-bottom: 0.25rem !important; }\n .ml-lg-1,\n .mx-lg-1 {\n   margin-left: 0.25rem !important; }\n .m-lg-2 {\n   margin: 0.5rem !important; }\n .mt-lg-2,\n .my-lg-2 {\n   margin-top: 0.5rem !important; }\n .mr-lg-2,\n .mx-lg-2 {\n   margin-right: 0.5rem !important; }\n .mb-lg-2,\n .my-lg-2 {\n   margin-bottom: 0.5rem !important; }\n .ml-lg-2,\n .mx-lg-2 {\n   margin-left: 0.5rem !important; }\n .m-lg-3 {\n   margin: 0.75rem !important; }\n .mt-lg-3,\n .my-lg-3 {\n   margin-top: 0.75rem !important; }\n .mr-lg-3,\n .mx-lg-3 {\n   margin-right: 0.75rem !important; }\n .mb-lg-3,\n .my-lg-3 {\n   margin-bottom: 0.75rem !important; }\n .ml-lg-3,\n .mx-lg-3 {\n   margin-left: 0.75rem !important; }\n .m-lg-4 {\n   margin: 1rem !important; }\n .mt-lg-4,\n .my-lg-4 {\n   margin-top: 1rem !important; }\n .mr-lg-4,\n .mx-lg-4 {\n   margin-right: 1rem !important; }\n .mb-lg-4,\n .my-lg-4 {\n   margin-bottom: 1rem !important; }\n .ml-lg-4,\n .mx-lg-4 {\n   margin-left: 1rem !important; }\n .m-lg-5 {\n   margin: 1.5rem !important; }\n .mt-lg-5,\n .my-lg-5 {\n   margin-top: 1.5rem !important; }\n .mr-lg-5,\n .mx-lg-5 {\n   margin-right: 1.5rem !important; }\n .mb-lg-5,\n .my-lg-5 {\n   margin-bottom: 1.5rem !important; }\n .ml-lg-5,\n .mx-lg-5 {\n   margin-left: 1.5rem !important; }\n .m-lg-6 {\n   margin: 2rem !important; }\n .mt-lg-6,\n .my-lg-6 {\n   margin-top: 2rem !important; }\n .mr-lg-6,\n .mx-lg-6 {\n   margin-right: 2rem !important; }\n .mb-lg-6,\n .my-lg-6 {\n   margin-bottom: 2rem !important; }\n .ml-lg-6,\n .mx-lg-6 {\n   margin-left: 2rem !important; }\n .m-lg-7 {\n   margin: 2.5rem !important; }\n .mt-lg-7,\n .my-lg-7 {\n   margin-top: 2.5rem !important; }\n .mr-lg-7,\n .mx-lg-7 {\n   margin-right: 2.5rem !important; }\n .mb-lg-7,\n .my-lg-7 {\n   margin-bottom: 2.5rem !important; }\n .ml-lg-7,\n .mx-lg-7 {\n   margin-left: 2.5rem !important; }\n .m-lg-8 {\n   margin: 3rem !important; }\n .mt-lg-8,\n .my-lg-8 {\n   margin-top: 3rem !important; }\n .mr-lg-8,\n .mx-lg-8 {\n   margin-right: 3rem !important; }\n .mb-lg-8,\n .my-lg-8 {\n   margin-bottom: 3rem !important; }\n .ml-lg-8,\n .mx-lg-8 {\n   margin-left: 3rem !important; }\n .m-lg-9 {\n   margin: 4rem !important; }\n .mt-lg-9,\n .my-lg-9 {\n   margin-top: 4rem !important; }\n .mr-lg-9,\n .mx-lg-9 {\n   margin-right: 4rem !important; }\n .mb-lg-9,\n .my-lg-9 {\n   margin-bottom: 4rem !important; }\n .ml-lg-9,\n .mx-lg-9 {\n   margin-left: 4rem !important; }\n .m-lg-10 {\n   margin: 5rem !important; }\n .mt-lg-10,\n .my-lg-10 {\n   margin-top: 5rem !important; }\n .mr-lg-10,\n .mx-lg-10 {\n   margin-right: 5rem !important; }\n .mb-lg-10,\n .my-lg-10 {\n   margin-bottom: 5rem !important; }\n .ml-lg-10,\n .mx-lg-10 {\n   margin-left: 5rem !important; }\n .m-lg-11 {\n   margin: 6rem !important; }\n .mt-lg-11,\n .my-lg-11 {\n   margin-top: 6rem !important; }\n .mr-lg-11,\n .mx-lg-11 {\n   margin-right: 6rem !important; }\n .mb-lg-11,\n .my-lg-11 {\n   margin-bottom: 6rem !important; }\n .ml-lg-11,\n .mx-lg-11 {\n   margin-left: 6rem !important; }\n .m-lg-12 {\n   margin: 8rem !important; }\n .mt-lg-12,\n .my-lg-12 {\n   margin-top: 8rem !important; }\n .mr-lg-12,\n .mx-lg-12 {\n   margin-right: 8rem !important; }\n .mb-lg-12,\n .my-lg-12 {\n   margin-bottom: 8rem !important; }\n .ml-lg-12,\n .mx-lg-12 {\n   margin-left: 8rem !important; }\n .m-lg-13 {\n   margin: 10rem !important; }\n .mt-lg-13,\n .my-lg-13 {\n   margin-top: 10rem !important; }\n .mr-lg-13,\n .mx-lg-13 {\n   margin-right: 10rem !important; }\n .mb-lg-13,\n .my-lg-13 {\n   margin-bottom: 10rem !important; }\n .ml-lg-13,\n .mx-lg-13 {\n   margin-left: 10rem !important; }\n .m-lg-14 {\n   margin: 12rem !important; }\n .mt-lg-14,\n .my-lg-14 {\n   margin-top: 12rem !important; }\n .mr-lg-14,\n .mx-lg-14 {\n   margin-right: 12rem !important; }\n .mb-lg-14,\n .my-lg-14 {\n   margin-bottom: 12rem !important; }\n .ml-lg-14,\n .mx-lg-14 {\n   margin-left: 12rem !important; }\n .m-lg-15 {\n   margin: 16rem !important; }\n .mt-lg-15,\n .my-lg-15 {\n   margin-top: 16rem !important; }\n .mr-lg-15,\n .mx-lg-15 {\n   margin-right: 16rem !important; }\n .mb-lg-15,\n .my-lg-15 {\n   margin-bottom: 16rem !important; }\n .ml-lg-15,\n .mx-lg-15 {\n   margin-left: 16rem !important; }\n .m-lg-16 {\n   margin: 25rem !important; }\n .mt-lg-16,\n .my-lg-16 {\n   margin-top: 25rem !important; }\n .mr-lg-16,\n .mx-lg-16 {\n   margin-right: 25rem !important; }\n .mb-lg-16,\n .my-lg-16 {\n   margin-bottom: 25rem !important; }\n .ml-lg-16,\n .mx-lg-16 {\n   margin-left: 25rem !important; }\n .p-lg-0 {\n   padding: 0 !important; }\n .pt-lg-0,\n .py-lg-0 {\n   padding-top: 0 !important; }\n .pr-lg-0,\n .px-lg-0 {\n   padding-right: 0 !important; }\n .pb-lg-0,\n .py-lg-0 {\n   padding-bottom: 0 !important; }\n .pl-lg-0,\n .px-lg-0 {\n   padding-left: 0 !important; }\n .p-lg-1 {\n   padding: 0.25rem !important; }\n .pt-lg-1,\n .py-lg-1 {\n   padding-top: 0.25rem !important; }\n .pr-lg-1,\n .px-lg-1 {\n   padding-right: 0.25rem !important; }\n .pb-lg-1,\n .py-lg-1 {\n   padding-bottom: 0.25rem !important; }\n .pl-lg-1,\n .px-lg-1 {\n   padding-left: 0.25rem !important; }\n .p-lg-2 {\n   padding: 0.5rem !important; }\n .pt-lg-2,\n .py-lg-2 {\n   padding-top: 0.5rem !important; }\n .pr-lg-2,\n .px-lg-2 {\n   padding-right: 0.5rem !important; }\n .pb-lg-2,\n .py-lg-2 {\n   padding-bottom: 0.5rem !important; }\n .pl-lg-2,\n .px-lg-2 {\n   padding-left: 0.5rem !important; }\n .p-lg-3 {\n   padding: 0.75rem !important; }\n .pt-lg-3,\n .py-lg-3 {\n   padding-top: 0.75rem !important; }\n .pr-lg-3,\n .px-lg-3 {\n   padding-right: 0.75rem !important; }\n .pb-lg-3,\n .py-lg-3 {\n   padding-bottom: 0.75rem !important; }\n .pl-lg-3,\n .px-lg-3 {\n   padding-left: 0.75rem !important; }\n .p-lg-4 {\n   padding: 1rem !important; }\n .pt-lg-4,\n .py-lg-4 {\n   padding-top: 1rem !important; }\n .pr-lg-4,\n .px-lg-4 {\n   padding-right: 1rem !important; }\n .pb-lg-4,\n .py-lg-4 {\n   padding-bottom: 1rem !important; }\n .pl-lg-4,\n .px-lg-4 {\n   padding-left: 1rem !important; }\n .p-lg-5 {\n   padding: 1.5rem !important; }\n .pt-lg-5,\n .py-lg-5 {\n   padding-top: 1.5rem !important; }\n .pr-lg-5,\n .px-lg-5 {\n   padding-right: 1.5rem !important; }\n .pb-lg-5,\n .py-lg-5 {\n   padding-bottom: 1.5rem !important; }\n .pl-lg-5,\n .px-lg-5 {\n   padding-left: 1.5rem !important; }\n .p-lg-6 {\n   padding: 2rem !important; }\n .pt-lg-6,\n .py-lg-6 {\n   padding-top: 2rem !important; }\n .pr-lg-6,\n .px-lg-6 {\n   padding-right: 2rem !important; }\n .pb-lg-6,\n .py-lg-6 {\n   padding-bottom: 2rem !important; }\n .pl-lg-6,\n .px-lg-6 {\n   padding-left: 2rem !important; }\n .p-lg-7 {\n   padding: 2.5rem !important; }\n .pt-lg-7,\n .py-lg-7 {\n   padding-top: 2.5rem !important; }\n .pr-lg-7,\n .px-lg-7 {\n   padding-right: 2.5rem !important; }\n .pb-lg-7,\n .py-lg-7 {\n   padding-bottom: 2.5rem !important; }\n .pl-lg-7,\n .px-lg-7 {\n   padding-left: 2.5rem !important; }\n .p-lg-8 {\n   padding: 3rem !important; }\n .pt-lg-8,\n .py-lg-8 {\n   padding-top: 3rem !important; }\n .pr-lg-8,\n .px-lg-8 {\n   padding-right: 3rem !important; }\n .pb-lg-8,\n .py-lg-8 {\n   padding-bottom: 3rem !important; }\n .pl-lg-8,\n .px-lg-8 {\n   padding-left: 3rem !important; }\n .p-lg-9 {\n   padding: 4rem !important; }\n .pt-lg-9,\n .py-lg-9 {\n   padding-top: 4rem !important; }\n .pr-lg-9,\n .px-lg-9 {\n   padding-right: 4rem !important; }\n .pb-lg-9,\n .py-lg-9 {\n   padding-bottom: 4rem !important; }\n .pl-lg-9,\n .px-lg-9 {\n   padding-left: 4rem !important; }\n .p-lg-10 {\n   padding: 5rem !important; }\n .pt-lg-10,\n .py-lg-10 {\n   padding-top: 5rem !important; }\n .pr-lg-10,\n .px-lg-10 {\n   padding-right: 5rem !important; }\n .pb-lg-10,\n .py-lg-10 {\n   padding-bottom: 5rem !important; }\n .pl-lg-10,\n .px-lg-10 {\n   padding-left: 5rem !important; }\n .p-lg-11 {\n   padding: 6rem !important; }\n .pt-lg-11,\n .py-lg-11 {\n   padding-top: 6rem !important; }\n .pr-lg-11,\n .px-lg-11 {\n   padding-right: 6rem !important; }\n .pb-lg-11,\n .py-lg-11 {\n   padding-bottom: 6rem !important; }\n .pl-lg-11,\n .px-lg-11 {\n   padding-left: 6rem !important; }\n .p-lg-12 {\n   padding: 8rem !important; }\n .pt-lg-12,\n .py-lg-12 {\n   padding-top: 8rem !important; }\n .pr-lg-12,\n .px-lg-12 {\n   padding-right: 8rem !important; }\n .pb-lg-12,\n .py-lg-12 {\n   padding-bottom: 8rem !important; }\n .pl-lg-12,\n .px-lg-12 {\n   padding-left: 8rem !important; }\n .p-lg-13 {\n   padding: 10rem !important; }\n .pt-lg-13,\n .py-lg-13 {\n   padding-top: 10rem !important; }\n .pr-lg-13,\n .px-lg-13 {\n   padding-right: 10rem !important; }\n .pb-lg-13,\n .py-lg-13 {\n   padding-bottom: 10rem !important; }\n .pl-lg-13,\n .px-lg-13 {\n   padding-left: 10rem !important; }\n .p-lg-14 {\n   padding: 12rem !important; }\n .pt-lg-14,\n .py-lg-14 {\n   padding-top: 12rem !important; }\n .pr-lg-14,\n .px-lg-14 {\n   padding-right: 12rem !important; }\n .pb-lg-14,\n .py-lg-14 {\n   padding-bottom: 12rem !important; }\n .pl-lg-14,\n .px-lg-14 {\n   padding-left: 12rem !important; }\n .p-lg-15 {\n   padding: 16rem !important; }\n .pt-lg-15,\n .py-lg-15 {\n   padding-top: 16rem !important; }\n .pr-lg-15,\n .px-lg-15 {\n   padding-right: 16rem !important; }\n .pb-lg-15,\n .py-lg-15 {\n   padding-bottom: 16rem !important; }\n .pl-lg-15,\n .px-lg-15 {\n   padding-left: 16rem !important; }\n .p-lg-16 {\n   padding: 25rem !important; }\n .pt-lg-16,\n .py-lg-16 {\n   padding-top: 25rem !important; }\n .pr-lg-16,\n .px-lg-16 {\n   padding-right: 25rem !important; }\n .pb-lg-16,\n .py-lg-16 {\n   padding-bottom: 25rem !important; }\n .pl-lg-16,\n .px-lg-16 {\n   padding-left: 25rem !important; }\n .m-lg-n1 {\n   margin: -0.25rem !important; }\n .mt-lg-n1,\n .my-lg-n1 {\n   margin-top: -0.25rem !important; }\n .mr-lg-n1,\n .mx-lg-n1 {\n   margin-right: -0.25rem !important; }\n .mb-lg-n1,\n .my-lg-n1 {\n   margin-bottom: -0.25rem !important; }\n .ml-lg-n1,\n .mx-lg-n1 {\n   margin-left: -0.25rem !important; }\n .m-lg-n2 {\n   margin: -0.5rem !important; }\n .mt-lg-n2,\n .my-lg-n2 {\n   margin-top: -0.5rem !important; }\n .mr-lg-n2,\n .mx-lg-n2 {\n   margin-right: -0.5rem !important; }\n .mb-lg-n2,\n .my-lg-n2 {\n   margin-bottom: -0.5rem !important; }\n .ml-lg-n2,\n .mx-lg-n2 {\n   margin-left: -0.5rem !important; }\n .m-lg-n3 {\n   margin: -0.75rem !important; }\n .mt-lg-n3,\n .my-lg-n3 {\n   margin-top: -0.75rem !important; }\n .mr-lg-n3,\n .mx-lg-n3 {\n   margin-right: -0.75rem !important; }\n .mb-lg-n3,\n .my-lg-n3 {\n   margin-bottom: -0.75rem !important; }\n .ml-lg-n3,\n .mx-lg-n3 {\n   margin-left: -0.75rem !important; }\n .m-lg-n4 {\n   margin: -1rem !important; }\n .mt-lg-n4,\n .my-lg-n4 {\n   margin-top: -1rem !important; }\n .mr-lg-n4,\n .mx-lg-n4 {\n   margin-right: -1rem !important; }\n .mb-lg-n4,\n .my-lg-n4 {\n   margin-bottom: -1rem !important; }\n .ml-lg-n4,\n .mx-lg-n4 {\n   margin-left: -1rem !important; }\n .m-lg-n5 {\n   margin: -1.5rem !important; }\n .mt-lg-n5,\n .my-lg-n5 {\n   margin-top: -1.5rem !important; }\n .mr-lg-n5,\n .mx-lg-n5 {\n   margin-right: -1.5rem !important; }\n .mb-lg-n5,\n .my-lg-n5 {\n   margin-bottom: -1.5rem !important; }\n .ml-lg-n5,\n .mx-lg-n5 {\n   margin-left: -1.5rem !important; }\n .m-lg-n6 {\n   margin: -2rem !important; }\n .mt-lg-n6,\n .my-lg-n6 {\n   margin-top: -2rem !important; }\n .mr-lg-n6,\n .mx-lg-n6 {\n   margin-right: -2rem !important; }\n .mb-lg-n6,\n .my-lg-n6 {\n   margin-bottom: -2rem !important; }\n .ml-lg-n6,\n .mx-lg-n6 {\n   margin-left: -2rem !important; }\n .m-lg-n7 {\n   margin: -2.5rem !important; }\n .mt-lg-n7,\n .my-lg-n7 {\n   margin-top: -2.5rem !important; }\n .mr-lg-n7,\n .mx-lg-n7 {\n   margin-right: -2.5rem !important; }\n .mb-lg-n7,\n .my-lg-n7 {\n   margin-bottom: -2.5rem !important; }\n .ml-lg-n7,\n .mx-lg-n7 {\n   margin-left: -2.5rem !important; }\n .m-lg-n8 {\n   margin: -3rem !important; }\n .mt-lg-n8,\n .my-lg-n8 {\n   margin-top: -3rem !important; }\n .mr-lg-n8,\n .mx-lg-n8 {\n   margin-right: -3rem !important; }\n .mb-lg-n8,\n .my-lg-n8 {\n   margin-bottom: -3rem !important; }\n .ml-lg-n8,\n .mx-lg-n8 {\n   margin-left: -3rem !important; }\n .m-lg-n9 {\n   margin: -4rem !important; }\n .mt-lg-n9,\n .my-lg-n9 {\n   margin-top: -4rem !important; }\n .mr-lg-n9,\n .mx-lg-n9 {\n   margin-right: -4rem !important; }\n .mb-lg-n9,\n .my-lg-n9 {\n   margin-bottom: -4rem !important; }\n .ml-lg-n9,\n .mx-lg-n9 {\n   margin-left: -4rem !important; }\n .m-lg-n10 {\n   margin: -5rem !important; }\n .mt-lg-n10,\n .my-lg-n10 {\n   margin-top: -5rem !important; }\n .mr-lg-n10,\n .mx-lg-n10 {\n   margin-right: -5rem !important; }\n .mb-lg-n10,\n .my-lg-n10 {\n   margin-bottom: -5rem !important; }\n .ml-lg-n10,\n .mx-lg-n10 {\n   margin-left: -5rem !important; }\n .m-lg-n11 {\n   margin: -6rem !important; }\n .mt-lg-n11,\n .my-lg-n11 {\n   margin-top: -6rem !important; }\n .mr-lg-n11,\n .mx-lg-n11 {\n   margin-right: -6rem !important; }\n .mb-lg-n11,\n .my-lg-n11 {\n   margin-bottom: -6rem !important; }\n .ml-lg-n11,\n .mx-lg-n11 {\n   margin-left: -6rem !important; }\n .m-lg-n12 {\n   margin: -8rem !important; }\n .mt-lg-n12,\n .my-lg-n12 {\n   margin-top: -8rem !important; }\n .mr-lg-n12,\n .mx-lg-n12 {\n   margin-right: -8rem !important; }\n .mb-lg-n12,\n .my-lg-n12 {\n   margin-bottom: -8rem !important; }\n .ml-lg-n12,\n .mx-lg-n12 {\n   margin-left: -8rem !important; }\n .m-lg-n13 {\n   margin: -10rem !important; }\n .mt-lg-n13,\n .my-lg-n13 {\n   margin-top: -10rem !important; }\n .mr-lg-n13,\n .mx-lg-n13 {\n   margin-right: -10rem !important; }\n .mb-lg-n13,\n .my-lg-n13 {\n   margin-bottom: -10rem !important; }\n .ml-lg-n13,\n .mx-lg-n13 {\n   margin-left: -10rem !important; }\n .m-lg-n14 {\n   margin: -12rem !important; }\n .mt-lg-n14,\n .my-lg-n14 {\n   margin-top: -12rem !important; }\n .mr-lg-n14,\n .mx-lg-n14 {\n   margin-right: -12rem !important; }\n .mb-lg-n14,\n .my-lg-n14 {\n   margin-bottom: -12rem !important; }\n .ml-lg-n14,\n .mx-lg-n14 {\n   margin-left: -12rem !important; }\n .m-lg-n15 {\n   margin: -16rem !important; }\n .mt-lg-n15,\n .my-lg-n15 {\n   margin-top: -16rem !important; }\n .mr-lg-n15,\n .mx-lg-n15 {\n   margin-right: -16rem !important; }\n .mb-lg-n15,\n .my-lg-n15 {\n   margin-bottom: -16rem !important; }\n .ml-lg-n15,\n .mx-lg-n15 {\n   margin-left: -16rem !important; }\n .m-lg-n16 {\n   margin: -25rem !important; }\n .mt-lg-n16,\n .my-lg-n16 {\n   margin-top: -25rem !important; }\n .mr-lg-n16,\n .mx-lg-n16 {\n   margin-right: -25rem !important; }\n .mb-lg-n16,\n .my-lg-n16 {\n   margin-bottom: -25rem !important; }\n .ml-lg-n16,\n .mx-lg-n16 {\n   margin-left: -25rem !important; }\n .m-lg-auto {\n   margin: auto !important; }\n .mt-lg-auto,\n .my-lg-auto {\n   margin-top: auto !important; }\n .mr-lg-auto,\n .mx-lg-auto {\n   margin-right: auto !important; }\n .mb-lg-auto,\n .my-lg-auto {\n   margin-bottom: auto !important; }\n .ml-lg-auto,\n .mx-lg-auto {\n   margin-left: auto !important; } }\n@media (min-width: 1200px) {\n .m-xl-0 {\n   margin: 0 !important; }\n .mt-xl-0,\n .my-xl-0 {\n   margin-top: 0 !important; }\n .mr-xl-0,\n .mx-xl-0 {\n   margin-right: 0 !important; }\n .mb-xl-0,\n .my-xl-0 {\n   margin-bottom: 0 !important; }\n .ml-xl-0,\n .mx-xl-0 {\n   margin-left: 0 !important; }\n .m-xl-1 {\n   margin: 0.25rem !important; }\n .mt-xl-1,\n .my-xl-1 {\n   margin-top: 0.25rem !important; }\n .mr-xl-1,\n .mx-xl-1 {\n   margin-right: 0.25rem !important; }\n .mb-xl-1,\n .my-xl-1 {\n   margin-bottom: 0.25rem !important; }\n .ml-xl-1,\n .mx-xl-1 {\n   margin-left: 0.25rem !important; }\n .m-xl-2 {\n   margin: 0.5rem !important; }\n .mt-xl-2,\n .my-xl-2 {\n   margin-top: 0.5rem !important; }\n .mr-xl-2,\n .mx-xl-2 {\n   margin-right: 0.5rem !important; }\n .mb-xl-2,\n .my-xl-2 {\n   margin-bottom: 0.5rem !important; }\n .ml-xl-2,\n .mx-xl-2 {\n   margin-left: 0.5rem !important; }\n .m-xl-3 {\n   margin: 0.75rem !important; }\n .mt-xl-3,\n .my-xl-3 {\n   margin-top: 0.75rem !important; }\n .mr-xl-3,\n .mx-xl-3 {\n   margin-right: 0.75rem !important; }\n .mb-xl-3,\n .my-xl-3 {\n   margin-bottom: 0.75rem !important; }\n .ml-xl-3,\n .mx-xl-3 {\n   margin-left: 0.75rem !important; }\n .m-xl-4 {\n   margin: 1rem !important; }\n .mt-xl-4,\n .my-xl-4 {\n   margin-top: 1rem !important; }\n .mr-xl-4,\n .mx-xl-4 {\n   margin-right: 1rem !important; }\n .mb-xl-4,\n .my-xl-4 {\n   margin-bottom: 1rem !important; }\n .ml-xl-4,\n .mx-xl-4 {\n   margin-left: 1rem !important; }\n .m-xl-5 {\n   margin: 1.5rem !important; }\n .mt-xl-5,\n .my-xl-5 {\n   margin-top: 1.5rem !important; }\n .mr-xl-5,\n .mx-xl-5 {\n   margin-right: 1.5rem !important; }\n .mb-xl-5,\n .my-xl-5 {\n   margin-bottom: 1.5rem !important; }\n .ml-xl-5,\n .mx-xl-5 {\n   margin-left: 1.5rem !important; }\n .m-xl-6 {\n   margin: 2rem !important; }\n .mt-xl-6,\n .my-xl-6 {\n   margin-top: 2rem !important; }\n .mr-xl-6,\n .mx-xl-6 {\n   margin-right: 2rem !important; }\n .mb-xl-6,\n .my-xl-6 {\n   margin-bottom: 2rem !important; }\n .ml-xl-6,\n .mx-xl-6 {\n   margin-left: 2rem !important; }\n .m-xl-7 {\n   margin: 2.5rem !important; }\n .mt-xl-7,\n .my-xl-7 {\n   margin-top: 2.5rem !important; }\n .mr-xl-7,\n .mx-xl-7 {\n   margin-right: 2.5rem !important; }\n .mb-xl-7,\n .my-xl-7 {\n   margin-bottom: 2.5rem !important; }\n .ml-xl-7,\n .mx-xl-7 {\n   margin-left: 2.5rem !important; }\n .m-xl-8 {\n   margin: 3rem !important; }\n .mt-xl-8,\n .my-xl-8 {\n   margin-top: 3rem !important; }\n .mr-xl-8,\n .mx-xl-8 {\n   margin-right: 3rem !important; }\n .mb-xl-8,\n .my-xl-8 {\n   margin-bottom: 3rem !important; }\n .ml-xl-8,\n .mx-xl-8 {\n   margin-left: 3rem !important; }\n .m-xl-9 {\n   margin: 4rem !important; }\n .mt-xl-9,\n .my-xl-9 {\n   margin-top: 4rem !important; }\n .mr-xl-9,\n .mx-xl-9 {\n   margin-right: 4rem !important; }\n .mb-xl-9,\n .my-xl-9 {\n   margin-bottom: 4rem !important; }\n .ml-xl-9,\n .mx-xl-9 {\n   margin-left: 4rem !important; }\n .m-xl-10 {\n   margin: 5rem !important; }\n .mt-xl-10,\n .my-xl-10 {\n   margin-top: 5rem !important; }\n .mr-xl-10,\n .mx-xl-10 {\n   margin-right: 5rem !important; }\n .mb-xl-10,\n .my-xl-10 {\n   margin-bottom: 5rem !important; }\n .ml-xl-10,\n .mx-xl-10 {\n   margin-left: 5rem !important; }\n .m-xl-11 {\n   margin: 6rem !important; }\n .mt-xl-11,\n .my-xl-11 {\n   margin-top: 6rem !important; }\n .mr-xl-11,\n .mx-xl-11 {\n   margin-right: 6rem !important; }\n .mb-xl-11,\n .my-xl-11 {\n   margin-bottom: 6rem !important; }\n .ml-xl-11,\n .mx-xl-11 {\n   margin-left: 6rem !important; }\n .m-xl-12 {\n   margin: 8rem !important; }\n .mt-xl-12,\n .my-xl-12 {\n   margin-top: 8rem !important; }\n .mr-xl-12,\n .mx-xl-12 {\n   margin-right: 8rem !important; }\n .mb-xl-12,\n .my-xl-12 {\n   margin-bottom: 8rem !important; }\n .ml-xl-12,\n .mx-xl-12 {\n   margin-left: 8rem !important; }\n .m-xl-13 {\n   margin: 10rem !important; }\n .mt-xl-13,\n .my-xl-13 {\n   margin-top: 10rem !important; }\n .mr-xl-13,\n .mx-xl-13 {\n   margin-right: 10rem !important; }\n .mb-xl-13,\n .my-xl-13 {\n   margin-bottom: 10rem !important; }\n .ml-xl-13,\n .mx-xl-13 {\n   margin-left: 10rem !important; }\n .m-xl-14 {\n   margin: 12rem !important; }\n .mt-xl-14,\n .my-xl-14 {\n   margin-top: 12rem !important; }\n .mr-xl-14,\n .mx-xl-14 {\n   margin-right: 12rem !important; }\n .mb-xl-14,\n .my-xl-14 {\n   margin-bottom: 12rem !important; }\n .ml-xl-14,\n .mx-xl-14 {\n   margin-left: 12rem !important; }\n .m-xl-15 {\n   margin: 16rem !important; }\n .mt-xl-15,\n .my-xl-15 {\n   margin-top: 16rem !important; }\n .mr-xl-15,\n .mx-xl-15 {\n   margin-right: 16rem !important; }\n .mb-xl-15,\n .my-xl-15 {\n   margin-bottom: 16rem !important; }\n .ml-xl-15,\n .mx-xl-15 {\n   margin-left: 16rem !important; }\n .m-xl-16 {\n   margin: 25rem !important; }\n .mt-xl-16,\n .my-xl-16 {\n   margin-top: 25rem !important; }\n .mr-xl-16,\n .mx-xl-16 {\n   margin-right: 25rem !important; }\n .mb-xl-16,\n .my-xl-16 {\n   margin-bottom: 25rem !important; }\n .ml-xl-16,\n .mx-xl-16 {\n   margin-left: 25rem !important; }\n .p-xl-0 {\n   padding: 0 !important; }\n .pt-xl-0,\n .py-xl-0 {\n   padding-top: 0 !important; }\n .pr-xl-0,\n .px-xl-0 {\n   padding-right: 0 !important; }\n .pb-xl-0,\n .py-xl-0 {\n   padding-bottom: 0 !important; }\n .pl-xl-0,\n .px-xl-0 {\n   padding-left: 0 !important; }\n .p-xl-1 {\n   padding: 0.25rem !important; }\n .pt-xl-1,\n .py-xl-1 {\n   padding-top: 0.25rem !important; }\n .pr-xl-1,\n .px-xl-1 {\n   padding-right: 0.25rem !important; }\n .pb-xl-1,\n .py-xl-1 {\n   padding-bottom: 0.25rem !important; }\n .pl-xl-1,\n .px-xl-1 {\n   padding-left: 0.25rem !important; }\n .p-xl-2 {\n   padding: 0.5rem !important; }\n .pt-xl-2,\n .py-xl-2 {\n   padding-top: 0.5rem !important; }\n .pr-xl-2,\n .px-xl-2 {\n   padding-right: 0.5rem !important; }\n .pb-xl-2,\n .py-xl-2 {\n   padding-bottom: 0.5rem !important; }\n .pl-xl-2,\n .px-xl-2 {\n   padding-left: 0.5rem !important; }\n .p-xl-3 {\n   padding: 0.75rem !important; }\n .pt-xl-3,\n .py-xl-3 {\n   padding-top: 0.75rem !important; }\n .pr-xl-3,\n .px-xl-3 {\n   padding-right: 0.75rem !important; }\n .pb-xl-3,\n .py-xl-3 {\n   padding-bottom: 0.75rem !important; }\n .pl-xl-3,\n .px-xl-3 {\n   padding-left: 0.75rem !important; }\n .p-xl-4 {\n   padding: 1rem !important; }\n .pt-xl-4,\n .py-xl-4 {\n   padding-top: 1rem !important; }\n .pr-xl-4,\n .px-xl-4 {\n   padding-right: 1rem !important; }\n .pb-xl-4,\n .py-xl-4 {\n   padding-bottom: 1rem !important; }\n .pl-xl-4,\n .px-xl-4 {\n   padding-left: 1rem !important; }\n .p-xl-5 {\n   padding: 1.5rem !important; }\n .pt-xl-5,\n .py-xl-5 {\n   padding-top: 1.5rem !important; }\n .pr-xl-5,\n .px-xl-5 {\n   padding-right: 1.5rem !important; }\n .pb-xl-5,\n .py-xl-5 {\n   padding-bottom: 1.5rem !important; }\n .pl-xl-5,\n .px-xl-5 {\n   padding-left: 1.5rem !important; }\n .p-xl-6 {\n   padding: 2rem !important; }\n .pt-xl-6,\n .py-xl-6 {\n   padding-top: 2rem !important; }\n .pr-xl-6,\n .px-xl-6 {\n   padding-right: 2rem !important; }\n .pb-xl-6,\n .py-xl-6 {\n   padding-bottom: 2rem !important; }\n .pl-xl-6,\n .px-xl-6 {\n   padding-left: 2rem !important; }\n .p-xl-7 {\n   padding: 2.5rem !important; }\n .pt-xl-7,\n .py-xl-7 {\n   padding-top: 2.5rem !important; }\n .pr-xl-7,\n .px-xl-7 {\n   padding-right: 2.5rem !important; }\n .pb-xl-7,\n .py-xl-7 {\n   padding-bottom: 2.5rem !important; }\n .pl-xl-7,\n .px-xl-7 {\n   padding-left: 2.5rem !important; }\n .p-xl-8 {\n   padding: 3rem !important; }\n .pt-xl-8,\n .py-xl-8 {\n   padding-top: 3rem !important; }\n .pr-xl-8,\n .px-xl-8 {\n   padding-right: 3rem !important; }\n .pb-xl-8,\n .py-xl-8 {\n   padding-bottom: 3rem !important; }\n .pl-xl-8,\n .px-xl-8 {\n   padding-left: 3rem !important; }\n .p-xl-9 {\n   padding: 4rem !important; }\n .pt-xl-9,\n .py-xl-9 {\n   padding-top: 4rem !important; }\n .pr-xl-9,\n .px-xl-9 {\n   padding-right: 4rem !important; }\n .pb-xl-9,\n .py-xl-9 {\n   padding-bottom: 4rem !important; }\n .pl-xl-9,\n .px-xl-9 {\n   padding-left: 4rem !important; }\n .p-xl-10 {\n   padding: 5rem !important; }\n .pt-xl-10,\n .py-xl-10 {\n   padding-top: 5rem !important; }\n .pr-xl-10,\n .px-xl-10 {\n   padding-right: 5rem !important; }\n .pb-xl-10,\n .py-xl-10 {\n   padding-bottom: 5rem !important; }\n .pl-xl-10,\n .px-xl-10 {\n   padding-left: 5rem !important; }\n .p-xl-11 {\n   padding: 6rem !important; }\n .pt-xl-11,\n .py-xl-11 {\n   padding-top: 6rem !important; }\n .pr-xl-11,\n .px-xl-11 {\n   padding-right: 6rem !important; }\n .pb-xl-11,\n .py-xl-11 {\n   padding-bottom: 6rem !important; }\n .pl-xl-11,\n .px-xl-11 {\n   padding-left: 6rem !important; }\n .p-xl-12 {\n   padding: 8rem !important; }\n .pt-xl-12,\n .py-xl-12 {\n   padding-top: 8rem !important; }\n .pr-xl-12,\n .px-xl-12 {\n   padding-right: 8rem !important; }\n .pb-xl-12,\n .py-xl-12 {\n   padding-bottom: 8rem !important; }\n .pl-xl-12,\n .px-xl-12 {\n   padding-left: 8rem !important; }\n .p-xl-13 {\n   padding: 10rem !important; }\n .pt-xl-13,\n .py-xl-13 {\n   padding-top: 10rem !important; }\n .pr-xl-13,\n .px-xl-13 {\n   padding-right: 10rem !important; }\n .pb-xl-13,\n .py-xl-13 {\n   padding-bottom: 10rem !important; }\n .pl-xl-13,\n .px-xl-13 {\n   padding-left: 10rem !important; }\n .p-xl-14 {\n   padding: 12rem !important; }\n .pt-xl-14,\n .py-xl-14 {\n   padding-top: 12rem !important; }\n .pr-xl-14,\n .px-xl-14 {\n   padding-right: 12rem !important; }\n .pb-xl-14,\n .py-xl-14 {\n   padding-bottom: 12rem !important; }\n .pl-xl-14,\n .px-xl-14 {\n   padding-left: 12rem !important; }\n .p-xl-15 {\n   padding: 16rem !important; }\n .pt-xl-15,\n .py-xl-15 {\n   padding-top: 16rem !important; }\n .pr-xl-15,\n .px-xl-15 {\n   padding-right: 16rem !important; }\n .pb-xl-15,\n .py-xl-15 {\n   padding-bottom: 16rem !important; }\n .pl-xl-15,\n .px-xl-15 {\n   padding-left: 16rem !important; }\n .p-xl-16 {\n   padding: 25rem !important; }\n .pt-xl-16,\n .py-xl-16 {\n   padding-top: 25rem !important; }\n .pr-xl-16,\n .px-xl-16 {\n   padding-right: 25rem !important; }\n .pb-xl-16,\n .py-xl-16 {\n   padding-bottom: 25rem !important; }\n .pl-xl-16,\n .px-xl-16 {\n   padding-left: 25rem !important; }\n .m-xl-n1 {\n   margin: -0.25rem !important; }\n .mt-xl-n1,\n .my-xl-n1 {\n   margin-top: -0.25rem !important; }\n .mr-xl-n1,\n .mx-xl-n1 {\n   margin-right: -0.25rem !important; }\n .mb-xl-n1,\n .my-xl-n1 {\n   margin-bottom: -0.25rem !important; }\n .ml-xl-n1,\n .mx-xl-n1 {\n   margin-left: -0.25rem !important; }\n .m-xl-n2 {\n   margin: -0.5rem !important; }\n .mt-xl-n2,\n .my-xl-n2 {\n   margin-top: -0.5rem !important; }\n .mr-xl-n2,\n .mx-xl-n2 {\n   margin-right: -0.5rem !important; }\n .mb-xl-n2,\n .my-xl-n2 {\n   margin-bottom: -0.5rem !important; }\n .ml-xl-n2,\n .mx-xl-n2 {\n   margin-left: -0.5rem !important; }\n .m-xl-n3 {\n   margin: -0.75rem !important; }\n .mt-xl-n3,\n .my-xl-n3 {\n   margin-top: -0.75rem !important; }\n .mr-xl-n3,\n .mx-xl-n3 {\n   margin-right: -0.75rem !important; }\n .mb-xl-n3,\n .my-xl-n3 {\n   margin-bottom: -0.75rem !important; }\n .ml-xl-n3,\n .mx-xl-n3 {\n   margin-left: -0.75rem !important; }\n .m-xl-n4 {\n   margin: -1rem !important; }\n .mt-xl-n4,\n .my-xl-n4 {\n   margin-top: -1rem !important; }\n .mr-xl-n4,\n .mx-xl-n4 {\n   margin-right: -1rem !important; }\n .mb-xl-n4,\n .my-xl-n4 {\n   margin-bottom: -1rem !important; }\n .ml-xl-n4,\n .mx-xl-n4 {\n   margin-left: -1rem !important; }\n .m-xl-n5 {\n   margin: -1.5rem !important; }\n .mt-xl-n5,\n .my-xl-n5 {\n   margin-top: -1.5rem !important; }\n .mr-xl-n5,\n .mx-xl-n5 {\n   margin-right: -1.5rem !important; }\n .mb-xl-n5,\n .my-xl-n5 {\n   margin-bottom: -1.5rem !important; }\n .ml-xl-n5,\n .mx-xl-n5 {\n   margin-left: -1.5rem !important; }\n .m-xl-n6 {\n   margin: -2rem !important; }\n .mt-xl-n6,\n .my-xl-n6 {\n   margin-top: -2rem !important; }\n .mr-xl-n6,\n .mx-xl-n6 {\n   margin-right: -2rem !important; }\n .mb-xl-n6,\n .my-xl-n6 {\n   margin-bottom: -2rem !important; }\n .ml-xl-n6,\n .mx-xl-n6 {\n   margin-left: -2rem !important; }\n .m-xl-n7 {\n   margin: -2.5rem !important; }\n .mt-xl-n7,\n .my-xl-n7 {\n   margin-top: -2.5rem !important; }\n .mr-xl-n7,\n .mx-xl-n7 {\n   margin-right: -2.5rem !important; }\n .mb-xl-n7,\n .my-xl-n7 {\n   margin-bottom: -2.5rem !important; }\n .ml-xl-n7,\n .mx-xl-n7 {\n   margin-left: -2.5rem !important; }\n .m-xl-n8 {\n   margin: -3rem !important; }\n .mt-xl-n8,\n .my-xl-n8 {\n   margin-top: -3rem !important; }\n .mr-xl-n8,\n .mx-xl-n8 {\n   margin-right: -3rem !important; }\n .mb-xl-n8,\n .my-xl-n8 {\n   margin-bottom: -3rem !important; }\n .ml-xl-n8,\n .mx-xl-n8 {\n   margin-left: -3rem !important; }\n .m-xl-n9 {\n   margin: -4rem !important; }\n .mt-xl-n9,\n .my-xl-n9 {\n   margin-top: -4rem !important; }\n .mr-xl-n9,\n .mx-xl-n9 {\n   margin-right: -4rem !important; }\n .mb-xl-n9,\n .my-xl-n9 {\n   margin-bottom: -4rem !important; }\n .ml-xl-n9,\n .mx-xl-n9 {\n   margin-left: -4rem !important; }\n .m-xl-n10 {\n   margin: -5rem !important; }\n .mt-xl-n10,\n .my-xl-n10 {\n   margin-top: -5rem !important; }\n .mr-xl-n10,\n .mx-xl-n10 {\n   margin-right: -5rem !important; }\n .mb-xl-n10,\n .my-xl-n10 {\n   margin-bottom: -5rem !important; }\n .ml-xl-n10,\n .mx-xl-n10 {\n   margin-left: -5rem !important; }\n .m-xl-n11 {\n   margin: -6rem !important; }\n .mt-xl-n11,\n .my-xl-n11 {\n   margin-top: -6rem !important; }\n .mr-xl-n11,\n .mx-xl-n11 {\n   margin-right: -6rem !important; }\n .mb-xl-n11,\n .my-xl-n11 {\n   margin-bottom: -6rem !important; }\n .ml-xl-n11,\n .mx-xl-n11 {\n   margin-left: -6rem !important; }\n .m-xl-n12 {\n   margin: -8rem !important; }\n .mt-xl-n12,\n .my-xl-n12 {\n   margin-top: -8rem !important; }\n .mr-xl-n12,\n .mx-xl-n12 {\n   margin-right: -8rem !important; }\n .mb-xl-n12,\n .my-xl-n12 {\n   margin-bottom: -8rem !important; }\n .ml-xl-n12,\n .mx-xl-n12 {\n   margin-left: -8rem !important; }\n .m-xl-n13 {\n   margin: -10rem !important; }\n .mt-xl-n13,\n .my-xl-n13 {\n   margin-top: -10rem !important; }\n .mr-xl-n13,\n .mx-xl-n13 {\n   margin-right: -10rem !important; }\n .mb-xl-n13,\n .my-xl-n13 {\n   margin-bottom: -10rem !important; }\n .ml-xl-n13,\n .mx-xl-n13 {\n   margin-left: -10rem !important; }\n .m-xl-n14 {\n   margin: -12rem !important; }\n .mt-xl-n14,\n .my-xl-n14 {\n   margin-top: -12rem !important; }\n .mr-xl-n14,\n .mx-xl-n14 {\n   margin-right: -12rem !important; }\n .mb-xl-n14,\n .my-xl-n14 {\n   margin-bottom: -12rem !important; }\n .ml-xl-n14,\n .mx-xl-n14 {\n   margin-left: -12rem !important; }\n .m-xl-n15 {\n   margin: -16rem !important; }\n .mt-xl-n15,\n .my-xl-n15 {\n   margin-top: -16rem !important; }\n .mr-xl-n15,\n .mx-xl-n15 {\n   margin-right: -16rem !important; }\n .mb-xl-n15,\n .my-xl-n15 {\n   margin-bottom: -16rem !important; }\n .ml-xl-n15,\n .mx-xl-n15 {\n   margin-left: -16rem !important; }\n .m-xl-n16 {\n   margin: -25rem !important; }\n .mt-xl-n16,\n .my-xl-n16 {\n   margin-top: -25rem !important; }\n .mr-xl-n16,\n .mx-xl-n16 {\n   margin-right: -25rem !important; }\n .mb-xl-n16,\n .my-xl-n16 {\n   margin-bottom: -25rem !important; }\n .ml-xl-n16,\n .mx-xl-n16 {\n   margin-left: -25rem !important; }\n .m-xl-auto {\n   margin: auto !important; }\n .mt-xl-auto,\n .my-xl-auto {\n   margin-top: auto !important; }\n .mr-xl-auto,\n .mx-xl-auto {\n   margin-right: auto !important; }\n .mb-xl-auto,\n .my-xl-auto {\n   margin-bottom: auto !important; }\n .ml-xl-auto,\n .mx-xl-auto {\n   margin-left: auto !important; } }\n.btn > img {\n max-height: 1em;\n width: auto; }\n.btn-white {\n background-color: #FFFFFF;\n color: #335EEA; }\n .btn-white:hover, .btn-white:focus {\n   background-color: #FFFFFF;\n   color: #1c4ce8; }\n\n .input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%; }\n  .input-group > .form-control,\n  .input-group > .form-control-plaintext,\n  .input-group > .custom-select,\n  .input-group > .custom-file {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    margin-bottom: 0; }\n    .input-group > .form-control + .form-control,\n    .input-group > .form-control + .custom-select,\n    .input-group > .form-control + .custom-file,\n    .input-group > .form-control-plaintext + .form-control,\n    .input-group > .form-control-plaintext + .custom-select,\n    .input-group > .form-control-plaintext + .custom-file,\n    .input-group > .custom-select + .form-control,\n    .input-group > .custom-select + .custom-select,\n    .input-group > .custom-select + .custom-file,\n    .input-group > .custom-file + .form-control,\n    .input-group > .custom-file + .custom-select,\n    .input-group > .custom-file + .custom-file {\n      margin-left: -1px; }\n  .input-group > .form-control:focus,\n  .input-group > .custom-select:focus,\n  .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3; }\n  .input-group > .custom-file .custom-file-input:focus {\n    z-index: 4; }\n  .input-group > .form-control:not(:last-child),\n  .input-group > .custom-select:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .input-group > .form-control:not(:first-child),\n  .input-group > .custom-select:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .input-group > .custom-file {\n    display: flex;\n    align-items: center; }\n    .input-group > .custom-file:not(:last-child) .custom-file-label,\n    .input-group > .custom-file:not(:last-child) .custom-file-label::after {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0; }\n    .input-group > .custom-file:not(:first-child) .custom-file-label {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0; }\n\n.input-group-prepend,\n.input-group-append {\n  display: flex; }\n  .input-group-prepend .btn,\n  .input-group-append .btn {\n    position: relative;\n    z-index: 2; }\n    .input-group-prepend .btn:focus,\n    .input-group-append .btn:focus {\n      z-index: 3; }\n  .input-group-prepend .btn + .btn,\n  .input-group-prepend .btn + .input-group-text,\n  .input-group-prepend .input-group-text + .input-group-text,\n  .input-group-prepend .input-group-text + .btn,\n  .input-group-append .btn + .btn,\n  .input-group-append .btn + .input-group-text,\n  .input-group-append .input-group-text + .input-group-text,\n  .input-group-append .input-group-text + .btn {\n    margin-left: -1px; }\n\n.input-group-prepend {\n  margin-right: -1px; }\n\n.input-group-append {\n  margin-left: -1px; }\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.8125rem 1.25rem;\n  margin-bottom: 0;\n  font-size: 1.0625rem;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #869AB8;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #FFFFFF;\n  border: 1px solid #F1F4F8;\n  border-radius: 0.375rem; }\n  .input-group-text input[type=\"radio\"],\n  .input-group-text input[type=\"checkbox\"] {\n    margin-top: 0; }\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: calc(1.3em + 2.244rem + 2px); }\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 1.122rem 1.5rem;\n  font-size: 1.0625rem;\n  line-height: 1.3;\n  border-radius: 0.375rem; }\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: calc(1.3em + 1.125rem + 2px); }\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.5625rem 1rem;\n  font-size: 1.0625rem;\n  line-height: 1.3;\n  border-radius: 0.375rem; }\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 2.25rem; }\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n  .badge {\n    display: inline-block;\n    padding: 0.25rem 0.75rem;\n    font-size: 75%;\n    font-weight: 600;\n    line-height: 1;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: 0.375rem;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n    @media (prefers-reduced-motion: reduce) {\n      .badge {\n        transition: none; } }\n    a.badge:hover, a.badge:focus {\n      text-decoration: none; }\n    .badge:empty {\n      display: none; }\n  \n  .btn .badge {\n    position: relative;\n    top: -1px; }\n  \n  .badge-pill {\n    padding-right: 0.75rem;\n    padding-left: 0.75rem;\n    border-radius: 10rem; }\n  \n  .badge-primary {\n    color: #FFFFFF;\n    background-color: #335EEA; }\n    a.badge-primary:hover, a.badge-primary:focus {\n      color: #FFFFFF;\n      background-color: #1643d4; }\n    a.badge-primary:focus, a.badge-primary.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(51, 94, 234, 0.5); }\n  \n  .badge-secondary {\n    color: #FFFFFF;\n    background-color: #506690; }\n    a.badge-secondary:hover, a.badge-secondary:focus {\n      color: #FFFFFF;\n      background-color: #3e4f6f; }\n    a.badge-secondary:focus, a.badge-secondary.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(80, 102, 144, 0.5); }\n  \n  .badge-success {\n    color: #FFFFFF;\n    background-color: #42BA96; }\n    a.badge-success:hover, a.badge-success:focus {\n      color: #FFFFFF;\n      background-color: #359478; }\n    a.badge-success:focus, a.badge-success.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(66, 186, 150, 0.5); }\n  \n  .badge-info {\n    color: #FFFFFF;\n    background-color: #7C69EF; }\n    a.badge-info:hover, a.badge-info:focus {\n      color: #FFFFFF;\n      background-color: #543bea; }\n    a.badge-info:focus, a.badge-info.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(124, 105, 239, 0.5); }\n  \n  .badge-warning {\n    color: #2B354F;\n    background-color: #FAD776; }\n    a.badge-warning:hover, a.badge-warning:focus {\n      color: #2B354F;\n      background-color: #f8c945; }\n    a.badge-warning:focus, a.badge-warning.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(250, 215, 118, 0.5); }\n  \n  .badge-danger {\n    color: #FFFFFF;\n    background-color: #DF4759; }\n    a.badge-danger:hover, a.badge-danger:focus {\n      color: #FFFFFF;\n      background-color: #cf2438; }\n    a.badge-danger:focus, a.badge-danger.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(223, 71, 89, 0.5); }\n  \n  .badge-light {\n    color: #2B354F;\n    background-color: #F9FBFD; }\n    a.badge-light:hover, a.badge-light:focus {\n      color: #2B354F;\n      background-color: #d3e2f0; }\n    a.badge-light:focus, a.badge-light.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(249, 251, 253, 0.5); }\n  \n  .badge-dark {\n    color: #FFFFFF;\n    background-color: #2B354F; }\n    a.badge-dark:hover, a.badge-dark:focus {\n      color: #FFFFFF;\n      background-color: #191f2e; }\n    a.badge-dark:focus, a.badge-dark.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(43, 53, 79, 0.5); }\n  \n  .badge-primary-desat {\n    color: #FFFFFF;\n    background-color: #6C8AEC; }\n    a.badge-primary-desat:hover, a.badge-primary-desat:focus {\n      color: #FFFFFF;\n      background-color: #3f66e6; }\n    a.badge-primary-desat:focus, a.badge-primary-desat.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(108, 138, 236, 0.5); }\n  \n  .badge-black {\n    color: #FFFFFF;\n    background-color: #161C2D; }\n    a.badge-black:hover, a.badge-black:focus {\n      color: #FFFFFF;\n      background-color: #05070b; }\n    a.badge-black:focus, a.badge-black.focus {\n      outline: 0;\n      box-shadow: 0 0 0 0 rgba(22, 28, 45, 0.5); }\n\n  .badge-primary-soft {\n    background-color: rgba(51, 94, 234, 0.1);\n    color: #335EEA; }\n    a.badge-primary-soft:hover, a.badge-primary-soft:focus {\n      background-color: rgba(51, 94, 234, 0.2);\n      color: #335EEA; }\n  \n  .badge-secondary-soft {\n    background-color: rgba(80, 102, 144, 0.1);\n    color: #506690; }\n    a.badge-secondary-soft:hover, a.badge-secondary-soft:focus {\n      background-color: rgba(80, 102, 144, 0.2);\n      color: #506690; }\n  \n  .badge-success-soft {\n    background-color: rgba(66, 186, 150, 0.1);\n    color: #42BA96; }\n    a.badge-success-soft:hover, a.badge-success-soft:focus {\n      background-color: rgba(66, 186, 150, 0.2);\n      color: #42BA96; }\n  \n  .badge-info-soft {\n    background-color: rgba(124, 105, 239, 0.1);\n    color: #7C69EF; }\n    a.badge-info-soft:hover, a.badge-info-soft:focus {\n      background-color: rgba(124, 105, 239, 0.2);\n      color: #7C69EF; }\n  \n  .badge-warning-soft {\n    background-color: rgba(250, 215, 118, 0.1);\n    color: #FAD776; }\n    a.badge-warning-soft:hover, a.badge-warning-soft:focus {\n      background-color: rgba(250, 215, 118, 0.2);\n      color: #FAD776; }\n  \n  .badge-danger-soft {\n    background-color: rgba(223, 71, 89, 0.1);\n    color: #DF4759; }\n    a.badge-danger-soft:hover, a.badge-danger-soft:focus {\n      background-color: rgba(223, 71, 89, 0.2);\n      color: #DF4759; }\n  \n  .badge-light-soft {\n    background-color: rgba(249, 251, 253, 0.1);\n    color: #F9FBFD; }\n    a.badge-light-soft:hover, a.badge-light-soft:focus {\n      background-color: rgba(249, 251, 253, 0.2);\n      color: #F9FBFD; }\n  \n  .badge-dark-soft {\n    background-color: rgba(43, 53, 79, 0.1);\n    color: #2B354F; }\n    a.badge-dark-soft:hover, a.badge-dark-soft:focus {\n      background-color: rgba(43, 53, 79, 0.2);\n      color: #2B354F; }\n  \n  .badge-primary-desat-soft {\n    background-color: rgba(108, 138, 236, 0.1);\n    color: #6C8AEC; }\n    a.badge-primary-desat-soft:hover, a.badge-primary-desat-soft:focus {\n      background-color: rgba(108, 138, 236, 0.2);\n      color: #6C8AEC; }\n  \n  .badge-black-soft {\n    background-color: rgba(22, 28, 45, 0.1);\n    color: #161C2D; }\n    a.badge-black-soft:hover, a.badge-black-soft:focus {\n      background-color: rgba(22, 28, 45, 0.2);\n      color: #161C2D; }\n  \n  .badge-gray-700-soft {\n    background-color: rgba(80, 102, 144, 0.1);\n    color: #506690; }\n    a.badge-gray-700-soft:hover, a.badge-gray-700-soft:focus {\n      background-color: rgba(80, 102, 144, 0.2);\n      color: #506690; }\n  \n  .badge-gray-600 {\n    background-color: #869AB8;\n    color: #FFFFFF; }\n  \n  .badge-lg {\n    padding: 0.7em 1.15em; }\n  \n  .badge-rounded-circle {\n    height: calc(1em + 0.5rem);\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n    border-radius: 10rem; }\n    .badge-rounded-circle > * {\n      display: block;\n      width: 1em; }\n    .badge-rounded-circle.badge-lg {\n      height: calc(1em + 1.4em);\n      padding-left: 0.7em;\n      padding-right: 0.7em; }\n  \n  .badge-float {\n    position: absolute;\n    z-index: 1000; }\n  \n  .badge-float-outside {\n    top: -.5rem;\n    right: -.5rem; }\n  \n  .badge-float-inside {\n        top: 1rem;\n        right: 1rem; }\n      \n\n.jarallax {\n  position: relative;\n  background: no-repeat center center / cover;\n  z-index: 0;\n}\n.jarallax > .jarallax-img {\n    position: absolute;\n    object-fit: cover;\n    /* support for plugin https://github.com/bfred-it/object-fit-images */\n    font-family: 'object-fit: cover;';\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n}\n\n.btn-gray-400 {\n  background-color: #C6D3E6;\n  color: #FFFFFF; }\n  .btn-gray-400:hover, .btn-gray-400:focus {\n    background-color: #b4c5de;\n    color: #f2f2f2; }\n\n.overflow-auto {\n  overflow: auto !important; }\n\n.overflow-hidden {\n  overflow: hidden !important; }\n\n.position-static {\n  position: static !important; }\n\n.position-relative {\n  position: relative !important; }\n\n.position-absolute {\n  position: absolute !important; }\n\n.position-fixed {\n  position: fixed !important; }\n\n.position-sticky {\n  position: -webkit-sticky !important;\n  position: sticky !important; }\n\n.center {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n\n.top-0 {\n  top: 0 !important; }\n\n.right-0 {\n  right: 0 !important; }\n\n.bottom-0 {\n  bottom: 0 !important; }\n\n.left-0 {\n  left: 0 !important; }\n\n.btn-pill {\n  border-radius: 50rem; }\n\n.screenshot {\n  border-radius: 0.625rem;\n  box-shadow: 25px 60px 125px -25px rgba(80, 102, 144, 0.1), 16px 40px 75px -40px rgba(0, 0, 0, 0.2); }\n  \n  .img-fluid {\n    max-width: 100%;\n    height: auto; }\n  \n  .img-thumbnail {\n    padding: 0.25rem;\n    background-color: #FFFFFF;\n    border: 1px solid #D9E2EF;\n    border-radius: 0.375rem;\n    box-shadow: 0 1px 2px rgba(22, 28, 45, 0.075);\n    max-width: 100%;\n    height: auto; }\n  \n  .figure {\n    display: inline-block; }\n  \n  .figure-img {\n    margin-bottom: 0.5rem;\n    line-height: 1; }\n  \n  .figure-caption {\n    font-size: 88.2%;\n    color: #869AB8; }\n  \n  code {\n    font-size: 0.8125rem;\n    color: #e83e8c;\n    word-break: break-word; }\n    a > code {\n      color: inherit; }\n  \n  kbd {\n    padding: 0.2rem 0.4rem;\n    font-size: 0.8125rem;\n    color: #FFFFFF;\n    background-color: #2B354F;\n    border-radius: 0.2rem;\n    box-shadow: inset 0 -0.1rem 0 rgba(22, 28, 45, 0.25); }\n    kbd kbd {\n      padding: 0;\n      font-size: 100%;\n      font-weight: 600;\n      box-shadow: none; }\n  \n  pre {\n    display: block;\n    font-size: 0.8125rem;\n    color: #2B354F; }\n    pre code {\n      font-size: inherit;\n      color: inherit;\n      word-break: normal; }\n  \n  .pre-scrollable {\n    max-height: 340px;\n    overflow-y: scroll; }\n  \n  .container {\n    width: 100%;\n    padding-right: 20px;\n    padding-left: 20px;\n    margin-right: auto;\n    margin-left: auto; }\n    @media (min-width: 576px) {\n      .container {\n        max-width: 540px; } }\n    @media (min-width: 768px) {\n      .container {\n        max-width: 720px; } }\n    @media (min-width: 992px) {\n      .container {\n        max-width: 960px; } }\n    @media (min-width: 1200px) {\n      .container {\n        max-width: 1040px; } }\n  \n.container-fluid {\n  @media (max-width: 768px) {\n    padding-right:0px;\n    padding-left:0px;\n  }\n  width: 100%;\n  padding-right: 20px;\n  padding-left: 20px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n#app {\n  margin: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.container-fluid-v2 {\n  @media (max-width: 768px) {\n    padding-right:0px;\n    padding-left:0px;\n  }\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.avatar {\n  position: relative;\n  display: inline-block;\n  width: 1.875rem;\n  height: 1.875rem;\n  font-size: 0.625rem; }\n  \n.avatar:after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0; }\n  \n.avatar-img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover; }\n\n .card-meta {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 0 2rem 1.5rem; }\n\n.card-meta-divider {\n  width: 100%;\n  margin: 0 0 1.5rem; }\n\n.search-bar {\n  border-radius: 10rem;\n  background: #fff;\n  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);\n}\n\n.search-bar .form-group {\n  position: relative;\n  margin-bottom: 0;\n}\n\n.search-bar .form-group::after {\n  display: block;\n  width: 1px;\n  height: 60%;\n  content: '';\n  background: #ddd;\n  position: absolute;\n  top: 20%;\n  right: 0;\n} \n\n.search-bar .form-group.no-divider::after, .search-bar .form-group:last-of-type::after {\n  display: none;\n}\n\n.search-bar .form-control {\n  height: calc(1.5em + 1rem + 2px);\n}\n\n.search-bar .input-label-absolute-right .label-absolute {\n  right: 0;\n}\n\n@media (max-width: 991.98px) {\n  .search-bar {\n    border-radius: 20px;\n  }\n  .search-bar .form-group {\n    margin-bottom: 1rem;\n  }\n  .search-bar .form-group::after {\n    display: block;\n    width: calc(100% - 4rem);\n    height: 1px;\n    content: '';\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    background: #dee2e6;\n    position: absolute;\n    top: auto;\n    right: auto;\n    bottom: 0;\n    left: 50%;\n  }\n  .search-bar .form-control {\n    height: calc(1.6em + 0.75rem + 2px);\n    padding: 10px 20px;\n  }\n  .search-bar .input-label-absolute-right .label-absolute {\n    right: 1rem;\n  }\n  .search-bar .bootstrap-select {\n    display: block !important;\n    width: 100% !important;\n    padding: 0;\n  }\n  .search-bar .bootstrap-select button {\n    display: block;\n    width: 100% !important;\n    padding: 10px 20px;\n  }\n}\n\n.z-index-20 {\n  z-index: 20;\n}\n\n.d-flex {\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n\n.flex-wrap-initial {\n  flex-wrap: initial;\n}\n\n.input-label-absolute {\n  position: relative;\n}\n\n.label-absolute {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  color: #868e96;\n}\n\n.input-label-absolute-left .label-absolute {\n  left: .7rem;\n}\n\n.input-label-absolute-left .form-control {\n  padding-left: 2rem;\n}\n\n.input-label-absolute-right .label-absolute {\n  right: .7rem;\n}\n\n.input-label-absolute-right .form-control {\n  padding-right: 2rem;\n}\n\n.input-expand {\n  position: relative;\n  z-index: 50;\n}\n\n.input-expand .form-control {\n  width: 100%;\n  max-width: 15rem;\n  transition: all .5s !important;\n}\n\n.input-expand.focus .form-control {\n  width: 15rem !important;\n}\n\n.input-reset.focus .form-control {\n  padding-right: 2rem;\n}\n\n.input-reset.focus .btn-reset {\n  display: block;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.align-items-center {\n  -ms-flex-align: center !important;\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  -ms-flex-align: baseline !important;\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  -ms-flex-align: stretch !important;\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  -ms-flex-line-pack: start !important;\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  -ms-flex-line-pack: end !important;\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  -ms-flex-line-pack: center !important;\n  align-content: center !important;\n}\n\n.align-content-between {\n  -ms-flex-line-pack: justify !important;\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  -ms-flex-line-pack: distribute !important;\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  -ms-flex-line-pack: stretch !important;\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  -ms-flex-item-align: auto !important;\n  align-self: auto !important;\n}\n\n.align-self-start {\n  -ms-flex-item-align: start !important;\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  -ms-flex-item-align: end !important;\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  -ms-flex-item-align: center !important;\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  -ms-flex-item-align: baseline !important;\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  -ms-flex-item-align: stretch !important;\n  align-self: stretch !important;\n}\n\nselect.selectpicker {\n  height: calc(1.6em + 0.75rem + 2px) !important;\n}\n\n.btn.btn-form-control {\n  color: #ced4da;\n  border-color: #ced4da;\n  color: #495057;\n  border: none;\n  font-size: 1rem;\n  text-transform: none;\n  font-weight: normal;\n  letter-spacing: normal;\n}\n\n.btn.btn-form-control:hover {\n  color: #212529;\n  background-color: #ced4da;\n  border-color: #ced4da;\n}\n\n.btn.btn-form-control:focus, .btn.btn-form-control.focus {\n  box-shadow: 0 0 0 0.2rem rgba(206, 212, 218, 0.5);\n}\n\n.small {\n  font-size: 80%;\n}\n\n.item-center {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.vh-100 {\n  height: 100vh !important; }\n\n.align-baseline {\n  vertical-align: baseline !important; }\n\n.align-top {\n  vertical-align: top !important; }\n\n.align-middle {\n  vertical-align: middle !important; }\n\n.align-bottom {\n  vertical-align: bottom !important; }\n\n.align-text-bottom {\n  vertical-align: text-bottom !important; }\n\n.align-text-top {\n  vertical-align: text-top !important; }\n\n.display-inline-block {\n  display: inline-block\n}\n\n.navbar-brand-img {\n  max-height: 2.4rem;\n  width: auto; }\n\n  .font-size-sm {\n    font-size: 1.06rem;\n  }\n\n.display-block {\n  display: block;\n}\n\n.flex-principal-search { \n  @media (min-width: 992px) {\n    .container {\n      flex: 0 0 20% !important;\n      max-width: 20% !important; } \n    }\n}\n\n.toggle-container {\n  min-width: 40px; /* Ajustar el ancho para acomodar el botón incluso en su posición más a la derecha */\n  max-width: 40px;\n  height: 20px;\n  overflow: hidden;\n  position: relative;\n  border-radius: 15px;\n  background-color: #ccc;\n}\n\n.toggle-button {\n  width: 20px;\n  height: 20px;\n  background-color: #f44336; /* Color de fondo cuando está activo */\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: left 0.3s ease;\n}\n\n.toggle-button.active {\n  background-color: #4CAF50; /* Color de fondo cuando está desactivado */\n  left: calc(100% - 20px); /* Asegurar que el botón no se salga del contenedor */\n}\n\n#seccionCabecera p {\n  text-align: center;\n  padding-left: 0;\n}\n\n@media (min-width: 992px) {\n  #seccionCabecera p {\n    text-align: left;\n    padding-left: 1.5rem; /* equivalente a Bootstrap's ps-lg-4 */\n  }\n}\n\n\n.trashbin-tabla td,\n.user-tabla td {\n  white-space: normal !important;\n  word-wrap: break-word;\n  word-break: break-word;\n  margin-bottom: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
